var _g, _rect, _g2, _g3, _path, _path2, _path3, _path4, _path5, _g4, _path6, _g5, _rect2, _g6, _path7, _g7, _path8, _g8, _circle, _g9, _polygon, _g10, _polygon2, _g11, _path9, _g12, _rect3, _g13, _rect4, _g14, _path10, _g15, _polygon3, _path11, _polygon4, _path12, _path13, _path14, _polygon5, _path15, _path16, _path17, _rect5, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect6, _g16, _rect7, _g17, _path25, _g18, _g19, _g20, _g21, _g22, _path26, _path27, _g23, _g24, _path28, _g25, _path29, _g26, _path30, _path31, _g27, _g28, _path32, _g29, _path33, _path34, _path35, _path36, _g30, _g31, _path37, _path38, _path39, _path40, _path41, _g32, _g33, _g34, _path42, _g35, _path43, _path44, _path45, _path46, _g36, _g37, _path47, _g38, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g39, _path56, _g40, _g41, _g42, _path57, _path58, _path59, _path60, _g43, _g44, _g45, _path61, _g46, _g47, _path62, _path63, _path64, _path65, _g48, _g49, _path66, _g50, _g51, _path67, _path68, _path69, _path70, _g52, _g53, _path71, _g54, _g55, _path72, _path73, _path74, _path75, _g56, _g57, _path76, _g58, _g59, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _g60, _g61, _path85, _g62, _g63, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _g64, _g65, _path94, _g66, _g67, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _g68, _g69, _path103, _path104, _g70, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _g71, _g72, _path113, _g73, _g74, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _g75, _g76, _path122, _g77, _g78, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _polygon6, _g79, _path139, _g80, _path140, _g81, _circle2, _path141;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMachine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Glow"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 256,
    cy: 301.9375,
    r: 60,
    gradientTransform: "matrix(4.2667 0 0 4.2667 -836.2667 -1032.2667)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#SVGID_1_)",
    width: 512,
    height: 512
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Melco"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.38,413.44c-1.57-1.57-3.66-2.44-5.89-2.44h-12.98c-2.22,0-4.31,0.87-5.89,2.44l-9.18,9.18 c-1.57,1.57-2.44,3.66-2.44,5.89v22.17c0,4.59,3.74,8.33,8.33,8.33H116v12h23v-12h3.67c4.59,0,8.33-3.74,8.33-8.33v-22.17 c0-2.22-0.87-4.32-2.44-5.89L139.38,413.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.38,413.44c-1.57-1.57-3.66-2.44-5.89-2.44h-12.98c-2.22,0-4.31,0.87-5.89,2.44l-9.18,9.18 c-1.57,1.57-2.44,3.66-2.44,5.89v22.17c0,4.59,3.74,8.33,8.33,8.33H373v12h23v-12h4.67c4.59,0,8.33-3.74,8.33-8.33v-22.17 c0-2.22-0.87-4.31-2.44-5.89L397.38,413.44z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 425,
    width: 202,
    height: 34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.51,407H382v-58c0-9.64-9.37-20.4-25.06-28.77c-16.64-8.88-37.61-13.92-59.06-14.2l-3.56-0.05l1.7,2.86 c-1.1-1.71-3.02-2.84-5.2-2.84h-21.93l1.65,2.8c-1.08-1.68-2.97-2.8-5.11-2.8h-18.83c-2.16,0-4.06,1.14-5.14,2.84l1.67-2.84 h-21.93c-2.18,0-4.09,1.13-5.19,2.84l1.69-2.86l-3.57,0.05c-21.45,0.28-42.43,5.33-59.06,14.2C139.37,328.6,130,339.36,130,349v58 h3.49c3.29,0,6.39,1.28,8.72,3.61l9.18,9.18c0.12,0.12,0.22,0.24,0.33,0.36l0.75,0.85h207.06l0.75-0.85 c0.11-0.12,0.21-0.25,0.33-0.36l9.18-9.18C372.12,408.28,375.22,407,378.51,407z M255.4,325.97c-0.17-0.02-0.34-0.04-0.5-0.08 C255.06,325.92,255.23,325.95,255.4,325.97z M254.79,325.88c-0.32-0.07-0.63-0.16-0.93-0.28 C254.16,325.72,254.47,325.81,254.79,325.88z M253.75,325.56c-0.28-0.11-0.55-0.25-0.81-0.41 C253.2,325.31,253.47,325.44,253.75,325.56z M252.02,324.47c-0.49-0.43-0.9-0.94-1.23-1.51 C251.11,323.53,251.53,324.04,252.02,324.47z M252.82,325.08c-0.26-0.16-0.5-0.34-0.73-0.54 C252.31,324.73,252.56,324.91,252.82,325.08z M250.79,317.04c0.32-0.57,0.74-1.08,1.23-1.51 C251.53,315.96,251.11,316.47,250.79,317.04z M252.08,315.46c0.23-0.2,0.47-0.38,0.73-0.54 C252.56,315.09,252.31,315.27,252.08,315.46z M252.94,314.85c0.26-0.15,0.53-0.29,0.81-0.41 C253.47,314.56,253.2,314.69,252.94,314.85z M250.09,320.97c-0.05-0.32-0.09-0.64-0.09-0.97s0.03-0.65,0.09-0.97 c-0.05,0.32-0.09,0.64-0.09,0.97S250.03,320.65,250.09,320.97z M250.1,318.91c0.06-0.31,0.14-0.61,0.24-0.9 C250.24,318.3,250.16,318.6,250.1,318.91z M250.38,317.92c0.11-0.3,0.25-0.59,0.4-0.87C250.62,317.33,250.49,317.62,250.38,317.92 z M250.78,322.95c-0.16-0.28-0.29-0.57-0.4-0.87C250.49,322.38,250.62,322.67,250.78,322.95z M250.35,321.99 c-0.1-0.29-0.19-0.59-0.24-0.9C250.16,321.4,250.24,321.7,250.35,321.99z M254.81,314.12c0.39-0.08,0.78-0.12,1.19-0.12 C255.6,314,255.2,314.04,254.81,314.12z M253.87,314.4c0.3-0.11,0.61-0.21,0.93-0.28C254.47,314.19,254.16,314.28,253.87,314.4z  M296.79,310.6c0-0.02-0.01-0.04-0.01-0.06C296.78,310.56,296.78,310.58,296.79,310.6z M296.95,311.43 c-0.01-0.05-0.02-0.1-0.02-0.15C296.93,311.33,296.94,311.38,296.95,311.43z M271.29,310.54c-0.01-0.02-0.01-0.04-0.02-0.07 C271.28,310.5,271.29,310.52,271.29,310.54z M271.45,311.34c-0.01-0.05-0.02-0.1-0.02-0.15 C271.43,311.24,271.44,311.29,271.45,311.34z M240.72,310.48c-0.01,0.02-0.01,0.04-0.02,0.06 C240.71,310.52,240.72,310.5,240.72,310.48z M240.57,311.19c-0.01,0.05-0.02,0.1-0.02,0.15 C240.56,311.29,240.57,311.24,240.57,311.19z M217.26,341.44c1.02,0.88,2,1.98,2.93,3.24 C219.26,343.41,218.28,342.31,217.26,341.44c-0.9-0.77-1.56-1.74-1.92-2.8C215.7,339.7,216.36,340.67,217.26,341.44z  M220.42,344.99c-0.01-0.01-0.02-0.02-0.02-0.04C220.4,344.96,220.41,344.98,220.42,344.99z M215.23,310.54 c-0.01,0.02-0.01,0.04-0.02,0.06C215.22,310.58,215.22,310.56,215.23,310.54z M215.07,311.28c-0.01,0.05-0.02,0.1-0.02,0.15 C215.06,311.38,215.07,311.33,215.07,311.28z M215.15,337.99c-0.1-0.44-0.15-0.88-0.15-1.34 C215,337.11,215.05,337.56,215.15,337.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,274c-7.72,0-14,6.28-14,14s6.28,14,14,14h206c7.72,0,14-6.28,14-14s-6.28-14-14-14h36.33l-5.11-3.63 c-0.88-0.62-1.61-1.22-2.22-1.81l-0.58-0.56h-12.14c-3.84,0-7.34-1.52-9.86-4.29c-1.98-2.17-3.15-4.89-3.38-7.87L361.9,254H362 l5.93-64.39L315,174.49V151c0-3.31-2.69-6-6-6H198c-2.61,0-4.83,1.67-5.66,4h-6.26c-5.56,0-10.08,4.52-10.08,10.08v21.41 l-34.06,9.73L125,207.44V254h-19h-2c-5.7,0-10,7.74-10,18v2h12H153z M303,282h-99v-6h99V282z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5,145c4.06,0,8.12-0.28,12.04-0.85c21.83-1.47,39.77-2.15,56.46-2.15s34.63,0.69,56.46,2.15 c3.92,0.56,7.97,0.85,12.04,0.85c27.65,0,48.5-11.39,48.5-26.5v-8h-0.51c0.33-1.3,0.51-2.63,0.51-4c0-1.81-0.32-3.62-0.94-5.4 l-1.33-3.79l-1.87,2.82c0.73-1.29,1.14-2.67,1.14-4.13c0-2.73-1.41-5.34-4-7.44V57c0-3.06-3.55-7.1-8-9.3V47c0-2.39-2.81-4-7-4 c-1.87,0-3.46,0.32-4.66,0.89l0.66-0.37V41c0-3.06-3.55-7.1-8-9.3V31c0-2.39-2.81-4-7-4s-7,1.61-7,4v0.7c-4.45,2.2-8,6.24-8,9.3 c0,0.2,0.02,0.41,0.06,0.64C315.95,41.23,314.57,41,313,41c-1.87,0-3.46,0.32-4.66,0.89l0.66-0.37V39c0-3.06-3.55-7.1-8-9.3V29 c0-2.39-2.81-4-7-4s-7,1.61-7,4v0.7c-4.45,2.2-8,6.24-8,9.3c0,0.2,0.02,0.41,0.06,0.64C277.95,39.23,276.57,39,275,39 c-1.87,0-3.46,0.32-4.66,0.89l0.66-0.37V37c0-3.06-3.55-7.1-8-9.3V27c0-2.39-2.81-4-7-4c-4.19,0-7,1.61-7,4v0.7 c-4.45,2.2-8,6.24-8,9.3v2.52l0.67,0.38c-1.2-0.57-2.79-0.9-4.67-0.9c-1.94,0-3.58,0.35-4.79,0.96l0.99-0.57l-0.35-1.45 c-0.6-2.53-3.51-6.1-7.86-8.24V29c0-2.39-2.81-4-7-4s-7,1.61-7,4v0.7c-4.45,2.2-8,6.24-8,9.3v2.52l0.67,0.38 c-1.2-0.57-2.79-0.9-4.67-0.9c-1.94,0-3.58,0.35-4.79,0.96l0.99-0.57l-0.35-1.45c-0.6-2.53-3.51-6.1-7.86-8.24V31 c0-2.39-2.81-4-7-4s-7,1.61-7,4v0.7c-4.45,2.2-8,6.24-8,9.3v2.52l0.67,0.38c-1.2-0.57-2.79-0.9-4.67-0.9c-4.19,0-7,1.61-7,4v0.7 c-4.45,2.2-8,6.24-8,9.3v31.56c-2.59,2.09-4,4.7-4,7.44c0,1.46,0.41,2.85,1.14,4.13l-1.87-2.82l-1.33,3.79 c-0.62,1.77-0.94,3.59-0.94,5.4c0,1.37,0.18,2.7,0.51,4H139v8C139,133.61,159.85,145,187.5,145z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.02,132.4l-4.32-1.28l1.95,4.06c0,0,0,0,0,0.01c-0.38-0.79-0.87-1.54-1.48-2.2c-1.75-1.92-4.21-2.98-6.91-2.98h-72 c-5.42,0-10.23,4.4-10.73,9.82l-10.51,114c-0.25,2.71,0.58,5.27,2.35,7.2c1.75,1.92,4.21,2.98,6.91,2.98h11.64 c1.38,0,2.71,0.56,3.75,1.58c2.9,2.85,6.83,4.42,11.06,4.42c2.55,0,5.09-0.58,7.45-1.67l-8.35,4.05l9.64-0.42 c3.91-0.17,7.78-1.69,10.93-4.3l4.63-3.66h21.24c4.34,0,8.29-2.84,9.95-6.75c-0.85,2.05-2.31,3.84-4.23,5.06l-5.78,3.69h8.06 c5.42,0,10.23-4.4,10.73-9.82l10.51-114C476.94,137.68,474.26,133.65,470.02,132.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 469,
    width: 19,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 469,
    width: 19,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S254,190.67,254,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S260,190.67,260,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S278,190.67,278,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S266,190.67,266,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S272,190.67,272,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S302,190.67,302,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S296,190.67,296,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S290,190.67,290,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S284,190.67,284,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S230,190.67,230,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S212,190.67,212,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S248,190.67,248,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S218,190.67,218,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,270v8c0,2.21,1.79,4,4,4v-4h4v4h103v-4h4v4c2.21,0,4-1.79,4-4v-8c0,2.21-1.79,4-4,4H198 C195.79,274,194,272.21,194,270z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S242,190.67,242,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S236,190.67,236,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,191.5v-8c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v8c0-0.83,0.67-1.5,1.5-1.5S224,190.67,224,191.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 457,
    width: 198,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,320.19v-8c0-1.52-0.42-2.93-1.14-4.15v7.99l0,0c0,0,0,0-0.01,0C298.58,317.25,299,318.67,299,320.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.51,413H380v-8h-1.49c-3.83,0-7.42,1.49-10.13,4.2l-9.18,9.18c-0.2,0.2-0.38,0.41-0.57,0.62H153.37 c-0.19-0.21-0.37-0.42-0.57-0.62l-9.18-9.18c-2.71-2.71-6.3-4.2-10.13-4.2H132v8h1.49c3.83,0,7.42,1.49,10.13,4.2l9.18,9.18 c0.2,0.2,0.38,0.41,0.57,0.62h205.26c0.19-0.21,0.37-0.42,0.57-0.62l9.18-9.18C371.08,414.49,374.68,413,378.51,413z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,320.19c0-1.52,0.42-2.94,1.15-4.16h0v-8h0c-0.72,1.22-1.15,2.64-1.15,4.16V320.19z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 292,
    width: 111,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.67,457h-31.35c-3.49,0-6.33-2.83-6.33-6.33v8c0,3.49,2.83,6.33,6.33,6.33H118v-4h19v4h5.67 c3.49,0,6.33-2.83,6.33-6.33v-8C149,454.17,146.17,457,142.67,457z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.67,457h-31.35c-3.49,0-6.33-2.83-6.33-6.33v8c0,3.49,2.83,6.33,6.33,6.33H375v-4h19v4h6.67 c3.49,0,6.33-2.83,6.33-6.33v-8C407,454.17,404.17,457,400.67,457z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,205c-4.9-2.45-8-7.46-8-12.94v8c0,1.72,0.3,3.39,0.87,4.94h0.42c1.41,1.43,3.06,2.64,4.92,3.58 c2.88,1.44,4.86,4.06,5.52,7.12c2.68,2.67,4.27,6.34,4.27,10.25V221v-3.06C194,212.46,190.9,207.45,186,205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,276h37v-4h-82v8h36.07C146.27,277.55,149.45,276,153,276z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355,209 355,205 355,201 351,201 324.46,201 317,201 317,205 351,205 351,209  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.17,252H355v4h5.05c0.05,0.69,0.16,1.36,0.3,2.03l2.96-32.08l2.48-26.87h0v-8l-2.48,26.87L360.17,252z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.07,272H317v4h42c3.55,0,6.73,1.55,8.93,4h21.14C389.07,277.98,389.07,274.74,389.07,272z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 252,
    width: 34,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.65,74.32c0-0.01,0.01-0.01,0.01-0.02c0.27-0.4,0.56-0.8,0.88-1.19c0.01-0.02,0.03-0.04,0.04-0.05 c0.3-0.36,0.62-0.72,0.96-1.07c0.15-0.15,0.3-0.3,0.45-0.44V71c0-1.93,2.84-5.55,7-7.56V63v-2v-4.65c-1.72,0.96-2.8,2.4-2.97,4.14 c-0.39,0.23-0.78,0.47-1.15,0.72c-0.08,0.06-0.17,0.11-0.25,0.17c-0.37,0.26-0.74,0.52-1.09,0.8c0,0-0.01,0-0.01,0.01 c-0.36,0.28-0.7,0.57-1.03,0.87c-0.05,0.04-0.1,0.09-0.15,0.13c-0.28,0.26-0.55,0.52-0.81,0.79c-0.34,0.35-0.66,0.71-0.96,1.07 c-0.01,0.02-0.03,0.04-0.04,0.05c-0.32,0.39-0.61,0.79-0.88,1.19c0,0.01-0.01,0.01-0.01,0.02c-0.54,0.82-0.97,1.66-1.25,2.48 c-0.26,0.75-0.4,1.5-0.4,2.21v4.16v0.45v2.63V79c0-0.71,0.14-1.45,0.4-2.21C277.68,75.97,278.11,75.14,278.65,74.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,53v0.52c0.09,0.09,0.19,0.18,0.28,0.27c0.05,0.05,0.09,0.09,0.14,0.14c0.18,0.18,0.35,0.37,0.51,0.55 c0.05,0.06,0.1,0.11,0.15,0.17c0.1,0.11,0.18,0.22,0.28,0.33c0.16,0.19,0.31,0.39,0.46,0.58c0.04,0.06,0.08,0.11,0.12,0.17 c0.15,0.2,0.29,0.41,0.43,0.61c0.03,0.04,0.05,0.08,0.08,0.13c0.13,0.21,0.26,0.41,0.37,0.62c0.03,0.05,0.06,0.11,0.09,0.16 c0.03,0.05,0.05,0.11,0.08,0.16c0.84-0.25,1.87-0.41,3.01-0.41c1.13,0,2.17,0.16,3.01,0.41c0.02-0.04,0.04-0.09,0.07-0.13 c0.03-0.05,0.06-0.1,0.09-0.16c0.09-0.16,0.19-0.33,0.29-0.49c0.03-0.04,0.06-0.09,0.08-0.13c0.05-0.07,0.1-0.15,0.14-0.22 c0.63-0.95,1.42-1.88,2.32-2.75V53c0-1.95,2.9-5.63,7.14-7.63v-7.02H269v0c-1.72,0.96-2.8,2.4-2.97,4.14 c-0.32,0.18-0.62,0.37-0.93,0.57c-0.09,0.06-0.18,0.12-0.26,0.18c-0.21,0.14-0.43,0.29-0.64,0.44c-0.09,0.07-0.19,0.14-0.28,0.21 c-0.2,0.15-0.4,0.31-0.6,0.46c-0.08,0.06-0.16,0.13-0.24,0.19c-0.22,0.18-0.43,0.36-0.63,0.55c-0.05,0.05-0.1,0.09-0.15,0.14 c-1.04,0.96-1.93,2-2.63,3.06c-0.05,0.07-0.1,0.15-0.14,0.22c-0.03,0.04-0.06,0.09-0.08,0.13c-0.1,0.16-0.2,0.33-0.29,0.49 c-0.03,0.05-0.06,0.1-0.09,0.16c-0.09,0.16-0.17,0.33-0.25,0.49c-0.02,0.05-0.04,0.09-0.07,0.14c-0.08,0.17-0.15,0.34-0.22,0.51 c-0.01,0.03-0.02,0.05-0.03,0.08c-0.3,0.8-0.48,1.58-0.5,2.34c0,0.05-0.01,0.11-0.01,0.16v0.12c-0.64-0.08-1.3-0.12-2-0.12 s-1.36,0.04-2,0.12V53c0-0.01,0-0.02,0-0.03c0-0.23-0.02-0.47-0.05-0.71c-0.01-0.05-0.02-0.1-0.03-0.15 c-0.03-0.19-0.06-0.38-0.11-0.58c-0.02-0.06-0.03-0.13-0.05-0.19c-0.05-0.18-0.1-0.37-0.17-0.56c-0.02-0.07-0.05-0.13-0.07-0.2 c-0.07-0.19-0.14-0.38-0.23-0.56c-0.03-0.06-0.06-0.12-0.09-0.18c-0.09-0.2-0.19-0.39-0.3-0.59c-0.03-0.05-0.06-0.11-0.09-0.16 c-0.12-0.21-0.24-0.41-0.37-0.62c-0.03-0.04-0.05-0.08-0.08-0.13c-0.13-0.2-0.28-0.41-0.43-0.61c-0.04-0.06-0.08-0.11-0.12-0.17 c-0.15-0.19-0.3-0.39-0.46-0.58c-0.09-0.11-0.18-0.22-0.28-0.33c-0.05-0.06-0.1-0.11-0.15-0.17c-0.17-0.18-0.33-0.37-0.51-0.55 c-0.04-0.05-0.09-0.09-0.14-0.14c-0.19-0.19-0.38-0.38-0.58-0.56c-0.04-0.03-0.07-0.07-0.11-0.1c-0.22-0.2-0.44-0.39-0.66-0.58 c-0.03-0.02-0.05-0.04-0.08-0.07c-0.24-0.2-0.49-0.4-0.75-0.59c-0.02-0.01-0.03-0.02-0.05-0.03c-0.27-0.2-0.54-0.4-0.82-0.58 c-0.01,0-0.01-0.01-0.02-0.01c-0.29-0.19-0.59-0.38-0.89-0.56c-0.12-0.07-0.23-0.15-0.36-0.22c-0.17-1.75-1.24-3.18-2.97-4.14V45 v0.44C247.16,47.45,250,51.07,250,53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.51,74.5c0.01-0.03,0.02-0.05,0.03-0.08c0.07-0.17,0.14-0.34,0.22-0.51c0.02-0.05,0.04-0.09,0.06-0.14 c0.08-0.16,0.16-0.33,0.25-0.49c0.03-0.05,0.06-0.1,0.09-0.16c0.09-0.16,0.19-0.33,0.29-0.49c0.03-0.04,0.06-0.09,0.08-0.13 c0.05-0.07,0.1-0.15,0.14-0.22c0.63-0.95,1.42-1.88,2.32-2.75V69c0-1.93,2.84-5.55,7-7.56V61v-6.65c-1.72,0.96-2.8,2.4-2.97,4.14 c-0.32,0.18-0.62,0.37-0.93,0.57c-0.09,0.06-0.18,0.12-0.26,0.18c-0.21,0.14-0.43,0.29-0.64,0.44c-0.09,0.07-0.18,0.14-0.28,0.21 c-0.2,0.15-0.4,0.31-0.6,0.47c-0.08,0.06-0.16,0.13-0.23,0.19c-0.22,0.18-0.43,0.36-0.63,0.55c-0.05,0.05-0.1,0.09-0.15,0.14 c-1.04,0.96-1.93,2-2.63,3.06c-0.05,0.07-0.1,0.15-0.14,0.22c-0.03,0.04-0.06,0.09-0.08,0.13c-0.1,0.16-0.2,0.33-0.29,0.49 c-0.03,0.05-0.06,0.1-0.09,0.16c-0.09,0.16-0.17,0.33-0.25,0.49c-0.02,0.05-0.04,0.09-0.06,0.14c-0.08,0.17-0.15,0.34-0.22,0.51 c-0.01,0.03-0.02,0.05-0.03,0.08c-0.3,0.8-0.48,1.58-0.5,2.34c0,0.05-0.01,0.11-0.01,0.16v4.16v0.45v2.63V77 c0-0.05,0.01-0.11,0.01-0.16C239.03,76.08,239.21,75.3,239.51,74.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.94,62.58c-0.18-0.15-0.37-0.31-0.56-0.46c-0.22-0.17-0.45-0.34-0.69-0.51c-0.15-0.11-0.29-0.21-0.44-0.31 c-0.02-0.01-0.04-0.03-0.06-0.04c-0.4-0.27-0.8-0.53-1.22-0.77c-0.02-0.2-0.05-0.4-0.1-0.59c-0.02-0.09-0.05-0.19-0.08-0.28 c-0.03-0.09-0.05-0.18-0.08-0.27c-0.04-0.11-0.09-0.23-0.14-0.34c-0.03-0.06-0.06-0.12-0.09-0.18c-0.06-0.11-0.12-0.23-0.19-0.34 c-0.51-0.85-1.29-1.58-2.3-2.14V61v2.44c4.16,2.01,7,5.63,7,7.56v0.53c0.01,0.01,0.01,0.01,0.02,0.02 c0.25,0.24,0.5,0.49,0.73,0.74c0.06,0.07,0.12,0.13,0.18,0.2c0.29,0.32,0.57,0.65,0.82,0.99c0.03,0.04,0.05,0.08,0.08,0.11 c0.24,0.32,0.46,0.64,0.66,0.96c0.03,0.05,0.07,0.11,0.1,0.16c0.21,0.34,0.39,0.68,0.55,1.01c0.03,0.07,0.06,0.13,0.09,0.2 c0.16,0.35,0.3,0.7,0.41,1.04c0.22,0.7,0.34,1.39,0.34,2.04v-6v-2c0-0.66-0.12-1.35-0.34-2.04c-0.11-0.34-0.25-0.69-0.41-1.04 c-0.03-0.07-0.06-0.13-0.09-0.2c-0.16-0.34-0.35-0.68-0.55-1.01c-0.03-0.05-0.07-0.11-0.1-0.16c-0.2-0.32-0.42-0.64-0.66-0.96 c-0.03-0.04-0.05-0.08-0.08-0.11c-0.25-0.33-0.53-0.66-0.82-0.99c-0.06-0.07-0.12-0.13-0.18-0.2c-0.23-0.25-0.48-0.5-0.73-0.74 c-0.19-0.18-0.38-0.36-0.58-0.53C230.28,62.86,230.11,62.72,229.94,62.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,55v0.52c0.09,0.09,0.19,0.18,0.28,0.27c0.05,0.05,0.09,0.09,0.14,0.14c0.18,0.18,0.35,0.37,0.51,0.55 c0.05,0.06,0.1,0.11,0.15,0.17c0.1,0.11,0.18,0.22,0.28,0.33c0.16,0.19,0.31,0.39,0.46,0.58c0.04,0.06,0.08,0.11,0.12,0.17 c0.15,0.2,0.29,0.41,0.43,0.61c0.03,0.04,0.05,0.08,0.08,0.13c0.13,0.21,0.26,0.41,0.37,0.62c0.03,0.05,0.06,0.11,0.09,0.16 c0.03,0.05,0.05,0.11,0.08,0.16c0.84-0.25,1.87-0.41,3.01-0.41c0.82,0,1.59,0.09,2.28,0.23c0.04-0.15,0.08-0.31,0.14-0.47 c0,0,0-0.01,0-0.01c0.05-0.14,0.11-0.29,0.17-0.43c0.15-0.38,0.33-0.76,0.54-1.14c0.01-0.02,0.02-0.03,0.03-0.05 c0.23-0.41,0.49-0.82,0.78-1.23c0.02-0.03,0.04-0.05,0.06-0.08c0.29-0.4,0.6-0.8,0.95-1.19c0.02-0.02,0.03-0.04,0.05-0.05 c0.32-0.36,0.66-0.72,1.02-1.06V53c0-1.91,2.8-5.5,6.91-7.51V38.4c-1.56,0.9-2.56,2.19-2.83,3.75c-0.02,0.11-0.04,0.23-0.06,0.34 c-1.45,0.83-2.78,1.83-3.93,2.92c-0.4,0.38-0.77,0.77-1.13,1.17c-0.02,0.02-0.03,0.04-0.05,0.05c-0.34,0.39-0.66,0.79-0.95,1.19 c-0.02,0.03-0.04,0.05-0.06,0.08c-0.29,0.41-0.55,0.82-0.78,1.23c-0.01,0.02-0.02,0.03-0.03,0.05c-0.21,0.38-0.38,0.76-0.54,1.14 c-0.06,0.14-0.12,0.29-0.17,0.43c0,0,0,0.01,0,0.01c-0.08,0.24-0.15,0.47-0.21,0.7c-0.01,0.02-0.01,0.05-0.02,0.07 c-0.05,0.21-0.09,0.42-0.12,0.63c-0.01,0.04-0.02,0.08-0.02,0.12C220.02,52.53,220,52.77,220,53v1.84v0.28 c-0.64-0.08-1.3-0.12-2-0.12s-1.36,0.04-2,0.12V55c0-0.01,0-0.02,0-0.03c0-0.23-0.02-0.47-0.05-0.71 c-0.01-0.05-0.02-0.1-0.03-0.15c-0.03-0.19-0.06-0.38-0.11-0.58c-0.02-0.06-0.03-0.13-0.05-0.19c-0.05-0.18-0.1-0.37-0.17-0.56 c-0.02-0.07-0.05-0.13-0.07-0.2c-0.07-0.19-0.14-0.38-0.23-0.56c-0.03-0.06-0.06-0.12-0.09-0.18c-0.09-0.2-0.19-0.39-0.3-0.59 c-0.03-0.05-0.06-0.11-0.09-0.16c-0.12-0.21-0.24-0.41-0.37-0.62c-0.03-0.04-0.05-0.08-0.08-0.13c-0.13-0.2-0.28-0.41-0.43-0.61 c-0.04-0.06-0.08-0.11-0.12-0.17c-0.15-0.19-0.3-0.39-0.46-0.58c-0.09-0.11-0.18-0.22-0.28-0.33c-0.05-0.06-0.1-0.11-0.15-0.17 c-0.17-0.18-0.33-0.37-0.51-0.55c-0.04-0.05-0.09-0.09-0.14-0.14c-0.19-0.19-0.38-0.38-0.58-0.56c-0.04-0.03-0.07-0.07-0.11-0.1 c-0.22-0.2-0.44-0.39-0.66-0.58c-0.03-0.02-0.05-0.04-0.08-0.07c-0.24-0.2-0.49-0.4-0.75-0.59c-0.02-0.01-0.03-0.02-0.05-0.03 c-0.27-0.2-0.54-0.4-0.82-0.58c-0.01,0-0.01-0.01-0.02-0.01c-0.29-0.19-0.59-0.38-0.89-0.56c-0.12-0.07-0.23-0.15-0.36-0.22 c-0.17-1.75-1.24-3.18-2.97-4.14V47v0.44C209.16,49.45,212,53.07,212,55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.94,64.58c-0.18-0.15-0.37-0.31-0.56-0.46c-0.22-0.17-0.45-0.34-0.69-0.51c-0.15-0.11-0.29-0.21-0.44-0.31 c-0.02-0.01-0.04-0.03-0.06-0.04c-0.4-0.27-0.8-0.53-1.22-0.77c-0.02-0.2-0.05-0.4-0.1-0.59c-0.02-0.09-0.05-0.19-0.08-0.28 c-0.03-0.09-0.05-0.18-0.08-0.27c-0.04-0.11-0.09-0.23-0.14-0.34c-0.03-0.06-0.06-0.12-0.09-0.18c-0.06-0.11-0.12-0.23-0.19-0.34 c-0.51-0.85-1.29-1.58-2.3-2.14V63v2.44c4.16,2.01,7,5.63,7,7.56v0.53c0.01,0.01,0.01,0.01,0.02,0.02 c0.25,0.24,0.5,0.49,0.73,0.74c0.06,0.07,0.12,0.13,0.18,0.2c0.29,0.32,0.57,0.65,0.82,0.99c0.03,0.04,0.05,0.08,0.08,0.11 c0.24,0.32,0.46,0.64,0.66,0.96c0.03,0.05,0.07,0.11,0.1,0.16c0.21,0.34,0.39,0.68,0.55,1.01c0.03,0.07,0.06,0.13,0.09,0.2 c0.16,0.35,0.3,0.7,0.41,1.04c0.22,0.7,0.34,1.39,0.34,2.04v-6v-2c0-0.66-0.12-1.35-0.34-2.04c-0.11-0.34-0.25-0.69-0.41-1.04 c-0.03-0.07-0.06-0.13-0.09-0.2c-0.16-0.34-0.35-0.68-0.55-1.01c-0.03-0.05-0.07-0.11-0.1-0.16c-0.2-0.32-0.42-0.64-0.66-0.96 c-0.03-0.04-0.05-0.08-0.08-0.11c-0.25-0.33-0.53-0.66-0.82-0.99c-0.06-0.07-0.12-0.13-0.18-0.2c-0.23-0.25-0.48-0.5-0.73-0.74 c-0.19-0.18-0.38-0.36-0.58-0.53C192.28,64.86,192.11,64.72,191.94,64.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,55v0.52c0.32,0.31,0.63,0.63,0.92,0.95c0.04,0.05,0.09,0.09,0.13,0.14c0.31,0.35,0.6,0.71,0.87,1.08 c0.04,0.06,0.09,0.12,0.13,0.17c0.26,0.37,0.5,0.74,0.72,1.11c0.03,0.05,0.05,0.09,0.08,0.14c0.18,0.33,0.34,0.66,0.48,0.98 c0.15,0.35,0.29,0.7,0.39,1.04c0.01,0.03,0.02,0.06,0.03,0.1c0.68-0.14,1.45-0.23,2.27-0.23c1.13,0,2.17,0.16,3.01,0.41 c0.02-0.04,0.04-0.09,0.07-0.13c0.03-0.05,0.06-0.1,0.09-0.16c0.09-0.16,0.19-0.33,0.29-0.49c0.03-0.04,0.06-0.09,0.08-0.13 c0.05-0.07,0.1-0.15,0.14-0.22c0.63-0.95,1.42-1.88,2.32-2.75V57c0-1.93,2.84-5.55,7-7.56V49v-6.65c-1.72,0.96-2.8,2.4-2.97,4.14 c-0.32,0.18-0.62,0.37-0.93,0.57c-0.09,0.06-0.18,0.12-0.26,0.18c-0.21,0.14-0.43,0.29-0.64,0.44c-0.09,0.07-0.19,0.14-0.28,0.21 c-0.2,0.15-0.4,0.31-0.6,0.46c-0.08,0.06-0.16,0.13-0.24,0.19c-0.22,0.18-0.43,0.36-0.63,0.55c-0.05,0.05-0.1,0.09-0.15,0.14 c-1.04,0.96-1.93,2-2.63,3.06c-0.05,0.07-0.1,0.15-0.14,0.22c-0.03,0.04-0.06,0.09-0.08,0.13c-0.1,0.16-0.2,0.33-0.29,0.49 c-0.03,0.05-0.06,0.1-0.09,0.16c-0.09,0.16-0.17,0.33-0.25,0.49c-0.02,0.05-0.04,0.09-0.07,0.14c-0.08,0.17-0.15,0.34-0.22,0.51 c-0.01,0.03-0.02,0.05-0.03,0.08c-0.3,0.8-0.48,1.58-0.5,2.34c0,0.05-0.01,0.11-0.01,0.16v0.12c-0.64-0.08-1.3-0.12-2-0.12 s-1.36,0.04-2,0.12V57v-0.03V55c0-0.27-0.03-0.54-0.06-0.82c-0.01-0.07-0.02-0.14-0.04-0.21c-0.04-0.23-0.09-0.46-0.16-0.7 c-0.01-0.05-0.03-0.1-0.04-0.15c-0.1-0.34-0.24-0.69-0.39-1.04c-0.14-0.33-0.3-0.66-0.48-0.98c-0.03-0.05-0.05-0.09-0.08-0.14 c-0.21-0.37-0.45-0.74-0.72-1.11c-0.04-0.06-0.08-0.12-0.13-0.17c-0.27-0.36-0.56-0.72-0.87-1.08c-0.04-0.05-0.08-0.09-0.13-0.14 c-0.33-0.37-0.67-0.73-1.04-1.08c-1.14-1.08-2.47-2.07-3.91-2.9c-0.01-0.12-0.04-0.23-0.06-0.34C320.09,43.29,319,42.2,319,41 v6.44C323.16,49.45,326,53.07,326,55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.51,76.5c0.01-0.03,0.02-0.05,0.03-0.08c0.07-0.17,0.14-0.34,0.22-0.51c0.02-0.05,0.04-0.09,0.06-0.14 c0.08-0.16,0.16-0.33,0.25-0.49c0.03-0.05,0.06-0.1,0.09-0.16c0.09-0.16,0.19-0.33,0.29-0.49c0.03-0.04,0.06-0.09,0.08-0.13 c0.05-0.07,0.1-0.15,0.14-0.22c0.63-0.95,1.42-1.88,2.32-2.75V71c0-1.93,2.84-5.55,7-7.56V63v-6.65c-1.72,0.96-2.8,2.4-2.97,4.14 c-0.32,0.18-0.62,0.37-0.93,0.57c-0.09,0.06-0.18,0.12-0.26,0.18c-0.21,0.14-0.43,0.29-0.64,0.44c-0.09,0.07-0.18,0.14-0.28,0.21 c-0.2,0.15-0.4,0.31-0.6,0.47c-0.08,0.06-0.16,0.13-0.23,0.19c-0.22,0.18-0.43,0.36-0.63,0.55c-0.05,0.05-0.1,0.09-0.15,0.14 c-1.04,0.96-1.93,2-2.63,3.06c-0.05,0.07-0.1,0.15-0.14,0.22c-0.03,0.04-0.06,0.09-0.08,0.13c-0.1,0.16-0.2,0.33-0.29,0.49 c-0.03,0.05-0.06,0.1-0.09,0.16c-0.09,0.16-0.17,0.33-0.25,0.49c-0.02,0.05-0.04,0.09-0.06,0.14c-0.08,0.17-0.15,0.34-0.22,0.51 c-0.01,0.03-0.02,0.05-0.03,0.08c-0.3,0.8-0.48,1.58-0.5,2.34c0,0.05-0.01,0.11-0.01,0.16v4.16v0.45v2.63V79 c0-0.05,0.01-0.11,0.01-0.16C201.03,78.08,201.21,77.3,201.51,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.58,65.13c-0.22-0.2-0.44-0.39-0.66-0.58c-0.03-0.02-0.05-0.04-0.08-0.07c-0.24-0.2-0.49-0.4-0.75-0.59 c-0.02-0.01-0.03-0.02-0.05-0.04c-0.27-0.2-0.54-0.39-0.82-0.58c-0.01,0-0.01-0.01-0.02-0.01c-0.29-0.19-0.58-0.38-0.89-0.56h0 c-0.12-0.07-0.23-0.15-0.36-0.22c-0.17-1.75-1.24-3.18-2.97-4.14V65v0.44c4.16,2.01,7,5.63,7,7.56v0.52 c0.09,0.09,0.19,0.18,0.28,0.27c0.05,0.05,0.1,0.09,0.14,0.14c0.18,0.18,0.34,0.36,0.51,0.55c0.05,0.06,0.1,0.11,0.15,0.17 c0.1,0.11,0.18,0.22,0.28,0.33c0.16,0.19,0.32,0.39,0.46,0.58c0.04,0.06,0.08,0.11,0.12,0.17c0.15,0.2,0.29,0.41,0.43,0.61 c0.03,0.04,0.05,0.08,0.08,0.13c0.13,0.21,0.26,0.41,0.37,0.62c0.03,0.05,0.06,0.11,0.09,0.16c0.11,0.19,0.2,0.39,0.3,0.58 c0.03,0.06,0.06,0.12,0.09,0.19c0.08,0.19,0.16,0.37,0.23,0.56c0.02,0.07,0.05,0.13,0.07,0.2c0.06,0.19,0.12,0.37,0.17,0.55 c0.02,0.06,0.04,0.13,0.05,0.19c0.05,0.19,0.08,0.39,0.11,0.58c0.01,0.05,0.02,0.1,0.03,0.15c0.03,0.24,0.05,0.48,0.05,0.71 c0,0.01,0,0.02,0,0.03v-0.47v-4.06V75v-2c0-0.01,0-0.02,0-0.03c0-0.23-0.02-0.47-0.05-0.71c-0.01-0.05-0.02-0.1-0.03-0.15 c-0.03-0.19-0.06-0.38-0.11-0.58c-0.02-0.06-0.04-0.13-0.05-0.19c-0.05-0.18-0.1-0.37-0.17-0.55c-0.02-0.07-0.05-0.13-0.07-0.2 c-0.07-0.19-0.14-0.37-0.23-0.56c-0.03-0.06-0.06-0.12-0.09-0.19c-0.09-0.19-0.19-0.39-0.3-0.58c-0.03-0.05-0.06-0.11-0.09-0.16 c-0.12-0.21-0.24-0.41-0.37-0.62c-0.03-0.04-0.05-0.08-0.08-0.13c-0.13-0.2-0.28-0.41-0.43-0.61c-0.04-0.06-0.08-0.11-0.12-0.17 c-0.15-0.2-0.3-0.39-0.46-0.58c-0.09-0.11-0.18-0.22-0.28-0.33c-0.05-0.06-0.1-0.11-0.15-0.17c-0.16-0.18-0.33-0.37-0.51-0.55 c-0.05-0.05-0.09-0.09-0.14-0.14c-0.19-0.19-0.38-0.38-0.58-0.56C344.66,65.2,344.62,65.16,344.58,65.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.58,61.13c-0.22-0.2-0.44-0.39-0.66-0.58c-0.03-0.02-0.05-0.04-0.08-0.07c-0.24-0.2-0.49-0.4-0.75-0.59 c-0.02-0.01-0.03-0.02-0.05-0.04c-0.27-0.2-0.54-0.39-0.82-0.58c-0.01,0-0.01-0.01-0.02-0.01c-0.29-0.19-0.58-0.38-0.89-0.56h0 c-0.12-0.07-0.23-0.15-0.36-0.22c-0.17-1.75-1.24-3.18-2.97-4.14V61v0.44c4.16,2.01,7,5.63,7,7.56v0.52 c0.09,0.09,0.19,0.18,0.28,0.27c0.05,0.05,0.1,0.09,0.14,0.14c0.18,0.18,0.34,0.36,0.51,0.55c0.05,0.06,0.1,0.11,0.15,0.17 c0.1,0.11,0.18,0.22,0.28,0.33c0.16,0.19,0.32,0.39,0.46,0.58c0.04,0.06,0.08,0.11,0.12,0.17c0.15,0.2,0.29,0.41,0.43,0.61 c0.03,0.04,0.05,0.08,0.08,0.13c0.13,0.21,0.26,0.41,0.37,0.62c0.03,0.05,0.06,0.11,0.09,0.16c0.11,0.19,0.2,0.39,0.3,0.58 c0.03,0.06,0.06,0.12,0.09,0.19c0.08,0.19,0.16,0.37,0.23,0.56c0.02,0.07,0.05,0.13,0.07,0.2c0.06,0.19,0.12,0.37,0.17,0.55 c0.02,0.06,0.04,0.13,0.05,0.19c0.05,0.19,0.08,0.39,0.11,0.58c0.01,0.05,0.02,0.1,0.03,0.15c0.03,0.24,0.05,0.48,0.05,0.71 c0,0.01,0,0.02,0,0.03v-6v-2c0-0.01,0-0.02,0-0.03c0-0.23-0.02-0.47-0.05-0.71c-0.01-0.05-0.02-0.1-0.03-0.15 c-0.03-0.19-0.06-0.38-0.11-0.58c-0.02-0.06-0.04-0.13-0.05-0.19c-0.05-0.18-0.1-0.37-0.17-0.55c-0.02-0.07-0.05-0.13-0.07-0.2 c-0.07-0.19-0.14-0.37-0.23-0.56c-0.03-0.06-0.06-0.12-0.09-0.19c-0.09-0.19-0.19-0.39-0.3-0.58c-0.03-0.05-0.06-0.11-0.09-0.16 c-0.12-0.21-0.24-0.41-0.37-0.62c-0.03-0.04-0.05-0.08-0.08-0.13c-0.13-0.2-0.28-0.41-0.43-0.61c-0.04-0.06-0.08-0.11-0.12-0.17 c-0.15-0.2-0.3-0.39-0.46-0.58c-0.09-0.11-0.18-0.22-0.28-0.33c-0.05-0.06-0.1-0.11-0.15-0.17c-0.16-0.18-0.33-0.37-0.51-0.55 c-0.05-0.05-0.09-0.09-0.14-0.14c-0.19-0.19-0.38-0.38-0.58-0.56C268.66,61.2,268.62,61.16,268.58,61.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.58,63.13c-0.22-0.2-0.44-0.39-0.66-0.58c-0.03-0.02-0.05-0.04-0.08-0.07c-0.24-0.2-0.49-0.4-0.75-0.59 c-0.02-0.01-0.03-0.02-0.05-0.04c-0.27-0.2-0.54-0.39-0.82-0.58c-0.01,0-0.01-0.01-0.02-0.01c-0.29-0.19-0.58-0.38-0.89-0.56h0 c-0.12-0.07-0.23-0.15-0.36-0.22c-0.17-1.75-1.24-3.18-2.97-4.14V63v0.44c4.16,2.01,7,5.63,7,7.56v0.52 c0.09,0.09,0.19,0.18,0.28,0.27c0.05,0.05,0.1,0.09,0.14,0.14c0.18,0.18,0.34,0.36,0.51,0.55c0.05,0.06,0.1,0.11,0.15,0.17 c0.1,0.11,0.18,0.22,0.28,0.33c0.16,0.19,0.32,0.39,0.46,0.58c0.04,0.06,0.08,0.11,0.12,0.17c0.15,0.2,0.29,0.41,0.43,0.61 c0.03,0.04,0.05,0.08,0.08,0.13c0.13,0.21,0.26,0.41,0.37,0.62c0.03,0.05,0.06,0.11,0.09,0.16c0.11,0.19,0.2,0.39,0.3,0.58 c0.03,0.06,0.06,0.12,0.09,0.19c0.08,0.19,0.16,0.37,0.23,0.56c0.02,0.07,0.05,0.13,0.07,0.2c0.06,0.19,0.12,0.37,0.17,0.55 c0.02,0.06,0.04,0.13,0.05,0.19c0.05,0.19,0.08,0.39,0.11,0.58c0.01,0.05,0.02,0.1,0.03,0.15c0.03,0.24,0.05,0.48,0.05,0.71 c0,0.01,0,0.02,0,0.03v-6v-2c0-0.01,0-0.02,0-0.03c0-0.23-0.02-0.47-0.05-0.71c-0.01-0.05-0.02-0.1-0.03-0.15 c-0.03-0.19-0.06-0.38-0.11-0.58c-0.02-0.06-0.04-0.13-0.05-0.19c-0.05-0.18-0.1-0.37-0.17-0.55c-0.02-0.07-0.05-0.13-0.07-0.2 c-0.07-0.19-0.14-0.37-0.23-0.56c-0.03-0.06-0.06-0.12-0.09-0.19c-0.09-0.19-0.19-0.39-0.3-0.58c-0.03-0.05-0.06-0.11-0.09-0.16 c-0.12-0.21-0.24-0.41-0.37-0.62c-0.03-0.04-0.05-0.08-0.08-0.13c-0.13-0.2-0.28-0.41-0.43-0.61c-0.04-0.06-0.08-0.11-0.12-0.17 c-0.15-0.2-0.3-0.39-0.46-0.58c-0.09-0.11-0.18-0.22-0.28-0.33c-0.05-0.06-0.1-0.11-0.15-0.17c-0.16-0.18-0.33-0.37-0.51-0.55 c-0.05-0.05-0.09-0.09-0.14-0.14c-0.19-0.19-0.38-0.38-0.58-0.56C306.66,63.2,306.62,63.16,306.58,63.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.65,76.32c0-0.01,0.01-0.01,0.01-0.02c0.27-0.4,0.56-0.8,0.88-1.19c0.01-0.02,0.03-0.04,0.04-0.05 c0.3-0.36,0.62-0.72,0.96-1.07c0.15-0.15,0.3-0.3,0.45-0.44V73c0-1.93,2.84-5.55,7-7.56V65v-2v-4.65c-1.72,0.96-2.8,2.4-2.97,4.14 c-0.39,0.23-0.78,0.47-1.15,0.72c-0.08,0.06-0.17,0.11-0.25,0.17c-0.37,0.26-0.74,0.52-1.09,0.8c0,0-0.01,0-0.01,0.01 c-0.36,0.28-0.7,0.57-1.03,0.87c-0.05,0.04-0.1,0.09-0.15,0.13c-0.28,0.26-0.55,0.52-0.81,0.79c-0.34,0.35-0.66,0.71-0.96,1.07 c-0.01,0.02-0.03,0.04-0.04,0.05c-0.32,0.39-0.61,0.79-0.88,1.19c0,0.01-0.01,0.01-0.01,0.02c-0.54,0.82-0.97,1.66-1.25,2.48 c-0.26,0.75-0.4,1.5-0.4,2.21v4.16v0.45v2.63V81c0-0.71,0.14-1.45,0.4-2.21C315.68,77.97,316.11,77.14,316.65,76.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,53v0.52c0.32,0.31,0.63,0.63,0.92,0.95c0.04,0.05,0.09,0.09,0.13,0.14c0.31,0.35,0.6,0.71,0.87,1.08 c0.04,0.06,0.09,0.12,0.13,0.17c0.26,0.37,0.5,0.74,0.72,1.11c0.03,0.05,0.05,0.09,0.08,0.14c0.18,0.33,0.34,0.66,0.48,0.98 c0.15,0.35,0.29,0.7,0.39,1.04c0.01,0.03,0.02,0.06,0.03,0.1c0.68-0.14,1.45-0.23,2.27-0.23c1.13,0,2.17,0.16,3.01,0.41 c0.02-0.04,0.04-0.09,0.07-0.13c0.03-0.05,0.06-0.1,0.09-0.16c0.09-0.16,0.19-0.33,0.29-0.49c0.03-0.04,0.06-0.09,0.08-0.13 c0.05-0.07,0.1-0.15,0.14-0.22c0.63-0.95,1.42-1.88,2.32-2.75V55c0-1.93,2.84-5.55,7-7.56V47v-6.65c-1.72,0.96-2.8,2.4-2.97,4.14 c-0.32,0.18-0.62,0.37-0.93,0.57c-0.09,0.06-0.18,0.12-0.26,0.18c-0.21,0.14-0.43,0.29-0.64,0.44c-0.09,0.07-0.19,0.14-0.28,0.21 c-0.2,0.15-0.4,0.31-0.6,0.46c-0.08,0.06-0.16,0.13-0.24,0.19c-0.22,0.18-0.43,0.36-0.63,0.55c-0.05,0.05-0.1,0.09-0.15,0.14 c-1.04,0.96-1.93,2-2.63,3.06c-0.05,0.07-0.1,0.15-0.14,0.22c-0.03,0.04-0.06,0.09-0.08,0.13c-0.1,0.16-0.2,0.33-0.29,0.49 c-0.03,0.05-0.06,0.1-0.09,0.16c-0.09,0.16-0.17,0.33-0.25,0.49c-0.02,0.05-0.04,0.09-0.07,0.14c-0.08,0.17-0.15,0.34-0.22,0.51 c-0.01,0.03-0.02,0.05-0.03,0.08c-0.3,0.8-0.48,1.58-0.5,2.34c0,0.05-0.01,0.11-0.01,0.16v0.12c-0.64-0.08-1.3-0.12-2-0.12 s-1.36,0.04-2,0.12V55v-0.03V53c0-0.27-0.03-0.54-0.06-0.82c-0.01-0.07-0.02-0.14-0.04-0.21c-0.04-0.23-0.09-0.46-0.16-0.7 c-0.01-0.05-0.03-0.1-0.04-0.15c-0.1-0.34-0.24-0.69-0.39-1.04c-0.14-0.33-0.3-0.66-0.48-0.98c-0.03-0.05-0.05-0.09-0.08-0.14 c-0.21-0.37-0.45-0.74-0.72-1.11c-0.04-0.06-0.08-0.12-0.13-0.17c-0.27-0.36-0.56-0.72-0.87-1.08c-0.04-0.05-0.08-0.09-0.13-0.14 c-0.33-0.37-0.67-0.73-1.04-1.08c-1.14-1.08-2.47-2.07-3.91-2.9c-0.01-0.12-0.04-0.23-0.06-0.34c-1.7-0.81-2.76-1.82-2.89-2.93 H281v6.22C285.16,47.45,288,51.07,288,53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,101.75v0.91v0.27v4.74c0.8,0.73,1.47,1.51,2.04,2.33c0.57,0,1.13-0.02,1.68-0.05c0.1-0.09,0.18-0.19,0.28-0.28v-0.05 v-0.45v-4.18v-2.05v-1.26c-0.1,0.09-0.19,0.19-0.28,0.28c-0.55,0.03-1.11,0.05-1.68,0.05c-0.57-0.82-1.24-1.6-2.04-2.33V101.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,103.75v0.91v0.27v4.74c0.8,0.73,1.47,1.51,2.04,2.33c0.57,0,1.13-0.02,1.68-0.05c0.1-0.09,0.18-0.19,0.28-0.28v-0.05 v-0.45v-4.18v-2.05v-1.26c-0.1,0.09-0.19,0.19-0.28,0.28c-0.55,0.03-1.11,0.05-1.68,0.05c-0.57-0.82-1.24-1.6-2.04-2.33V103.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,102.93v0.81v0.91v5.01c0.1,0.09,0.19,0.19,0.28,0.28c0.55,0.03,1.11,0.05,1.68,0.05c0.57-0.82,1.24-1.6,2.04-2.33 v-0.05v-0.45v-4.18v-0.05v-3.26c-0.8,0.73-1.47,1.51-2.04,2.33c-0.57,0-1.13-0.02-1.68-0.05c-0.1-0.09-0.18-0.19-0.28-0.28V102.93 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.51,78.5c0.01-0.03,0.02-0.05,0.03-0.08c0.07-0.17,0.14-0.34,0.22-0.51c0.02-0.05,0.04-0.09,0.06-0.14 c0.08-0.16,0.16-0.33,0.25-0.49c0.03-0.05,0.06-0.1,0.09-0.16c0.09-0.16,0.19-0.33,0.29-0.49c0.03-0.04,0.06-0.09,0.08-0.13 c0.05-0.07,0.1-0.15,0.14-0.22c0.63-0.95,1.42-1.88,2.32-2.75V73c0-1.93,2.84-5.55,7-7.56V65v-6.65c-1.72,0.96-2.8,2.4-2.97,4.14 c-0.32,0.18-0.62,0.37-0.93,0.57c-0.09,0.06-0.18,0.12-0.26,0.18c-0.21,0.14-0.43,0.29-0.64,0.44c-0.09,0.07-0.18,0.14-0.28,0.21 c-0.2,0.15-0.4,0.31-0.6,0.47c-0.08,0.06-0.16,0.13-0.23,0.19c-0.22,0.18-0.43,0.36-0.63,0.55c-0.05,0.05-0.1,0.09-0.15,0.14 c-1.04,0.96-1.93,2-2.63,3.06c-0.05,0.07-0.1,0.15-0.14,0.22c-0.03,0.04-0.06,0.09-0.08,0.13c-0.1,0.16-0.2,0.33-0.29,0.49 c-0.03,0.05-0.06,0.1-0.09,0.16c-0.09,0.16-0.17,0.33-0.25,0.49c-0.02,0.05-0.04,0.09-0.06,0.14c-0.08,0.17-0.15,0.34-0.22,0.51 c-0.01,0.03-0.02,0.05-0.03,0.08c-0.3,0.8-0.48,1.58-0.5,2.34c0,0.05-0.01,0.11-0.01,0.16v3.03v1.13v0.45v2.63v0.72V81 c0-0.05,0.01-0.11,0.01-0.16C163.03,80.08,163.21,79.3,163.51,78.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,104.93v0.81v0.91v5.01c0.1,0.09,0.19,0.19,0.28,0.28c0.55,0.03,1.11,0.05,1.68,0.05c0.57-0.82,1.24-1.6,2.04-2.33 v-0.05v-0.45v-4.18v-0.05v-3.26c-0.8,0.73-1.47,1.51-2.04,2.33c-0.57,0-1.13-0.02-1.68-0.05c-0.1-0.09-0.18-0.19-0.28-0.28V104.93 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,57v0.52c0.09,0.09,0.19,0.18,0.28,0.27c0.05,0.05,0.09,0.09,0.14,0.14c0.18,0.18,0.35,0.37,0.51,0.55 c0.05,0.06,0.1,0.11,0.15,0.17c0.1,0.11,0.18,0.22,0.28,0.33c0.16,0.19,0.31,0.39,0.46,0.58c0.04,0.06,0.08,0.11,0.12,0.17 c0.15,0.2,0.29,0.41,0.43,0.61c0.03,0.04,0.05,0.08,0.08,0.13c0.13,0.21,0.26,0.41,0.37,0.62c0.03,0.05,0.06,0.11,0.09,0.16 c0.03,0.05,0.05,0.11,0.08,0.16c0.84-0.25,1.87-0.41,3.01-0.41c0.82,0,1.59,0.09,2.28,0.23c0.04-0.15,0.08-0.31,0.14-0.47 c0,0,0-0.01,0-0.01c0.05-0.14,0.11-0.29,0.17-0.43c0.15-0.38,0.33-0.76,0.54-1.14c0.01-0.02,0.02-0.03,0.03-0.05 c0.23-0.41,0.49-0.82,0.78-1.23c0.02-0.03,0.04-0.05,0.06-0.08c0.29-0.4,0.6-0.8,0.95-1.19c0.02-0.02,0.03-0.04,0.05-0.05 c0.32-0.36,0.66-0.72,1.02-1.06V55c0-1.91,2.8-5.5,6.91-7.51V40.4c-1.56,0.9-2.56,2.19-2.83,3.75c-0.02,0.11-0.04,0.23-0.06,0.34 c-1.45,0.83-2.78,1.83-3.93,2.92c-0.4,0.38-0.77,0.77-1.13,1.17c-0.02,0.02-0.03,0.04-0.05,0.05c-0.34,0.39-0.66,0.79-0.95,1.19 c-0.02,0.03-0.04,0.05-0.06,0.08c-0.29,0.41-0.55,0.82-0.78,1.23c-0.01,0.02-0.02,0.03-0.03,0.05c-0.21,0.38-0.38,0.76-0.54,1.14 c-0.06,0.14-0.12,0.29-0.17,0.43c0,0,0,0.01,0,0.01c-0.08,0.24-0.15,0.47-0.21,0.7c-0.01,0.02-0.01,0.05-0.02,0.07 c-0.05,0.21-0.09,0.42-0.12,0.63c-0.01,0.04-0.02,0.08-0.02,0.12C182.02,54.53,182,54.77,182,55v1.84v0.28 c-0.64-0.08-1.3-0.12-2-0.12s-1.36,0.04-2,0.12V57c0-0.01,0-0.02,0-0.03c0-0.23-0.02-0.47-0.05-0.71 c-0.01-0.05-0.02-0.1-0.03-0.15c-0.03-0.19-0.06-0.38-0.11-0.58c-0.02-0.06-0.03-0.13-0.05-0.19c-0.05-0.18-0.1-0.37-0.17-0.56 c-0.02-0.07-0.05-0.13-0.07-0.2c-0.07-0.19-0.14-0.38-0.23-0.56c-0.03-0.06-0.06-0.12-0.09-0.18c-0.09-0.2-0.19-0.39-0.3-0.59 c-0.03-0.05-0.06-0.11-0.09-0.16c-0.12-0.21-0.24-0.41-0.37-0.62c-0.03-0.04-0.05-0.08-0.08-0.13c-0.13-0.2-0.28-0.41-0.43-0.61 c-0.04-0.06-0.08-0.11-0.12-0.17c-0.15-0.19-0.3-0.39-0.46-0.58c-0.09-0.11-0.18-0.22-0.28-0.33c-0.05-0.06-0.1-0.11-0.15-0.17 c-0.17-0.18-0.33-0.37-0.51-0.55c-0.04-0.05-0.09-0.09-0.14-0.14c-0.19-0.19-0.38-0.38-0.58-0.56c-0.04-0.03-0.07-0.07-0.11-0.1 c-0.22-0.2-0.44-0.39-0.66-0.58c-0.03-0.02-0.05-0.04-0.08-0.07c-0.24-0.2-0.49-0.4-0.75-0.59c-0.02-0.01-0.03-0.02-0.05-0.03 c-0.27-0.2-0.54-0.4-0.82-0.58c-0.01,0-0.01-0.01-0.02-0.01c-0.29-0.19-0.59-0.38-0.89-0.56c-0.12-0.07-0.23-0.15-0.36-0.22 c-0.17-1.75-1.24-3.18-2.97-4.14V49v0.44C171.16,51.45,174,55.07,174,57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.03,104.31c3.46,3.17,8.89,5.3,15.21,5.63c-0.14,0.68-0.24,1.36-0.24,2.06c0,0.66,0.09,1.31,0.22,1.94 c0.58,0.04,1.16,0.05,1.75,0.06c0.57-0.82,1.24-1.6,2.03-2.33v-0.05v-0.45v-4.18v-0.05v-0.1v-3.16c-0.79,0.73-1.46,1.51-2.03,2.33 c-9.29-0.01-16.82-4.4-16.96-9.85H144v8h0.01C144.01,104.2,144.03,104.25,144.03,104.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,122c-9.28,0-16.81-4.38-16.98-9.81H163v8h0.02c0,0.04,0.01,0.09,0.02,0.13c3.79,3.46,9.91,5.68,16.97,5.68 c7.07,0,13.19-2.22,16.97-5.69c0-0.04,0.01-0.08,0.01-0.12H197v-8h-0.02C196.81,117.62,189.28,122,180,122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,120c-9.28,0-16.81-4.38-16.98-9.81H201v8h0.02c0,0.05,0.01,0.09,0.02,0.13c3.79,3.46,9.91,5.67,16.97,5.67 c7.07,0,13.19-2.22,16.97-5.69c0-0.04,0.01-0.08,0.01-0.12H235v-8h-0.02C234.81,115.62,227.28,120,218,120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,118c-9.28,0-16.81-4.38-16.98-9.81H239v8h0.02c0,0.05,0.01,0.09,0.02,0.13c3.79,3.46,9.91,5.67,16.97,5.67 c7.06,0,13.18-2.21,16.97-5.67c0-0.05,0.01-0.09,0.02-0.13H273v-8h-0.02C272.81,113.62,265.28,118,256,118z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,120c-9.28,0-16.81-4.38-16.98-9.81H277v8h0.02c0,0.04,0.01,0.08,0.01,0.12c3.78,3.47,9.9,5.69,16.97,5.69 c7.06,0,13.18-2.21,16.97-5.67c0-0.05,0.01-0.09,0.02-0.13H311v-8h-0.02C310.81,115.62,303.28,120,294,120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,122c-9.28,0-16.81-4.38-16.98-9.81H315v8h0.02c0,0.04,0.01,0.08,0.01,0.12c3.78,3.47,9.9,5.69,16.97,5.69 c7.06,0,13.18-2.22,16.97-5.68c0-0.04,0.01-0.09,0.02-0.13H349v-8h-0.02C348.81,117.62,341.28,122,332,122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,105.75v0.91v0.27v0v4.74c0.79,0.73,1.46,1.51,2.03,2.33c0.59,0,1.18-0.02,1.75-0.06c0.13-0.64,0.22-1.28,0.22-1.94 c0-0.7-0.1-1.38-0.24-2.06c6.31-0.34,11.74-2.46,15.21-5.63c0-0.05,0.02-0.1,0.02-0.16H368v-8h-0.01 c-0.14,5.45-7.67,9.84-16.96,9.85c-0.57-0.82-1.24-1.6-2.03-2.33V105.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5,135c4.09,0,8.05-0.29,11.83-0.84C217.66,132.93,236.6,132,256,132s38.34,0.93,56.67,2.16 c3.78,0.54,7.74,0.84,11.83,0.84c25.68,0,46.5-10.42,46.5-24.5v-4c0,14.08-20.82,24.5-46.5,24.5c-4.09,0-8.05-0.29-11.83-0.84 C294.34,128.93,275.4,128,256,128s-38.34,0.93-56.67,2.16c-3.78,0.54-7.74,0.84-11.83,0.84c-25.68,0-46.5-10.42-46.5-24.5v4 C141,124.58,161.82,135,187.5,135z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.72,203c1.1,0,2.08-0.9,2.18-2c0.1-1.1-0.71-2-1.82-2c-1.1,0-2.08,0.9-2.18,2C448.81,202.1,449.62,203,450.72,203z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.46,195c1.1,0,2.08-0.9,2.18-2c0.1-1.1-0.71-2-1.82-2s-2.08,0.9-2.18,2C449.54,194.1,450.36,195,451.46,195z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.15,144.28l0.36-3.91c0.2-2.12-0.18-4.16-1.03-5.98v7.93l0.02,0.02c-0.02-0.01-0.03-0.01-0.05-0.02 C469.75,142.94,469.97,143.61,470.15,144.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.48,134.32L469.48,134.32c0.01,0.01,0.01,0.01,0.02,0.02L469.48,134.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.16,152c0.15-1.66,1.62-3,3.28-3h0.26l0.37-4h52l-8.67,94h-51.26h-0.74v4h52.37l8.3-90v-4h1.37 c0.91,0,1.67,0.41,2.17,1.05l0.56-6.05c0.15-1.66-1.07-3-2.72-3h-54c-1.66,0-3.12,1.34-3.28,3l-8.85,96 c-0.07,0.75,0.15,1.42,0.56,1.95L386.16,152z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.09,199c1.1,0,2.08-0.9,2.18-2c0.1-1.1-0.71-2-1.82-2s-2.08,0.9-2.18,2C453.17,198.1,453.99,199,455.09,199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.28,197c-0.1,1.1,0.71,2,1.82,2c1.1,0,2.08-0.9,2.18-2c0.1-1.1-0.71-2-1.82-2S445.38,195.9,445.28,197z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.1,146.66L464.02,256c-0.41,4.42-4.32,8-8.74,8h-1.21c0.66-0.42,1.28-0.92,1.85-1.46c0.03-0.18,0.07-0.36,0.09-0.54 l10.51-114c0.02-0.24,0.03-0.48,0.03-0.71h0v-8h0c0,0.23-0.01,0.47-0.03,0.71l-10.51,114c-0.41,4.42-4.32,8-8.74,8h-29.64 c-1.99,0-3.94,0.82-5.54,2.15c-2.87,2.39-6.51,3.85-10.36,3.85c-3.85,0-7.22-1.46-9.65-3.85c-1.36-1.33-3.15-2.15-5.15-2.15 h-11.64c-4.22,0-7.37-3.27-7.29-7.41h-0.01v8H368c-0.08,4.14,3.07,7.41,7.29,7.41h11.64c1.99,0,3.79,0.82,5.15,2.15 c2.43,2.39,5.8,3.85,9.65,3.85c3.13,0,6.11-0.97,8.66-2.61v4.58h0c3.61-0.16,7-1.56,9.7-3.82c0.06-0.05,0.13-0.1,0.2-0.15v-4 h26.99c2.67,0,5.15-1.32,6.79-3.33V272h1.21c4.42,0,8.33-3.58,8.74-8l10.51-114C474.64,148.81,474.48,147.68,474.1,146.66z  M420.1,266.15c-2.71,2.25-6.1,3.66-9.71,3.82c1.51-0.73,2.94-1.64,4.26-2.74c0.95-0.79,2.01-1.23,2.99-1.23h2.65 C420.23,266.05,420.16,266.1,420.1,266.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.88,223c-3.31,0-6.25,2.69-6.55,6c-0.16,1.75,0.44,3.31,1.53,4.41c1.23-1.46,3.06-2.41,5.02-2.41 c1.57,0,2.94,0.61,3.91,1.59c0.84-1,1.41-2.24,1.53-3.59C454.63,225.69,452.19,223,448.88,223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.46,333.08c-0.3-0.2-0.59-0.42-0.87-0.65c-1.67-1.38-2.93-3.22-3.59-5.34c-0.11-0.35-0.2-0.71-0.28-1.08 c-0.15-0.73-0.23-1.49-0.23-2.27v8c0,0.9,0.12,1.77,0.32,2.61c2.77,2.86,6.65,4.64,10.93,4.64h4.5c4.29,0,8.16-1.78,10.93-4.64 c0.2-0.84,0.32-1.71,0.32-2.61v-8c0,0.78-0.08,1.53-0.23,2.27c-0.07,0.37-0.17,0.73-0.28,1.08c-0.66,2.11-1.92,3.96-3.59,5.34 c-0.28,0.23-0.57,0.45-0.87,0.65c-0.6,0.4-1.24,0.75-1.91,1.04c-1.35,0.57-2.83,0.88-4.38,0.88h-4.5c-1.55,0-3.03-0.31-4.38-0.88 C248.7,333.83,248.06,333.48,247.46,333.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.38,308v8h0c0.71,1.2,1.12,2.59,1.12,4.08v-8C273.5,310.59,273.09,309.2,272.38,308z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,312.08v8c0-1.49,0.41-2.88,1.12-4.08h0v-8C238.91,309.2,238.5,310.59,238.5,312.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.67,372.13c-1.24-14.78-5.9-26.9-12.11-32.22c-0.96-0.82-1.56-1.99-1.56-3.26v7.3c1.71,1.8,3.27,4.31,4.64,7.33 c4.47,6.01,7.75,15.87,8.9,27.5c1.25,0.77,2.72,1.21,4.3,1.21h42.32c1.58,0,3.05-0.44,4.3-1.21c1.15-11.63,4.43-21.49,8.9-27.5 c1.36-3.02,2.93-5.54,4.64-7.33v-7.3c0,1.27-0.6,2.44-1.56,3.26c-6.21,5.32-10.87,17.44-12.11,32.22 c-0.18,2.18-1.98,3.87-4.17,3.87h-42.32C232.65,376,230.85,374.31,230.67,372.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,326.92V320c0,2.21-1.79,4-4,4s-4-1.79-4-4v6.92c1.18,0.68,2.54,1.08,4,1.08S258.82,327.6,260,326.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,286v2c0-0.68,0.07-1.35,0.18-2H141z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,296v-8c0,6.63-5.37,12-12,12h-46H194h-41c-6.63,0-12-5.37-12-12v8c0,6.63,5.37,12,12,12h206 C365.63,308,371,302.63,371,296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.82,286c0.11,0.65,0.18,1.32,0.18,2v-2H370.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5,151c2.22,0,4.39-0.09,6.53-0.26c0.14-2.09,1.85-3.74,3.97-3.74h111c1.93,0,3.55,1.37,3.92,3.2 c3.7,0.52,7.58,0.8,11.58,0.8c25.68,0,46.5-10.42,46.5-24.5v-8c0,14.08-20.82,24.5-46.5,24.5c-4.09,0-8.05-0.29-11.83-0.84 C294.34,140.93,275.4,140,256,140s-38.34,0.93-56.67,2.16c-3.78,0.54-7.74,0.84-11.83,0.84c-25.68,0-46.5-10.42-46.5-24.5v8 C141,140.58,161.82,151,187.5,151z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 252,
    width: 30,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161,205 176.3,205 176.3,201 174.03,201 161,201 157,201 157,205 157,209 161,209  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 252,
    width: 29,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 272,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.19,263c1.72,0,3.35-0.55,4.74-1.47v-5.79c1.22,0.59,2.23,1.49,2.93,2.62c0,0,0,0,0,0c0.14-0.25,0.27-0.51,0.39-0.78 c0-0.01,0-0.01,0.01-0.01c0.11-0.25,0.2-0.5,0.29-0.76c0.01-0.03,0.02-0.05,0.03-0.08c0.07-0.24,0.14-0.48,0.19-0.72 c0.01-0.05,0.03-0.09,0.04-0.14c0.06-0.29,0.1-0.57,0.13-0.87c0.05-0.55,0.04-1.09-0.01-1.61c-0.06-0.52-0.17-1.02-0.33-1.5 c-0.08-0.24-0.17-0.47-0.27-0.7c-0.31-0.68-0.72-1.3-1.21-1.84c-1.32-1.45-3.23-2.35-5.44-2.35s-4.29,0.9-5.87,2.35 c-0.59,0.54-1.12,1.16-1.55,1.84c-0.14,0.23-0.28,0.46-0.4,0.7c-0.25,0.48-0.45,0.98-0.61,1.5c-0.15,0.52-0.26,1.06-0.31,1.61 c-0.04,0.39-0.03,0.77-0.01,1.14c0,0.07,0.01,0.15,0.01,0.22c0.03,0.37,0.08,0.74,0.17,1.1c0,0.01,0.01,0.02,0.01,0.03 c0.09,0.37,0.21,0.73,0.35,1.07c0.01,0.02,0.01,0.03,0.02,0.05c0.15,0.35,0.32,0.69,0.52,1.02c0.71-1.27,1.73-2.36,2.94-3.17v5.8 C399.91,262.73,401,263,402.19,263z M398.93,255c0.2-2.21,2.16-4,4.37-4c2.21,0,3.83,1.79,3.63,4c-0.2,2.21-2.16,4-4.37,4 C400.35,259,398.73,257.21,398.93,255z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079458230494604322470000001115379782868003236_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.5,
    y1: 220.875,
    x2: 186.5,
    y2: 151.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000079458230494604322470000001115379782868003236_)",
    d: "M194.12,220.88v-2.93 c0-5.56-3.09-10.57-8.07-13.06c-4.89-2.45-7.93-7.36-7.93-12.83v-32.97c0-4.39,3.57-7.96,7.96-7.96h8.79v69.75H194.12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M194.75,151.25v69.5h-0.5v-2.81c0-5.61-3.12-10.66-8.14-13.17c-4.85-2.42-7.86-7.3-7.86-12.72v-32.97 c0-4.32,3.51-7.83,7.83-7.83H194.75 M195,151h-8.92c-4.46,0-8.08,3.62-8.08,8.08v32.97c0,5.48,3.1,10.49,8,12.94h0 c4.9,2.45,8,7.46,8,12.94V221h1V151L195,151z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155865822103657249900000010122175763067759016_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.5,
    y1: 273.875,
    x2: 253.5,
    y2: 147.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000155865822103657249900000010122175763067759016_)",
    d: "M198,273.88c-2.14,0-3.88-1.74-3.88-3.88V151 c0-2.14,1.74-3.88,3.88-3.88h111c2.14,0,3.88,1.74,3.88,3.88v119c0,2.14-1.74,3.88-3.88,3.88H198z M300.5,181.88 c-0.9,0-1.62,0.73-1.62,1.62v29c0,0.9,0.73,1.62,1.62,1.62s1.62-0.73,1.62-1.62v-29C302.12,182.6,301.4,181.88,300.5,181.88z  M294.5,181.88c-0.9,0-1.62,0.73-1.62,1.62v29c0,0.9,0.73,1.62,1.62,1.62s1.62-0.73,1.62-1.62v-29 C296.12,182.6,295.4,181.88,294.5,181.88z M288.5,181.88c-0.9,0-1.62,0.73-1.62,1.62v29c0,0.9,0.73,1.62,1.62,1.62 s1.62-0.73,1.62-1.62v-29C290.12,182.6,289.4,181.88,288.5,181.88z M282.5,181.88c-0.9,0-1.62,0.73-1.62,1.62v29 c0,0.9,0.73,1.62,1.62,1.62s1.62-0.73,1.62-1.62v-29C284.12,182.6,283.4,181.88,282.5,181.88z M276.5,181.88 c-0.9,0-1.62,0.73-1.62,1.62v29c0,0.9,0.73,1.62,1.62,1.62s1.62-0.73,1.62-1.62v-29C278.12,182.6,277.4,181.88,276.5,181.88z  M270.5,181.88c-0.9,0-1.62,0.73-1.62,1.62v29c0,0.9,0.73,1.62,1.62,1.62s1.62-0.73,1.62-1.62v-29 C272.12,182.6,271.4,181.88,270.5,181.88z M264.5,181.88c-0.9,0-1.62,0.73-1.62,1.62v29c0,0.9,0.73,1.62,1.62,1.62 s1.62-0.73,1.62-1.62v-29C266.12,182.6,265.4,181.88,264.5,181.88z M258.5,181.88c-0.9,0-1.62,0.73-1.62,1.62v29 c0,0.9,0.73,1.62,1.62,1.62s1.62-0.73,1.62-1.62v-29C260.12,182.6,259.4,181.88,258.5,181.88z M252.5,181.88 c-0.9,0-1.62,0.73-1.62,1.62v29c0,0.9,0.73,1.62,1.62,1.62s1.62-0.73,1.62-1.62v-29C254.12,182.6,253.4,181.88,252.5,181.88z  M246.5,181.88c-0.9,0-1.62,0.73-1.62,1.62v29c0,0.9,0.73,1.62,1.62,1.62s1.62-0.73,1.62-1.62v-29 C248.12,182.6,247.4,181.88,246.5,181.88z M240.5,181.88c-0.9,0-1.62,0.73-1.62,1.62v29c0,0.9,0.73,1.62,1.62,1.62 s1.62-0.73,1.62-1.62v-29C242.12,182.6,241.4,181.88,240.5,181.88z M234.5,181.88c-0.9,0-1.62,0.73-1.62,1.62v29 c0,0.9,0.73,1.62,1.62,1.62s1.62-0.73,1.62-1.62v-29C236.12,182.6,235.4,181.88,234.5,181.88z M228.5,181.88 c-0.9,0-1.62,0.73-1.62,1.62v29c0,0.9,0.73,1.62,1.62,1.62s1.62-0.73,1.62-1.62v-29C230.12,182.6,229.4,181.88,228.5,181.88z  M222.5,181.88c-0.9,0-1.62,0.73-1.62,1.62v29c0,0.9,0.73,1.62,1.62,1.62s1.62-0.73,1.62-1.62v-29 C224.12,182.6,223.4,181.88,222.5,181.88z M216.5,181.88c-0.9,0-1.62,0.73-1.62,1.62v29c0,0.9,0.73,1.62,1.62,1.62 s1.62-0.73,1.62-1.62v-29C218.12,182.6,217.4,181.88,216.5,181.88z M210.5,181.88c-0.9,0-1.62,0.73-1.62,1.62v29 c0,0.9,0.73,1.62,1.62,1.62s1.62-0.73,1.62-1.62v-29C212.12,182.6,211.4,181.88,210.5,181.88z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M309,147.25c2.07,0,3.75,1.68,3.75,3.75v119c0,2.07-1.68,3.75-3.75,3.75H198c-2.07,0-3.75-1.68-3.75-3.75 V151c0-2.07,1.68-3.75,3.75-3.75H309 M300.5,214.25c0.96,0,1.75-0.79,1.75-1.75v-29c0-0.96-0.79-1.75-1.75-1.75 s-1.75,0.79-1.75,1.75v29C298.75,213.46,299.54,214.25,300.5,214.25 M294.5,214.25c0.96,0,1.75-0.79,1.75-1.75v-29 c0-0.96-0.79-1.75-1.75-1.75s-1.75,0.79-1.75,1.75v29C292.75,213.46,293.54,214.25,294.5,214.25 M288.5,214.25 c0.96,0,1.75-0.79,1.75-1.75v-29c0-0.96-0.79-1.75-1.75-1.75s-1.75,0.79-1.75,1.75v29C286.75,213.46,287.54,214.25,288.5,214.25  M282.5,214.25c0.96,0,1.75-0.79,1.75-1.75v-29c0-0.96-0.79-1.75-1.75-1.75s-1.75,0.79-1.75,1.75v29 C280.75,213.46,281.54,214.25,282.5,214.25 M276.5,214.25c0.96,0,1.75-0.79,1.75-1.75v-29c0-0.96-0.79-1.75-1.75-1.75 s-1.75,0.79-1.75,1.75v29C274.75,213.46,275.54,214.25,276.5,214.25 M270.5,214.25c0.96,0,1.75-0.79,1.75-1.75v-29 c0-0.96-0.79-1.75-1.75-1.75s-1.75,0.79-1.75,1.75v29C268.75,213.46,269.54,214.25,270.5,214.25 M264.5,214.25 c0.96,0,1.75-0.79,1.75-1.75v-29c0-0.96-0.79-1.75-1.75-1.75s-1.75,0.79-1.75,1.75v29C262.75,213.46,263.54,214.25,264.5,214.25  M258.5,214.25c0.96,0,1.75-0.79,1.75-1.75v-29c0-0.96-0.79-1.75-1.75-1.75s-1.75,0.79-1.75,1.75v29 C256.75,213.46,257.54,214.25,258.5,214.25 M252.5,214.25c0.96,0,1.75-0.79,1.75-1.75v-29c0-0.96-0.79-1.75-1.75-1.75 s-1.75,0.79-1.75,1.75v29C250.75,213.46,251.54,214.25,252.5,214.25 M246.5,214.25c0.96,0,1.75-0.79,1.75-1.75v-29 c0-0.96-0.79-1.75-1.75-1.75s-1.75,0.79-1.75,1.75v29C244.75,213.46,245.54,214.25,246.5,214.25 M240.5,214.25 c0.96,0,1.75-0.79,1.75-1.75v-29c0-0.96-0.79-1.75-1.75-1.75s-1.75,0.79-1.75,1.75v29C238.75,213.46,239.54,214.25,240.5,214.25  M234.5,214.25c0.96,0,1.75-0.79,1.75-1.75v-29c0-0.96-0.79-1.75-1.75-1.75s-1.75,0.79-1.75,1.75v29 C232.75,213.46,233.54,214.25,234.5,214.25 M228.5,214.25c0.96,0,1.75-0.79,1.75-1.75v-29c0-0.96-0.79-1.75-1.75-1.75 s-1.75,0.79-1.75,1.75v29C226.75,213.46,227.54,214.25,228.5,214.25 M222.5,214.25c0.96,0,1.75-0.79,1.75-1.75v-29 c0-0.96-0.79-1.75-1.75-1.75s-1.75,0.79-1.75,1.75v29C220.75,213.46,221.54,214.25,222.5,214.25 M216.5,214.25 c0.96,0,1.75-0.79,1.75-1.75v-29c0-0.96-0.79-1.75-1.75-1.75s-1.75,0.79-1.75,1.75v29C214.75,213.46,215.54,214.25,216.5,214.25  M210.5,214.25c0.96,0,1.75-0.79,1.75-1.75v-29c0-0.96-0.79-1.75-1.75-1.75s-1.75,0.79-1.75,1.75v29 C208.75,213.46,209.54,214.25,210.5,214.25 M309,147H198c-2.21,0-4,1.79-4,4v119c0,2.21,1.79,4,4,4h111c2.21,0,4-1.79,4-4V151 C313,148.79,311.21,147,309,147L309,147z M300.5,214c-0.83,0-1.5-0.67-1.5-1.5v-29c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5v29 C302,213.33,301.33,214,300.5,214L300.5,214z M294.5,214c-0.83,0-1.5-0.67-1.5-1.5v-29c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5 v29C296,213.33,295.33,214,294.5,214L294.5,214z M288.5,214c-0.83,0-1.5-0.67-1.5-1.5v-29c0-0.83,0.67-1.5,1.5-1.5 s1.5,0.67,1.5,1.5v29C290,213.33,289.33,214,288.5,214L288.5,214z M282.5,214c-0.83,0-1.5-0.67-1.5-1.5v-29 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5v29C284,213.33,283.33,214,282.5,214L282.5,214z M276.5,214c-0.83,0-1.5-0.67-1.5-1.5 v-29c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5v29C278,213.33,277.33,214,276.5,214L276.5,214z M270.5,214 c-0.83,0-1.5-0.67-1.5-1.5v-29c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5v29C272,213.33,271.33,214,270.5,214L270.5,214z  M264.5,214c-0.83,0-1.5-0.67-1.5-1.5v-29c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5v29C266,213.33,265.33,214,264.5,214 L264.5,214z M258.5,214c-0.83,0-1.5-0.67-1.5-1.5v-29c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5v29 C260,213.33,259.33,214,258.5,214L258.5,214z M252.5,214c-0.83,0-1.5-0.67-1.5-1.5v-29c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5 v29C254,213.33,253.33,214,252.5,214L252.5,214z M246.5,214c-0.83,0-1.5-0.67-1.5-1.5v-29c0-0.83,0.67-1.5,1.5-1.5 s1.5,0.67,1.5,1.5v29C248,213.33,247.33,214,246.5,214L246.5,214z M240.5,214c-0.83,0-1.5-0.67-1.5-1.5v-29 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5v29C242,213.33,241.33,214,240.5,214L240.5,214z M234.5,214c-0.83,0-1.5-0.67-1.5-1.5 v-29c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5v29C236,213.33,235.33,214,234.5,214L234.5,214z M228.5,214 c-0.83,0-1.5-0.67-1.5-1.5v-29c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5v29C230,213.33,229.33,214,228.5,214L228.5,214z  M222.5,214c-0.83,0-1.5-0.67-1.5-1.5v-29c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5v29C224,213.33,223.33,214,222.5,214 L222.5,214z M216.5,214c-0.83,0-1.5-0.67-1.5-1.5v-29c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5v29 C218,213.33,217.33,214,216.5,214L216.5,214z M210.5,214c-0.83,0-1.5-0.67-1.5-1.5v-29c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5 v29C212,213.33,211.33,214,210.5,214L210.5,214z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078743332390540389890000010438421932274609047_",
    gradientUnits: "userSpaceOnUse",
    x1: 127,
    y1: 456.875,
    x2: 127,
    y2: 413.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000078743332390540389890000010438421932274609047_)",
    d: "M111.33,456.88c-3.42,0-6.2-2.78-6.2-6.2v-22.17 c0-1.66,0.65-3.21,1.82-4.38l9.18-9.18c1.17-1.17,2.73-1.82,4.39-1.82h12.98c1.66,0,3.21,0.65,4.39,1.82l9.18,9.18 c1.17,1.17,1.82,2.73,1.82,4.38v22.17c0,3.42-2.78,6.2-6.2,6.2H111.33z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M133.49,413.25c1.62,0,3.15,0.63,4.3,1.78l9.18,9.18c1.15,1.15,1.78,2.67,1.78,4.3v22.17 c0,3.35-2.73,6.08-6.08,6.08h-31.35c-3.35,0-6.08-2.73-6.08-6.08v-22.17c0-1.62,0.63-3.15,1.78-4.3l9.18-9.18 c1.15-1.15,2.67-1.78,4.3-1.78H133.49 M133.49,413h-12.98c-1.68,0-3.29,0.67-4.47,1.85l-9.18,9.18c-1.19,1.19-1.85,2.8-1.85,4.47 v22.17c0,3.49,2.83,6.33,6.33,6.33h31.35c3.49,0,6.33-2.83,6.33-6.33v-22.17c0-1.68-0.67-3.29-1.85-4.47l-9.18-9.18 C136.78,413.67,135.17,413,133.49,413L133.49,413z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046339883900500056520000006655806110572184509_",
    gradientUnits: "userSpaceOnUse",
    x1: 385,
    y1: 456.875,
    x2: 385,
    y2: 413.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000046339883900500056520000006655806110572184509_)",
    d: "M369.33,456.88c-3.42,0-6.2-2.78-6.2-6.2v-22.17 c0-1.66,0.65-3.21,1.82-4.38l9.18-9.18c1.17-1.17,2.73-1.82,4.38-1.82h12.98c1.66,0,3.21,0.65,4.38,1.82l9.18,9.18 c1.17,1.17,1.82,2.73,1.82,4.38v22.17c0,3.42-2.78,6.2-6.2,6.2H369.33z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M391.49,413.25c1.62,0,3.15,0.63,4.3,1.78l9.18,9.18c1.15,1.15,1.78,2.67,1.78,4.3v22.17 c0,3.35-2.73,6.08-6.08,6.08h-31.35c-3.35,0-6.08-2.73-6.08-6.08v-22.17c0-1.62,0.63-3.15,1.78-4.3l9.18-9.18 c1.15-1.15,2.67-1.78,4.3-1.78H391.49 M391.49,413h-12.98c-1.68,0-3.29,0.67-4.47,1.85l-9.18,9.18c-1.19,1.19-1.85,2.8-1.85,4.47 v22.17c0,3.49,2.83,6.33,6.33,6.33h31.35c3.49,0,6.33-2.83,6.33-6.33v-22.17c0-1.68-0.67-3.29-1.85-4.47l-9.18-9.18 C394.78,413.67,393.17,413,391.49,413L391.49,413z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103944209789108857710000016946442232279834785_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 456.875,
    x2: 256,
    y2: 427.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 157.12,
    y: 427.12,
    fill: "url(#SVGID_00000103944209789108857710000016946442232279834785_)",
    width: 197.75,
    height: 29.75
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M354.75,427.25v29.5h-197.5v-29.5H354.75 M355,427H157v30h198V427L355,427z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059295660945136648310000000618710895004241835_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 418.875,
    x2: 256,
    y2: 308.1562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000059295660945136648310000000618710895004241835_)",
    d: "M153.43,418.88l-0.11-0.12 c-0.14-0.16-0.28-0.32-0.43-0.47l-9.18-9.18c-2.73-2.73-6.36-4.23-10.22-4.23h-1.37V349c0-17.99,36.47-40.18,81.8-40.84 c-0.69,1.24-1.05,2.63-1.05,4.03v24.47c0,2.43,1.09,4.76,3,6.39c5.38,4.61,9.57,16.16,10.68,29.43c0.37,4.36,3.93,7.65,8.28,7.65 h42.32c4.36,0,7.92-3.29,8.28-7.65c1.11-13.27,5.31-24.82,10.68-29.43c1.91-1.63,3-3.96,3-6.39v-24.47c0-1.4-0.36-2.79-1.05-4.03 c45.34,0.66,81.8,22.86,81.8,40.84v55.88h-1.37c-3.86,0-7.49,1.5-10.22,4.23l-9.18,9.18c-0.15,0.15-0.29,0.3-0.42,0.46l-0.11,0.12 H153.43z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M298.28,308.28c20.95,0.34,41.39,5.28,57.6,13.93c14.94,7.97,23.87,17.99,23.87,26.78v55.75h-1.24 c-3.89,0-7.55,1.52-10.31,4.27l-9.18,9.18c-0.15,0.15-0.29,0.31-0.43,0.47l-0.07,0.08H153.48l-0.07-0.08 c-0.14-0.16-0.28-0.32-0.43-0.47l-9.18-9.18c-2.75-2.75-6.41-4.27-10.31-4.27h-1.24V349c0-8.8,8.92-18.81,23.87-26.78 c16.21-8.65,36.66-13.59,57.6-13.93c-0.63,1.21-0.97,2.55-0.97,3.9v24.47c0,2.46,1.11,4.83,3.04,6.49 c5.35,4.59,9.53,16.11,10.64,29.34c0.37,4.43,3.98,7.76,8.41,7.76h42.32c4.42,0,8.03-3.34,8.41-7.76 c1.11-13.24,5.29-24.76,10.64-29.34c1.93-1.66,3.04-4.02,3.04-6.49v-24.47C299.25,310.83,298.92,309.49,298.28,308.28  M297.85,308.03c0.72,1.22,1.15,2.64,1.15,4.16v24.47c0,2.39-1.08,4.69-2.96,6.3c-5.4,4.63-9.61,16.21-10.73,29.51 c-0.36,4.29-3.87,7.53-8.16,7.53h-42.32c-4.29,0-7.8-3.24-8.16-7.53c-1.12-13.3-5.33-24.88-10.73-29.51 c-1.88-1.61-2.96-3.91-2.96-6.3v-24.47c0-1.52,0.42-2.94,1.15-4.16C168.61,308.63,132,331.02,132,349v56h1.49 c3.83,0,7.42,1.49,10.13,4.2l9.18,9.18c0.2,0.2,0.38,0.41,0.57,0.62h205.26c0.19-0.21,0.37-0.42,0.57-0.62l9.18-9.18 c2.71-2.71,6.3-4.2,10.13-4.2H380v-56C380,331.02,343.39,308.63,297.85,308.03L297.85,308.03z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090258743041764846790000013565575657337746587_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 334.875,
    x2: 256,
    y2: 308.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E47D91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3954,
    style: {
      stopColor: "#DD5D76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    style: {
      stopColor: "#D5586F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7821,
    style: {
      stopColor: "#C04B5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A63C46"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000090258743041764846790000013565575657337746587_)",
    d: "M253.75,334.88c-6.13,0-11.12-4.99-11.12-11.12 v-11.67c0-2.18,1.78-3.96,3.96-3.96h18.83c2.18,0,3.96,1.78,3.96,3.96v11.67c0,6.13-4.99,11.12-11.12,11.12H253.75z M256,311.88 c-4.48,0-8.12,3.64-8.12,8.12s3.65,8.12,8.12,8.12c4.48,0,8.12-3.64,8.12-8.12S260.48,311.88,256,311.88z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A63C46",
    d: "M265.42,308.25c2.11,0,3.83,1.72,3.83,3.83v11.67c0,6.07-4.93,11-11,11h-4.5c-6.07,0-11-4.93-11-11 v-11.67c0-2.11,1.72-3.83,3.83-3.83H265.42 M256,328.25c4.55,0,8.25-3.7,8.25-8.25s-3.7-8.25-8.25-8.25s-8.25,3.7-8.25,8.25 S251.45,328.25,256,328.25 M265.42,308h-18.83c-2.26,0-4.08,1.83-4.08,4.08v11.67c0,6.21,5.04,11.25,11.25,11.25h4.5 c6.21,0,11.25-5.04,11.25-11.25v-11.67C269.5,309.83,267.67,308,265.42,308L265.42,308z M256,328c-4.42,0-8-3.58-8-8s3.58-8,8-8 s8,3.58,8,8S260.42,328,256,328L256,328z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129171836800288043170000000558207673252672690_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 323.875,
    x2: 256,
    y2: 316.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_00000129171836800288043170000000558207673252672690_)",
    cx: 256,
    cy: 320,
    r: 3.88
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M256,316.25c2.07,0,3.75,1.68,3.75,3.75s-1.68,3.75-3.75,3.75c-2.07,0-3.75-1.68-3.75-3.75 S253.93,316.25,256,316.25 M256,316c-2.21,0-4,1.79-4,4c0,2.21,1.79,4,4,4s4-1.79,4-4C260,317.79,258.21,316,256,316L256,316z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129914541267095518870000016141764658191700614_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.3892,
    y1: 251.875,
    x2: 341.3892,
    y2: 177.3086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000129914541267095518870000016141764658191700614_)",
    points: "355.12,251.88 355.12,200.88  317.12,200.88 317.12,177.31 365.65,191.17 360.06,251.88  "
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M317.25,177.47l48.27,13.79l-5.58,60.48h-4.69V205v-4v-0.25H355h-4h-33.75V177.47 M317,177.14V201h34h4v4 v47h5.17l5.62-60.92L317,177.14L317,177.14z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100380956778102329810000002975534225192378519_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.5,
    y1: 278.125,
    x2: 253.5,
    y2: 291.875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58595B"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000100380956778102329810000002975534225192378519_)",
    points: "198.12,291.88 198.12,278.12  201.88,278.12 201.88,284.12 305.12,284.12 305.12,278.12 308.88,278.12 308.88,291.88  "
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M308.75,278.25v13.5h-110.5v-13.5h3.5V284v0.25H202h103h0.25V284v-5.75H308.75 M309,278h-4v6H202v-6h-4 v14h111V278L309,278z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026870835790040366800000001137141426333862052_",
    gradientUnits: "userSpaceOnUse",
    x1: 100,
    y1: 256.127,
    x2: 100,
    y2: 271.875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58595B"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000026870835790040366800000001137141426333862052_)",
    d: "M96.12,271.88c0.03-8.61,3.49-15.61,7.75-15.75 v15.75H96.12z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M103.75,256.26v15.49h-7.5C96.32,263.35,99.63,256.52,103.75,256.26 M104,256c-4.42,0-8,7.16-8,16h8V256 L104,256z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093886590815059328300000012309500008918171302_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.125,
    y1: 465,
    x2: 136.875,
    y2: 465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58595B"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 118.12,
    y: 461.12,
    fill: "url(#SVGID_00000093886590815059328300000012309500008918171302_)",
    width: 18.75,
    height: 7.75
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M136.75,461.25v7.5h-18.5v-7.5H136.75 M137,461h-19v8h19V461L137,461z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020362815070905122970000003723630562567463593_",
    gradientUnits: "userSpaceOnUse",
    x1: 375.125,
    y1: 465,
    x2: 393.875,
    y2: 465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58595B"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 375.12,
    y: 461.12,
    fill: "url(#SVGID_00000020362815070905122970000003723630562567463593_)",
    width: 18.75,
    height: 7.75
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M393.75,461.25v7.5h-18.5v-7.5H393.75 M394,461h-19v8h19V461L394,461z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115484665973378598220000004658825176750899350_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.5,
    y1: 232.125,
    x2: 253.5,
    y2: 262.875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000115484665973378598220000004658825176750899350_)",
    d: "M256,262.88c-20.01,0-38.91-1.42-54.66-4.11 c-1.87-0.32-3.22-1.93-3.22-3.82V236c0-2.14,1.74-3.88,3.88-3.88h103c2.14,0,3.88,1.74,3.88,3.88v19.73 c0,1.94-1.39,3.55-3.31,3.84C290.89,261.73,273.75,262.88,256,262.88z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M305,232.25c2.07,0,3.75,1.68,3.75,3.75v19.73c0,1.88-1.35,3.44-3.2,3.71c-14.67,2.16-31.8,3.3-49.55,3.3 c-20,0-38.9-1.42-54.63-4.11c-1.81-0.31-3.12-1.86-3.12-3.7V236c0-2.07,1.68-3.75,3.75-3.75H305 M305,232H202c-2.21,0-4,1.79-4,4 v18.94c0,1.95,1.4,3.62,3.32,3.95c15.09,2.58,34.06,4.11,54.68,4.11c18.36,0,35.41-1.22,49.58-3.31 c1.97-0.29,3.42-1.97,3.42-3.96V236C309,233.79,307.21,232,305,232L305,232z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044895439220507735450000012748248223839038362_",
    gradientUnits: "userSpaceOnUse",
    x1: 359.1514,
    y1: 251.875,
    x2: 359.1514,
    y2: 214.5181
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000044895439220507735450000012748248223839038362_)",
    points: "355.12,251.88 355.12,214.52  363.18,218.03 360.06,251.88  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M355.25,214.71l7.79,3.4l-3.1,33.64h-4.69V214.71 M355,214.33V252h5.17l3.14-34.05L355,214.33L355,214.33 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010272411946470342860000002830536057997564311_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.4922,
    y1: 200.875,
    x2: 320.4922,
    y2: 197.9365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000010272411946470342860000002830536057997564311_)",
    points: "317.12,200.88 317.12,197.94  323.86,200.88  "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M317.25,198.13l6.01,2.62h-6.01V198.13 M317,197.75V201h7.46L317,197.75L317,197.75z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080898533680364597080000012704524616756727176_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.6074,
    y1: 251.875,
    x2: 151.6074,
    y2: 183.3086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000080898533680364597080000012704524616756727176_)",
    d: "M127.12,251.88v-43.62l15.96-16.17l30.79-8.78 v8.75c0,3.08,0.77,6.12,2.21,8.82h-19.21v51H127.12z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M173.75,183.47v8.58c0,3.03,0.74,6.02,2.13,8.69H161h-4h-0.25V201v4v46.75h-29.5v-43.39l15.88-16.14 L173.75,183.47 M174,183.14L143,192l-16,16.26V252h30v-47v-4h4h15.3c-1.48-2.68-2.3-5.74-2.3-8.94V183.14L174,183.14z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083087457735392344640000015584196537800004283_",
    gradientUnits: "userSpaceOnUse",
    x1: 142,
    y1: 251.875,
    x2: 142,
    y2: 214.5181
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000083087457735392344640000015584196537800004283_)",
    points: "127.12,251.88 127.12,238.26  144.09,220.08 156.88,214.52 156.88,251.88  "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M156.75,214.71v37.04h-29.5v-13.39l16.9-18.15L156.75,214.71 M157,214.33L144,220l-17,18.26V252h30 V214.33L157,214.33z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030445765623076434330000017153326472551411380_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.5,
    y1: 205.125,
    x2: 175.5,
    y2: 251.875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58595B"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000030445765623076434330000017153326472551411380_)",
    d: "M161.12,251.88v-46.75h18.16 c1.36,1.43,3.03,2.64,4.87,3.56c3.53,1.76,5.72,5.31,5.72,9.25v33.93H161.12z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M179.18,205.25c1.44,1.45,3.1,2.64,4.92,3.55c3.49,1.74,5.65,5.25,5.65,9.14v33.81h-28.5v-46.5H179.18  M179.29,205H161v47h29v-34.06c0-3.99-2.22-7.58-5.79-9.37C182.35,207.64,180.7,206.43,179.29,205L179.29,205z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057140760998879707300000002766865147358194569_",
    gradientUnits: "userSpaceOnUse",
    x1: 334,
    y1: 205.125,
    x2: 334,
    y2: 251.875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58595B"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 317.12,
    y: 205.12,
    fill: "url(#SVGID_00000057140760998879707300000002766865147358194569_)",
    width: 33.75,
    height: 46.75
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M350.75,205.25v46.5h-33.5v-46.5H350.75 M351,205h-34v47h34V205L351,205z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072961302099107777290000003143158475108432046_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.1143,
    y1: 271.875,
    x2: 149.1143,
    y2: 256.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000072961302099107777290000003143158475108432046_)",
    d: "M108.12,271.88v-15.75h81.75V270 c0,0.61,0.08,1.24,0.23,1.88H108.12z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M189.75,256.25V270c0,0.57,0.07,1.16,0.2,1.75h-81.7v-15.5H189.75 M190,256h-82v16h82.26 c-0.17-0.64-0.26-1.31-0.26-2V256L190,256z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177485964981744113680000012055909354810189472_",
    gradientUnits: "userSpaceOnUse",
    x1: 352.7871,
    y1: 271.875,
    x2: 352.7871,
    y2: 256.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000177485964981744113680000012055909354810189472_)",
    d: "M316.9,271.88c0.15-0.63,0.23-1.26,0.23-1.88 v-13.88h42.81c0.29,3.41,1.64,6.52,3.92,9.02c2.93,3.21,6.99,4.98,11.43,4.98h11.33c0.54,0.56,1.24,1.15,2.06,1.75H316.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M359.82,256.25c0.31,3.39,1.67,6.49,3.94,8.98c2.95,3.24,7.05,5.02,11.53,5.02h11.23 c0.52,0.5,1.11,0.99,1.78,1.5h-71.25c0.13-0.59,0.2-1.18,0.2-1.75v-13.75H359.82 M360.05,256H317v14c0,0.69-0.1,1.36-0.26,2 h72.33c-0.86-0.61-1.68-1.26-2.45-2h-11.33c-4.41,0-8.44-1.75-11.34-4.94C361.64,262.53,360.31,259.39,360.05,256L360.05,256z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001622542328635450990000007698549952665283257_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 276.0938,
    x2: 256,
    y2: 299.875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58595B"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000001622542328635450990000007698549952665283257_)",
    d: "M153,299.88c-6.55,0-11.88-5.33-11.88-11.88 s5.33-11.88,11.88-11.88h39.73c0.29,0.3,0.7,0.59,1.15,0.86v19.14h119.25v-19.14c0.45-0.27,0.86-0.56,1.23-0.89l44.64,0.03 c6.55,0,11.88,5.33,11.88,11.88s-5.33,11.88-11.88,11.88H153z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M359,276.25c6.48,0,11.75,5.27,11.75,11.75s-5.27,11.75-11.75,11.75H153c-6.48,0-11.75-5.27-11.75-11.75 s5.27-11.75,11.75-11.75h39.63c0.34,0.29,0.71,0.56,1.12,0.8V296v0.25H194h119h0.25V296v-18.95c0.4-0.24,0.78-0.51,1.12-0.8H359  M359,276h-44.73c-0.39,0.34-0.82,0.65-1.27,0.91V296H194v-19.09c-0.45-0.26-0.88-0.57-1.27-0.91H153c-6.63,0-12,5.37-12,12 c0,6.63,5.37,12,12,12h206c6.63,0,12-5.37,12-12C371,281.37,365.63,276,359,276L359,276z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124859808915949597600000004718557761359541437_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.5,
    y1: 220.125,
    x2: 253.5,
    y2: 227.875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 198.12,
    y: 220.12,
    fill: "url(#SVGID_00000124859808915949597600000004718557761359541437_)",
    width: 110.75,
    height: 7.75
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M308.75,220.25v7.5h-110.5v-7.5H308.75 M309,220H198v8h111V220L309,220z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161592749516152743440000000714099571279228568_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.125,
    y1: 165,
    x2: 304.875,
    y2: 165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58595B"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 206.12,
    y: 155.12,
    fill: "url(#SVGID_00000161592749516152743440000000714099571279228568_)",
    width: 98.75,
    height: 19.75
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M304.75,155.25v19.5h-98.5v-19.5H304.75 M305,155h-99v20h99V155L305,155z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004515480629532336030000011563872442636516480_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.5,
    y1: 240.125,
    x2: 253.5,
    y2: 247.875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000004515480629532336030000011563872442636516480_)",
    d: "M206.22,247.88c-2.26,0-4.09-1.84-4.09-4.09 v-3.66h102.75v3.66c0,2.26-1.84,4.09-4.09,4.09H206.22z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M304.75,240.25v3.53c0,2.19-1.78,3.97-3.97,3.97h-94.56c-2.19,0-3.97-1.78-3.97-3.97v-3.53H304.75  M305,240H202v3.78c0,2.33,1.89,4.22,4.22,4.22h94.56c2.33,0,4.22-1.89,4.22-4.22V240L305,240z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M180,36.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46s4.21-0.6,4.88-1.46V35 C184.88,36.02,182.64,36.88,180,36.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M184.75,31.97V35c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S183.92,32.74,184.75,31.97 M185,31c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V31L185,31z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M180,32.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S182.64,32.88,180,32.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M180,29.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S177.2,29.25,180,29.25 M180,29c-2.76,0-5,0.9-5,2c0,1.1,2.24,2,5,2s5-0.9,5-2C185,29.9,182.76,29,180,29L180,29z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M178.12,56.98c-0.01-3.5-3.31-7.84-8.04-10.56c-0.11-0.99-0.5-1.89-1.15-2.66 c2.33,1.42,6.42,2.37,11.06,2.37c3.83,0,7.43-0.64,9.92-1.76c0,0.02-0.01,0.04-0.01,0.05c-4.74,2.73-8.04,7.08-8.04,10.58v1.98 c-0.62-0.07-1.25-0.11-1.88-0.11S178.74,56.91,178.12,56.98z M167.12,42.28V42c0.08,0.15,0.17,0.3,0.28,0.45 C167.31,42.39,167.22,42.33,167.12,42.28z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M169.42,44.2c2.4,1.25,6.21,2.05,10.58,2.05c3.3,0,6.44-0.47,8.85-1.32c-4.23,2.76-7.1,6.78-7.1,10.07 v1.84c-0.58-0.06-1.17-0.09-1.75-0.09c-0.58,0-1.17,0.03-1.75,0.09c-0.1-3.5-3.37-7.79-8.05-10.5 C170.11,45.56,169.84,44.85,169.42,44.2 M167,41v1.35c1.72,0.96,2.8,2.4,2.97,4.14c4.6,2.64,8.03,6.97,8.03,10.51v0.12 c0.64-0.08,1.3-0.12,2-0.12s1.36,0.04,2,0.12V55c0-3.53,3.43-7.87,8.03-10.51c0.01-0.12,0.04-0.23,0.06-0.34 C187.7,45.28,184.07,46,180,46C172.82,46,167,43.76,167,41L167,41z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M180,45.88c-7.1,0-12.88-2.19-12.88-4.88c0-1.9,3.01-5.86,7.75-7.82V35c0,1.19,2.25,2.12,5.12,2.12 s5.12-0.93,5.12-2.12v-1.82c4.02,1.66,7.06,4.96,7.65,7.15c-1.55,0.92-2.51,2.2-2.79,3.73C187.51,45.22,183.88,45.88,180,45.88 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M185.25,33.37c3.84,1.65,6.75,4.78,7.37,6.91c-1.51,0.92-2.46,2.19-2.76,3.7 c-2.45,1.13-6.03,1.77-9.87,1.77c-6.91,0-12.75-2.18-12.75-4.75c0-1.8,2.98-5.69,7.5-7.63V35c0,1.26,2.31,2.25,5.25,2.25 c2.94,0,5.25-0.99,5.25-2.25V33.37 M185,33v2c0,1.1-2.24,2-5,2s-5-0.9-5-2v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5 c4.07,0,7.7-0.72,10.09-1.85c0.27-1.56,1.27-2.86,2.83-3.75C192.39,38.21,189.28,34.7,185,33L185,33z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122684059710788076910000007804591289493235104_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.2662,
    y1: 53.9342,
    x2: 182.7224,
    y2: 53.9342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000122684059710788076910000007804591289493235104_)",
    d: "M178,56.97c0.37,0.01,0.74,0.03,1.12,0.03 c0.99,0,1.94-0.07,2.88-0.16V55c0-0.96,0.26-1.98,0.72-3.01c-2.69-0.04-5.22-0.43-7.46-1.12 C176.95,52.87,177.99,55.03,178,56.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152951465773732588150000010105423315426225081_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.3226,
    y1: 49.6044,
    x2: 186.1039,
    y2: 49.6044
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000152951465773732588150000010105423315426225081_)",
    d: "M176.21,52.1c1.49,0.25,3.05,0.4,4.67,0.4 c0.56,0,1.1-0.02,1.65-0.05c0.67-1.71,1.92-3.47,3.57-5.04c-1.82,0.37-3.9,0.59-6.1,0.59c-2.47,0-4.78-0.27-6.75-0.73 c-1.02-0.13-1.99-0.32-2.93-0.56C172.75,48.17,174.83,50.09,176.21,52.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M218,34.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46s4.21-0.6,4.88-1.46V33 C222.88,34.02,220.64,34.88,218,34.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M222.75,29.97V33c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S221.92,30.74,222.75,29.97 M223,29c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V29L223,29z"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M218,30.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S220.64,30.88,218,30.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M218,27.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S215.2,27.25,218,27.25 M218,27c-2.76,0-5,0.9-5,2s2.24,2,5,2s5-0.9,5-2S220.76,27,218,27L218,27z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000182067123657313930000018149841188301908877_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.5242,
    y1: 54.9824,
    x2: 216.5242,
    y2: 39.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000000182067123657313930000018149841188301908877_)",
    d: "M216.12,54.98 c-0.01-3.5-3.31-7.84-8.04-10.56c-0.11-0.99-0.5-1.89-1.15-2.66c2.33,1.42,6.42,2.37,11.06,2.37c3.83,0,7.43-0.64,9.92-1.76 c0,0.02-0.01,0.04-0.01,0.05c-4.74,2.73-8.04,7.08-8.04,10.58v1.98c-0.62-0.07-1.25-0.11-1.88-0.11S216.74,54.91,216.12,54.98z  M205.12,40.28V40c0.08,0.15,0.17,0.3,0.28,0.45C205.31,40.39,205.22,40.33,205.12,40.28z"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M207.42,42.2c2.4,1.25,6.21,2.05,10.58,2.05c3.3,0,6.44-0.47,8.85-1.32c-4.23,2.76-7.1,6.78-7.1,10.07 v1.84c-0.58-0.06-1.17-0.09-1.75-0.09c-0.58,0-1.17,0.03-1.75,0.09c-0.1-3.5-3.37-7.79-8.05-10.5 C208.11,43.56,207.84,42.85,207.42,42.2 M205,39v1.35c1.72,0.96,2.8,2.4,2.97,4.14c4.6,2.64,8.03,6.97,8.03,10.51v0.12 c0.64-0.08,1.3-0.12,2-0.12s1.36,0.04,2,0.12V53c0-3.53,3.43-7.87,8.03-10.51c0.01-0.12,0.04-0.23,0.06-0.34 C225.7,43.28,222.07,44,218,44C210.82,44,205,41.76,205,39L205,39z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137118954149648549970000016555065377525094045_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.9475,
    y1: 43.875,
    x2: 217.9475,
    y2: 31.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000137118954149648549970000016555065377525094045_)",
    d: "M218,43.88c-7.1,0-12.88-2.19-12.88-4.88 c0-1.9,3.01-5.86,7.75-7.82V33c0,1.19,2.25,2.12,5.12,2.12s5.12-0.93,5.12-2.12v-1.82c4.02,1.66,7.06,4.96,7.65,7.15 c-1.55,0.92-2.51,2.2-2.79,3.73C225.51,43.22,221.88,43.88,218,43.88z"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M223.25,31.37c3.84,1.65,6.75,4.78,7.37,6.91c-1.51,0.92-2.46,2.19-2.76,3.7 c-2.45,1.13-6.03,1.77-9.87,1.77c-6.91,0-12.75-2.18-12.75-4.75c0-1.8,2.98-5.69,7.5-7.63V33c0,1.26,2.31,2.25,5.25,2.25 c2.94,0,5.25-0.99,5.25-2.25V31.37 M223,31v2c0,1.1-2.24,2-5,2s-5-0.9-5-2v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5 c4.07,0,7.7-0.72,10.09-1.85c0.27-1.56,1.27-2.86,2.83-3.75C230.39,36.21,227.28,32.7,223,31L223,31z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002344846241840578700000002054981663081297822_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.2662,
    y1: 51.9342,
    x2: 220.7224,
    y2: 51.9342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000002344846241840578700000002054981663081297822_)",
    d: "M216,54.97c0.37,0.01,0.74,0.03,1.12,0.03 c0.99,0,1.94-0.07,2.88-0.16V53c0-0.96,0.26-1.98,0.72-3.01c-2.69-0.04-5.22-0.43-7.46-1.12 C214.95,50.87,215.99,53.03,216,54.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055690995351354420700000002760081270671506079_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.3226,
    y1: 47.6044,
    x2: 224.1039,
    y2: 47.6044
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000055690995351354420700000002760081270671506079_)",
    d: "M214.21,50.1c1.49,0.25,3.05,0.4,4.67,0.4 c0.56,0,1.1-0.02,1.65-0.05c0.67-1.71,1.92-3.47,3.57-5.04c-1.82,0.37-3.9,0.59-6.1,0.59c-2.47,0-4.78-0.27-6.75-0.73 c-1.02-0.13-1.99-0.32-2.93-0.56C210.75,46.17,212.83,48.09,214.21,50.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M256,32.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46 c2.31,0,4.21-0.6,4.88-1.46V31C260.88,32.02,258.64,32.88,256,32.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M260.75,27.97V31c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S259.92,28.74,260.75,27.97 M261,27c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V27L261,27z"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M256,28.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S258.64,28.88,256,28.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M256,25.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S253.2,25.25,256,25.25 M256,25c-2.76,0-5,0.9-5,2s2.24,2,5,2c2.76,0,5-0.9,5-2S258.76,25,256,25L256,25z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066501673295625801980000004167383805322117548_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 52.9824,
    x2: 256,
    y2: 37.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58595B"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000066501673295625801980000004167383805322117548_)",
    d: "M254.12,52.98 c-0.01-3.5-3.31-7.84-8.04-10.56c-0.11-0.99-0.5-1.89-1.15-2.66c2.33,1.42,6.42,2.37,11.06,2.37c4.64,0,8.73-0.95,11.06-2.37 c-0.65,0.77-1.04,1.67-1.15,2.66c-4.73,2.73-8.03,7.06-8.04,10.57c-0.62-0.07-1.25-0.11-1.88-0.11 C255.38,52.88,254.74,52.91,254.12,52.98z M268.59,38.45c0.11-0.15,0.2-0.3,0.28-0.45v0.28 C268.78,38.33,268.69,38.39,268.59,38.45z M243.12,38.28V38c0.08,0.15,0.17,0.3,0.28,0.45 C243.31,38.39,243.22,38.33,243.12,38.28z"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M266.58,40.2c-0.42,0.65-0.68,1.37-0.78,2.14c-4.67,2.72-7.95,7-8.05,10.5 c-0.58-0.06-1.17-0.09-1.75-0.09s-1.17,0.03-1.75,0.09c-0.1-3.5-3.37-7.79-8.05-10.5c-0.1-0.78-0.36-1.49-0.78-2.14 c2.4,1.25,6.21,2.05,10.58,2.05S264.18,41.45,266.58,40.2 M269,37c0,2.76-5.82,5-13,5s-13-2.24-13-5v1.35 c1.72,0.96,2.8,2.4,2.97,4.14c4.6,2.64,8.03,6.97,8.03,10.51v0.12c0.64-0.08,1.3-0.12,2-0.12s1.36,0.04,2,0.12V53 c0-3.53,3.43-7.87,8.03-10.51c0.17-1.75,1.24-3.18,2.97-4.14V37L269,37z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026847862194965271980000017564113409942132907_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 41.875,
    x2: 256,
    y2: 29.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58595B"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000026847862194965271980000017564113409942132907_)",
    d: "M256,41.88c-7.1,0-12.88-2.19-12.88-4.88 c0-1.9,3.01-5.86,7.75-7.82V31c0,1.19,2.25,2.12,5.12,2.12s5.12-0.93,5.12-2.12v-1.82c4.74,1.96,7.75,5.91,7.75,7.82 C268.88,39.69,263.1,41.88,256,41.88z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M261.25,29.37c4.52,1.94,7.5,5.83,7.5,7.63c0,2.57-5.84,4.75-12.75,4.75 c-6.91,0-12.75-2.18-12.75-4.75c0-1.8,2.98-5.69,7.5-7.63V31c0,1.26,2.31,2.25,5.25,2.25c2.94,0,5.25-0.99,5.25-2.25V29.37  M261,29v2c0,1.1-2.24,2-5,2s-5-0.9-5-2v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5s13-2.24,13-5 C269,34.92,265.7,30.87,261,29L261,29z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130648540010343213490000014742693571567655813_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.2662,
    y1: 49.9342,
    x2: 259.8744,
    y2: 49.9342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000130648540010343213490000014742693571567655813_)",
    d: "M254,52.97c0.37,0.01,0.74,0.03,1.12,0.03 c0.99,0,1.95-0.07,2.89-0.16c0.04-1.54,0.73-3.23,1.86-4.86c-0.25,0.01-0.5,0.02-0.76,0.02c-2.83,0-5.5-0.41-7.85-1.13 C252.95,48.87,253.99,51.03,254,52.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133513455775512214920000005142075213801502110_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.3226,
    y1: 45.3258,
    x2: 266.0876,
    y2: 45.3258
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000133513455775512214920000005142075213801502110_)",
    d: "M252.21,48.1c1.49,0.25,3.05,0.4,4.67,0.4 c0.94,0,1.85-0.06,2.74-0.14c1.44-2.2,3.72-4.32,6.41-5.86c0.01-0.12,0.04-0.23,0.06-0.34C263.7,43.28,260.07,44,256,44 c-2.47,0-4.78-0.27-6.75-0.73c-1.02-0.13-1.99-0.32-2.93-0.56C248.75,44.17,250.83,46.09,252.21,48.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M294,34.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46s4.21-0.6,4.88-1.46V33 C298.88,34.02,296.64,34.88,294,34.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M298.75,29.97V33c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S297.92,30.74,298.75,29.97 M299,29c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V29L299,29z"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M294,30.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S296.64,30.88,294,30.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M294,27.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S291.2,27.25,294,27.25 M294,27c-2.76,0-5,0.9-5,2s2.24,2,5,2s5-0.9,5-2S296.76,27,294,27L294,27z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081611070191788236260000001368518516193489846_",
    gradientUnits: "userSpaceOnUse",
    x1: 294,
    y1: 43.875,
    x2: 294,
    y2: 31.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405,
    style: {
      stopColor: "#9AB1DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#567DC7"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000081611070191788236260000001368518516193489846_)",
    d: "M294,43.88c-7.1,0-12.88-2.19-12.88-4.88 c0-1.9,3.01-5.86,7.75-7.82V33c0,1.19,2.25,2.12,5.12,2.12s5.12-0.93,5.12-2.12v-1.82c4.74,1.96,7.75,5.91,7.75,7.82 C306.88,41.69,301.1,43.88,294,43.88z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3F64",
    d: "M299.25,31.37c4.52,1.94,7.5,5.83,7.5,7.63c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75 c0-1.8,2.98-5.69,7.5-7.63V33c0,1.26,2.31,2.25,5.25,2.25s5.25-0.99,5.25-2.25V31.37 M299,31v2c0,1.1-2.24,2-5,2s-5-0.9-5-2 v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5s13-2.24,13-5C307,36.92,303.7,32.87,299,31L299,31z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001647181212874340690000016093268110310022065_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.9443,
    y1: 52.1557,
    x2: 297.8744,
    y2: 52.1557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000001647181212874340690000016093268110310022065_)",
    d: "M292,53v1.97c0.37,0.01,0.74,0.03,1.12,0.03 c0.99,0,1.95-0.07,2.89-0.16c0.04-1.54,0.73-3.23,1.86-4.86c-0.25,0.01-0.5,0.02-0.76,0.02c-2.18,0-4.26-0.25-6.17-0.69 C291.62,50.57,292,51.83,292,53z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059290237061240134190000017482813683882419600_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.8755,
    y1: 47.3258,
    x2: 304.0876,
    y2: 47.3258
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000059290237061240134190000017482813683882419600_)",
    d: "M291.4,50.27c1.13,0.14,2.28,0.23,3.48,0.23 c0.94,0,1.85-0.06,2.74-0.14c1.44-2.2,3.72-4.32,6.41-5.86c0.01-0.12,0.04-0.23,0.06-0.34C301.7,45.28,298.07,46,294,46 c-2.22,0-4.3-0.23-6.12-0.61C289.48,46.91,290.72,48.61,291.4,50.27z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026140138459121228420000000722147096418277311_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.4761,
    y1: 54.9824,
    x2: 295.4761,
    y2: 39.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405,
    style: {
      stopColor: "#9AB1DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#567DC7"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000026140138459121228420000000722147096418277311_)",
    d: "M295.88,54.98 c-0.62-0.07-1.25-0.11-1.88-0.11s-1.26,0.04-1.88,0.11V53c0-3.5-3.3-7.85-8.04-10.58c0-0.02-0.01-0.03-0.01-0.05 c2.49,1.12,6.09,1.76,9.92,1.76c4.64,0,8.73-0.95,11.06-2.37c-0.65,0.77-1.04,1.67-1.15,2.66 C299.19,47.15,295.89,51.48,295.88,54.98z M306.59,40.45c0.11-0.15,0.2-0.3,0.28-0.45v0.28 C306.78,40.33,306.69,40.39,306.59,40.45z"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2B3F64",
    d: "M304.58,42.2c-0.42,0.65-0.68,1.37-0.78,2.14c-4.67,2.72-7.95,7-8.05,10.5 c-0.58-0.06-1.17-0.09-1.75-0.09c-0.58,0-1.17,0.03-1.75,0.09V53c0-3.29-2.87-7.31-7.1-10.07c2.41,0.85,5.54,1.32,8.85,1.32 C298.37,44.25,302.18,43.45,304.58,42.2 M307,39c0,2.76-5.82,5-13,5c-4.07,0-7.7-0.72-10.09-1.85 c0.02,0.11,0.04,0.23,0.06,0.34c4.6,2.64,8.03,6.97,8.03,10.51v2v0.12c0.64-0.08,1.3-0.12,2-0.12s1.36,0.04,2,0.12V55 c0-3.53,3.43-7.87,8.03-10.51c0.17-1.75,1.24-3.18,2.97-4.14V39L307,39z"
  }))))), /*#__PURE__*/React.createElement("g", null, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M332,36.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46s4.21-0.6,4.88-1.46V35 C336.88,36.02,334.64,36.88,332,36.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M336.75,31.97V35c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S335.92,32.74,336.75,31.97 M337,31c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V31L337,31z"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M332,32.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S334.64,32.88,332,32.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M332,29.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S329.2,29.25,332,29.25 M332,29c-2.76,0-5,0.9-5,2c0,1.1,2.24,2,5,2s5-0.9,5-2C337,29.9,334.76,29,332,29L332,29z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098221702370270340350000004811500217797680272_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.4761,
    y1: 56.9824,
    x2: 333.4761,
    y2: 41.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9EB8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#319941"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000098221702370270340350000004811500217797680272_)",
    d: "M333.88,56.98 c-0.62-0.07-1.25-0.11-1.88-0.11s-1.26,0.04-1.88,0.11V55c0-3.5-3.3-7.85-8.04-10.58c0-0.02-0.01-0.03-0.01-0.05 c2.49,1.12,6.09,1.76,9.92,1.76c4.64,0,8.73-0.95,11.06-2.37c-0.65,0.77-1.04,1.67-1.15,2.66 C337.19,49.15,333.89,53.48,333.88,56.98z M344.59,42.45c0.11-0.15,0.2-0.3,0.28-0.45v0.28 C344.78,42.33,344.69,42.39,344.59,42.45z"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#319941",
    d: "M342.58,44.2c-0.42,0.65-0.68,1.37-0.78,2.14c-4.67,2.72-7.95,7-8.05,10.5 c-0.58-0.06-1.17-0.09-1.75-0.09c-0.58,0-1.17,0.03-1.75,0.09V55c0-3.29-2.87-7.31-7.1-10.07c2.41,0.85,5.54,1.32,8.85,1.32 C336.37,46.25,340.18,45.45,342.58,44.2 M345,41c0,2.76-5.82,5-13,5c-4.07,0-7.7-0.72-10.09-1.85 c0.02,0.11,0.04,0.23,0.06,0.34c4.6,2.64,8.03,6.97,8.03,10.51v2v0.12c0.64-0.08,1.3-0.12,2-0.12s1.36,0.04,2,0.12V57 c0-3.53,3.43-7.87,8.03-10.51c0.17-1.75,1.24-3.18,2.97-4.14V41L345,41z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100348791646753241090000016956172817524670891_",
    gradientUnits: "userSpaceOnUse",
    x1: 332,
    y1: 45.875,
    x2: 332,
    y2: 33.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9EB8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#319941"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000100348791646753241090000016956172817524670891_)",
    d: "M332,45.88c-7.1,0-12.88-2.19-12.88-4.88 c0-1.9,3.01-5.86,7.75-7.82V35c0,1.19,2.25,2.12,5.12,2.12s5.12-0.93,5.12-2.12v-1.82c4.74,1.96,7.75,5.91,7.75,7.82 C344.88,43.69,339.1,45.88,332,45.88z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#319941",
    d: "M337.25,33.37c4.52,1.94,7.5,5.83,7.5,7.63c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75 c0-1.8,2.98-5.69,7.5-7.63V35c0,1.26,2.31,2.25,5.25,2.25s5.25-0.99,5.25-2.25V33.37 M337,33v2c0,1.1-2.24,2-5,2s-5-0.9-5-2 v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5s13-2.24,13-5C345,38.92,341.7,34.87,337,33L337,33z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065758721611186729940000005121962980351166345_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.9443,
    y1: 54.1557,
    x2: 335.8744,
    y2: 54.1557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000065758721611186729940000005121962980351166345_)",
    d: "M330,55v1.97c0.37,0.01,0.74,0.03,1.12,0.03 c0.99,0,1.95-0.07,2.89-0.16c0.04-1.54,0.73-3.23,1.86-4.86c-0.25,0.01-0.5,0.02-0.76,0.02c-2.18,0-4.26-0.25-6.17-0.69 C329.62,52.57,330,53.83,330,55z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048482684684913847190000009743450692663123601_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.8755,
    y1: 49.3258,
    x2: 342.0876,
    y2: 49.3258
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000048482684684913847190000009743450692663123601_)",
    d: "M329.4,52.27c1.13,0.14,2.28,0.23,3.48,0.23 c0.94,0,1.85-0.06,2.74-0.14c1.44-2.2,3.72-4.32,6.41-5.86c0.01-0.12,0.04-0.23,0.06-0.34C339.7,47.28,336.07,48,332,48 c-2.22,0-4.3-0.23-6.12-0.61C327.48,48.91,328.72,50.61,329.4,52.27z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M161,52.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46s4.21-0.6,4.88-1.46V51 C165.88,52.02,163.64,52.88,161,52.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M165.75,47.97V51c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S164.92,48.74,165.75,47.97 M166,47c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V47L166,47z"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M161,48.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S163.64,48.88,161,48.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M161,45.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S158.2,45.25,161,45.25 M161,45c-2.76,0-5,0.9-5,2s2.24,2,5,2s5-0.9,5-2S163.76,45,161,45L161,45z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128449067011522269830000009730552952599415938_",
    gradientUnits: "userSpaceOnUse",
    x1: 161,
    y1: 98.875,
    x2: 161,
    y2: 57.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCF5C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B9EB8F"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000128449067011522269830000009730552952599415938_)",
    d: "M161,98.88c-7.1,0-12.88-2.19-12.88-4.88V58 c1.19,2.35,6.51,4.13,12.88,4.13c4.64,0,8.73-0.95,11.06-2.37c-0.65,0.77-1.04,1.67-1.15,2.66c-4.74,2.73-8.04,7.08-8.04,10.58 v25.82C162.26,98.85,161.64,98.88,161,98.88z M173.59,58.44c0.11-0.15,0.2-0.29,0.28-0.45v0.28 C173.78,58.33,173.69,58.39,173.59,58.44z"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7EAD56",
    d: "M148.25,58.46c1.56,2.21,6.6,3.79,12.75,3.79c4.37,0,8.18-0.8,10.58-2.05 c-0.42,0.65-0.68,1.37-0.78,2.14c-4.74,2.76-8.05,7.13-8.05,10.66v4.16v0.45v2.63v5.73v4.18v0.45v2.63v5.45 c-0.64,0.03-1.21,0.05-1.75,0.05c-6.91,0-12.75-2.18-12.75-4.75V58.46 M174,57c0,2.76-5.82,5-13,5s-13-2.24-13-5v37 c0,2.76,5.82,5,13,5c0.68,0,1.35-0.03,2-0.07v-5.69v-2.63v-0.45v-4.18v-5.73v-2.63v-0.45V73c0-3.53,3.43-7.87,8.03-10.51 c0.17-1.75,1.24-3.18,2.97-4.14V57L174,57z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100362849526935543170000011430623801522928543_",
    gradientUnits: "userSpaceOnUse",
    x1: 161,
    y1: 61.875,
    x2: 161,
    y2: 49.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCF5C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B9EB8F"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000100362849526935543170000011430623801522928543_)",
    d: "M161,61.88c-7.1,0-12.88-2.19-12.88-4.88 c0-1.9,3.01-5.86,7.75-7.82V51c0,1.19,2.25,2.12,5.12,2.12s5.12-0.93,5.12-2.12v-1.82c4.74,1.96,7.75,5.91,7.75,7.82 C173.88,59.69,168.1,61.88,161,61.88z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#7EAD56",
    d: "M166.25,49.37c4.52,1.94,7.5,5.83,7.5,7.63c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75 c0-1.8,2.98-5.69,7.5-7.63V51c0,1.26,2.31,2.25,5.25,2.25s5.25-0.99,5.25-2.25V49.37 M166,49v2c0,1.1-2.24,2-5,2s-5-0.9-5-2 v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5s13-2.24,13-5C174,54.92,170.7,50.87,166,49L166,49z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022545147140187378710000008596462320375091341_",
    gradientUnits: "userSpaceOnUse",
    x1: 148,
    y1: 93.0769,
    x2: 163,
    y2: 93.0769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000022545147140187378710000008596462320375091341_)",
    d: "M163,98.84v-4.86 c-7.01-0.27-12.86-3.04-15-6.81V94c0,2.69,5.55,4.89,12.49,4.99C161.35,98.98,162.18,98.92,163,98.84z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083794093586583351930000015444775222523944362_",
    gradientUnits: "userSpaceOnUse",
    x1: 148,
    y1: 80.0819,
    x2: 163,
    y2: 80.0819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000083794093586583351930000015444775222523944362_)",
    d: "M163,85.84v-4.87 c-7.01-0.27-12.86-3.04-15-6.81v8.82c3.08,1.85,7.36,3.02,12.12,3.02C161.1,86,162.06,85.93,163,85.84z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173125195005093430260000002125392989035257488_",
    gradientUnits: "userSpaceOnUse",
    x1: 148,
    y1: 67.0819,
    x2: 164.8746,
    y2: 67.0819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000173125195005093430260000002125392989035257488_)",
    d: "M163.01,72.84 c0.04-1.54,0.73-3.23,1.86-4.86c-0.25,0.01-0.5,0.02-0.76,0.02c-7.51,0-13.87-2.87-16.12-6.84v8.82 c3.08,1.85,7.36,3.02,12.12,3.02C161.11,73,162.07,72.93,163.01,72.84z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142177397229171264950000006107466232301997489_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.8125,
    y1: 91.0586,
    x2: 172.199,
    y2: 91.0586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000142177397229171264950000006107466232301997489_)",
    d: "M148,87.62v2.63 c3.07,2.57,8.14,4.25,13.88,4.25c0.38,0,0.75-0.02,1.12-0.03v-1.22v-2.63v-0.45v-1.13c-1.62,0.3-3.33,0.47-5.12,0.47 C154.19,89.5,150.78,88.8,148,87.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052809187990992517300000009786840707600189614_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.8125,
    y1: 78.0586,
    x2: 172.199,
    y2: 78.0586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000052809187990992517300000009786840707600189614_)",
    d: "M148,74.62v2.63 c3.07,2.57,8.14,4.25,13.88,4.25c0.38,0,0.75-0.02,1.12-0.03v-1.22v-2.63v-0.45v-1.13c-1.62,0.3-3.33,0.47-5.12,0.47 C154.19,76.5,150.78,75.8,148,74.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025400463934530153980000014280866729074601130_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.8125,
    y1: 65.0586,
    x2: 172.199,
    y2: 65.0586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000025400463934530153980000014280866729074601130_)",
    d: "M161,64c-2.47,0-4.78-0.27-6.75-0.73 c-2.3-0.3-4.41-0.87-6.25-1.65v2.63c3.07,2.57,8.14,4.25,13.88,4.25c0.94,0,1.85-0.06,2.74-0.14 c1.44-2.2,3.72-4.32,6.41-5.86c0.01-0.12,0.04-0.23,0.06-0.34C168.7,63.28,165.07,64,161,64z"
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M160.9,105.87c-9.26-0.03-16.78-4.45-16.78-9.87c0-2.25,1.33-4.44,3.75-6.2V94 c0,2.83,5.89,5.12,13.12,5.12c0.64,0,1.26-0.02,1.88-0.06v4.55C162.17,104.27,161.49,105.04,160.9,105.87z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M147.75,90.05V94c0,2.94,5.82,5.25,13.25,5.25c0.54,0,1.12-0.02,1.75-0.05v3.96v0.4 c-0.71,0.66-1.35,1.39-1.91,2.19c-9.16-0.05-16.59-4.41-16.59-9.75C144.25,93.85,145.49,91.76,147.75,90.05 M148,89.56 c-2.49,1.74-4,3.98-4,6.44c0,5.52,7.6,9.99,16.97,10c0.57-0.82,1.24-1.6,2.03-2.33v-0.05v-0.45v-4.18v-0.05 c-0.65,0.04-1.32,0.07-2,0.07c-7.18,0-13-2.24-13-5V89.56L148,89.56z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180326078664397263560000009412039964062152619_",
    gradientUnits: "userSpaceOnUse",
    x1: 199,
    y1: 96.875,
    x2: 199,
    y2: 55.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5B158"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5822,
    style: {
      stopColor: "#F7C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9D09B"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000180326078664397263560000009412039964062152619_)",
    d: "M199,96.88c-0.64,0-1.26-0.02-1.88-0.06V73 c0-3.5-3.3-7.85-8.04-10.58c-0.19-1.71-1.21-3.14-2.96-4.14V56c1.19,2.35,6.51,4.13,12.88,4.13c4.64,0,8.73-0.95,11.06-2.37 c-0.65,0.77-1.04,1.67-1.15,2.66c-4.74,2.73-8.04,7.08-8.04,10.58v25.82C200.26,96.85,199.64,96.88,199,96.88z M211.59,56.44 c0.11-0.15,0.2-0.29,0.28-0.45v0.28C211.78,56.33,211.69,56.39,211.59,56.44z"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B88542",
    d: "M186.25,56.46c1.56,2.21,6.6,3.79,12.75,3.79c4.37,0,8.18-0.8,10.58-2.05 c-0.42,0.65-0.68,1.37-0.78,2.14c-4.74,2.76-8.05,7.13-8.05,10.66v4.16v0.45v2.63v5.73v4.18v0.45v2.63v5.45 c-0.64,0.03-1.21,0.05-1.75,0.05s-1.11-0.02-1.75-0.05v-1.58v-0.64v-8.82v-0.91v-2.63v-0.64V75v-2c0-3.53-3.3-7.9-8.05-10.66 c-0.21-1.71-1.23-3.13-2.95-4.14V56.46 M212,55c0,2.76-5.82,5-13,5s-13-2.24-13-5v3.35c1.72,0.96,2.8,2.4,2.97,4.14 c4.6,2.64,8.03,6.97,8.03,10.51v2v6.48v0.64v2.63v0.91v8.82v0.64v1.82c0.65,0.04,1.32,0.07,2,0.07s1.35-0.03,2-0.07v-5.69 v-2.63v-0.45v-4.18v-5.73v-2.63v-0.45V71c0-3.53,3.43-7.87,8.03-10.51c0.17-1.75,1.24-3.18,2.97-4.14V55L212,55z"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M199,50.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46s4.21-0.6,4.88-1.46V49 C203.88,50.02,201.64,50.88,199,50.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M203.75,45.97V49c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S202.92,46.74,203.75,45.97 M204,45c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V45L204,45z"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M199,46.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S201.64,46.88,199,46.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M199,43.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S196.2,43.25,199,43.25 M199,43c-2.76,0-5,0.9-5,2s2.24,2,5,2s5-0.9,5-2S201.76,43,199,43L199,43z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127762603094199072110000003445199179225296791_",
    gradientUnits: "userSpaceOnUse",
    x1: 199,
    y1: 59.875,
    x2: 199,
    y2: 47.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5B158"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5822,
    style: {
      stopColor: "#F7C179"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9D09B"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000127762603094199072110000003445199179225296791_)",
    d: "M199,59.88c-7.1,0-12.88-2.19-12.88-4.88 c0-1.9,3.01-5.86,7.75-7.82V49c0,1.19,2.25,2.12,5.12,2.12s5.12-0.93,5.12-2.12v-1.82c4.74,1.96,7.75,5.91,7.75,7.82 C211.88,57.69,206.1,59.88,199,59.88z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#B88542",
    d: "M204.25,47.37c4.52,1.94,7.5,5.83,7.5,7.63c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75 c0-1.8,2.98-5.69,7.5-7.63V49c0,1.26,2.31,2.25,5.25,2.25s5.25-0.99,5.25-2.25V47.37 M204,47v2c0,1.1-2.24,2-5,2s-5-0.9-5-2 v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5s13-2.24,13-5C212,52.92,208.7,48.87,204,47L204,47z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099639151010709681650000010608446209561405328_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.9355,
    y1: 66.6474,
    x2: 202.8746,
    y2: 66.6474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000099639151010709681650000010608446209561405328_)",
    d: "M188.97,62.49 c3.74,2.15,6.71,5.41,7.69,8.46c0.48,0.02,0.97,0.04,1.46,0.04c0.99,0,1.95-0.07,2.89-0.16c0.04-1.54,0.73-3.23,1.86-4.86 c-0.25,0.01-0.5,0.02-0.76,0.02c-5.33,0-10.07-1.45-13.18-3.71C188.94,62.36,188.96,62.43,188.97,62.49z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072983208039998146770000016129284256427669915_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.2507,
    y1: 63.3258,
    x2: 209.0876,
    y2: 63.3258
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000072983208039998146770000016129284256427669915_)",
    d: "M188.97,62.49 c1.56,0.89,2.98,1.98,4.18,3.17c2.07,0.53,4.33,0.84,6.74,0.84c0.94,0,1.85-0.06,2.74-0.14c1.44-2.2,3.72-4.32,6.41-5.86 c0.01-0.12,0.04-0.23,0.06-0.34C206.7,61.28,203.07,62,199,62c-2.47,0-4.78-0.27-6.75-0.73c-1.41-0.18-2.75-0.48-4-0.86 C188.64,61.04,188.89,61.74,188.97,62.49z"
  }))))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M198.9,103.87c-0.54,0-1.08-0.02-1.61-0.05l-0.02-0.07c-0.05-0.05-0.09-0.09-0.14-0.14v-6.55 c0.61,0.04,1.24,0.06,1.88,0.06s1.26-0.02,1.88-0.06v4.55C200.15,102.29,199.47,103.06,198.9,103.87z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M200.75,97.2v3.96v0.4c-0.73,0.67-1.37,1.41-1.92,2.19c-0.49,0-0.97-0.02-1.44-0.04l-0.04-0.04 c-0.03-0.03-0.07-0.07-0.1-0.1v-4.9v-0.91V97.2c0.63,0.03,1.21,0.05,1.75,0.05S200.12,97.23,200.75,97.2 M201,96.93 c-0.65,0.04-1.32,0.07-2,0.07s-1.35-0.03-2-0.07v0.81v0.91v5.01c0.1,0.09,0.19,0.19,0.28,0.28c0.55,0.03,1.11,0.05,1.68,0.05 c0.57-0.82,1.24-1.6,2.04-2.33v-0.05v-0.45v-4.18V96.93L201,96.93z"
  }))))), /*#__PURE__*/React.createElement("g", null, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M237,48.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46s4.21-0.6,4.88-1.46V47 C241.88,48.02,239.64,48.88,237,48.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M241.75,43.97V47c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S240.92,44.74,241.75,43.97 M242,43c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V43L242,43z"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M237,44.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S239.64,44.88,237,44.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M237,41.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S234.2,41.25,237,41.25 M237,41c-2.76,0-5,0.9-5,2s2.24,2,5,2s5-0.9,5-2S239.76,41,237,41L237,41z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165220067581848220180000012098359737224086956_",
    gradientUnits: "userSpaceOnUse",
    x1: 237,
    y1: 94.875,
    x2: 237,
    y2: 53.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E47D91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3954,
    style: {
      stopColor: "#DD5D76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    style: {
      stopColor: "#D5586F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7821,
    style: {
      stopColor: "#C04B5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A63C46"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000165220067581848220180000012098359737224086956_)",
    d: "M237,94.88c-0.64,0-1.26-0.02-1.88-0.06V71 c0-3.5-3.3-7.85-8.04-10.58c-0.19-1.71-1.21-3.14-2.96-4.14V54c1.19,2.35,6.51,4.13,12.88,4.13c4.64,0,8.73-0.95,11.06-2.37 c-0.65,0.77-1.04,1.67-1.15,2.66c-4.74,2.73-8.04,7.08-8.04,10.58v25.82C238.26,94.85,237.64,94.88,237,94.88z M249.59,54.44 c0.11-0.15,0.2-0.29,0.28-0.45v0.28C249.78,54.33,249.69,54.39,249.59,54.44z"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A63C46",
    d: "M224.25,54.46c1.56,2.21,6.6,3.79,12.75,3.79c4.37,0,8.18-0.8,10.58-2.05 c-0.42,0.65-0.68,1.37-0.78,2.14c-4.74,2.76-8.05,7.13-8.05,10.66v4.16v0.45v2.63v5.73v4.18v0.45v2.63v5.45 c-0.64,0.03-1.21,0.05-1.75,0.05s-1.11-0.02-1.75-0.05v-1.58v-0.64v-8.82v-0.91v-2.63v-0.64V73v-2c0-3.53-3.3-7.9-8.05-10.66 c-0.21-1.71-1.23-3.13-2.95-4.14V54.46 M250,53c0,2.76-5.82,5-13,5s-13-2.24-13-5v3.35c1.72,0.96,2.8,2.4,2.97,4.14 c4.6,2.64,8.03,6.97,8.03,10.51v2v6.48v0.64v2.63v0.91v8.82v0.64v1.82c0.65,0.04,1.32,0.07,2,0.07s1.35-0.03,2-0.07v-5.69 v-2.63v-0.45v-4.18v-5.73v-2.63v-0.45V69c0-3.53,3.43-7.87,8.03-10.51c0.17-1.75,1.24-3.18,2.97-4.14V53L250,53z"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M236.9,101.87c-0.54,0-1.08-0.02-1.61-0.05l-0.02-0.07c-0.05-0.05-0.09-0.09-0.14-0.14v-6.55 c0.61,0.04,1.24,0.06,1.88,0.06s1.26-0.02,1.88-0.06v4.55C238.15,100.29,237.47,101.06,236.9,101.87z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M238.75,95.2v3.96v0.4c-0.73,0.67-1.37,1.41-1.92,2.19c-0.49,0-0.97-0.02-1.44-0.04l-0.04-0.04 c-0.03-0.03-0.07-0.07-0.1-0.1v-4.9v-0.91V95.2c0.63,0.03,1.21,0.05,1.75,0.05S238.12,95.23,238.75,95.2 M239,94.93 c-0.65,0.04-1.32,0.07-2,0.07s-1.35-0.03-2-0.07v0.81v0.91v5.01c0.1,0.09,0.19,0.19,0.28,0.28c0.55,0.03,1.11,0.05,1.68,0.05 c0.57-0.82,1.24-1.6,2.04-2.33v-0.05v-0.45v-4.18V94.93L239,94.93z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039095690993716463920000005783443340142870948_",
    gradientUnits: "userSpaceOnUse",
    x1: 237,
    y1: 57.875,
    x2: 237,
    y2: 45.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E47D91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3954,
    style: {
      stopColor: "#DD5D76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    style: {
      stopColor: "#D5586F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7821,
    style: {
      stopColor: "#C04B5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A63C46"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000039095690993716463920000005783443340142870948_)",
    d: "M237,57.88c-7.1,0-12.88-2.19-12.88-4.88 c0-1.9,3.01-5.86,7.75-7.82V47c0,1.19,2.25,2.12,5.12,2.12s5.12-0.93,5.12-2.12v-1.82c4.74,1.96,7.75,5.91,7.75,7.82 C249.88,55.69,244.1,57.88,237,57.88z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#A63C46",
    d: "M242.25,45.37c4.52,1.94,7.5,5.83,7.5,7.63c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75 c0-1.8,2.98-5.69,7.5-7.63V47c0,1.26,2.31,2.25,5.25,2.25s5.25-0.99,5.25-2.25V45.37 M242,45v2c0,1.1-2.24,2-5,2s-5-0.9-5-2 v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5s13-2.24,13-5C250,50.92,246.7,46.87,242,45L242,45z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097460033048219077890000006930060315989278107_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.9355,
    y1: 64.6474,
    x2: 240.8746,
    y2: 64.6474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000097460033048219077890000006930060315989278107_)",
    d: "M226.97,60.49 c3.74,2.15,6.71,5.41,7.69,8.46c0.48,0.02,0.97,0.04,1.46,0.04c0.99,0,1.95-0.07,2.89-0.16c0.04-1.54,0.73-3.23,1.86-4.86 c-0.25,0.01-0.5,0.02-0.76,0.02c-5.33,0-10.07-1.45-13.18-3.71C226.94,60.36,226.96,60.43,226.97,60.49z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057863049728425314480000017787835361026143374_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.2507,
    y1: 61.3258,
    x2: 247.0876,
    y2: 61.3258
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000057863049728425314480000017787835361026143374_)",
    d: "M226.97,60.49 c1.56,0.89,2.98,1.98,4.18,3.17c2.07,0.53,4.33,0.84,6.74,0.84c0.94,0,1.85-0.06,2.74-0.14c1.44-2.2,3.72-4.32,6.41-5.86 c0.01-0.12,0.04-0.23,0.06-0.34C244.7,59.28,241.07,60,237,60c-2.47,0-4.78-0.27-6.75-0.73c-1.41-0.18-2.75-0.48-4-0.86 C226.64,59.04,226.89,59.74,226.97,60.49z"
  }))))), /*#__PURE__*/React.createElement("g", null, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M275,48.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46s4.21-0.6,4.88-1.46V47 C279.88,48.02,277.64,48.88,275,48.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M279.75,43.97V47c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S278.92,44.74,279.75,43.97 M280,43c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V43L280,43z"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M275,44.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S277.64,44.88,275,44.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M275,41.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S272.2,41.25,275,41.25 M275,41c-2.76,0-5,0.9-5,2s2.24,2,5,2s5-0.9,5-2S277.76,41,275,41L275,41z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083075714434333603400000004240354959747785373_",
    gradientUnits: "userSpaceOnUse",
    x1: 275,
    y1: 94.875,
    x2: 275,
    y2: 53.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#847ABD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7149A1"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000083075714434333603400000004240354959747785373_)",
    d: "M275,94.88c-0.64,0-1.26-0.02-1.88-0.06V69 c0-3.5-3.3-7.85-8.04-10.58c-0.11-0.99-0.5-1.89-1.15-2.66c2.33,1.42,6.42,2.37,11.06,2.37c6.36,0,11.68-1.78,12.88-4.13v2.28 c-1.75,1-2.77,2.43-2.96,4.14c-4.74,2.73-8.04,7.08-8.04,10.58v23.82C276.26,94.85,275.64,94.88,275,94.88z M262.12,54.28V54 c0.08,0.15,0.17,0.3,0.28,0.45C262.31,54.39,262.22,54.33,262.12,54.28z"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2B3F64",
    d: "M287.75,54.46v1.74c-1.72,1.01-2.74,2.43-2.95,4.14c-4.74,2.76-8.05,7.13-8.05,10.66v4.16v0.45v2.63 v5.73v4.18v0.45v2.63v3.45c-0.64,0.03-1.21,0.05-1.75,0.05s-1.11-0.02-1.75-0.05v-0.03v-0.91v-2.63v-0.64v-8.82v-0.91v-2.63 v-0.64V71v-2c0-3.53-3.3-7.9-8.05-10.66c-0.1-0.78-0.36-1.49-0.78-2.14c2.4,1.25,6.21,2.05,10.58,2.05 C281.15,58.25,286.19,56.67,287.75,54.46 M288,53c0,2.76-5.82,5-13,5s-13-2.24-13-5v1.35c1.72,0.96,2.8,2.4,2.97,4.14 c4.6,2.64,8.03,6.97,8.03,10.51v2v6.48v0.64v2.63v0.91v8.82v0.64v2.63v0.91v0.27c0.65,0.04,1.32,0.07,2,0.07s1.35-0.03,2-0.07 v-3.69v-2.63v-0.45v-4.18v-5.73v-2.63v-0.45V71c0-3.53,3.43-7.87,8.03-10.51c0.17-1.75,1.24-3.18,2.97-4.14V53L288,53z"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M275.1,101.87c-0.56-0.8-1.23-1.56-1.98-2.26v-4.55c0.61,0.04,1.24,0.06,1.88,0.06s1.26-0.02,1.88-0.06 v6.55l-0.25,0.24c-0.04,0-0.07,0-0.11,0C276.09,101.86,275.6,101.87,275.1,101.87z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M276.75,95.2v1.78v4.18v0.4c-0.03,0.03-0.07,0.07-0.1,0.1l-0.04,0.04c-0.47,0.03-0.95,0.04-1.44,0.04 c-0.55-0.78-1.19-1.51-1.92-2.19V95.2c0.63,0.03,1.21,0.05,1.75,0.05S276.12,95.23,276.75,95.2 M277,94.93 c-0.65,0.04-1.32,0.07-2,0.07s-1.35-0.03-2-0.07v4.74c0.8,0.73,1.47,1.51,2.04,2.33c0.57,0,1.13-0.02,1.68-0.05 c0.1-0.09,0.18-0.19,0.28-0.28v-0.05v-0.45v-4.18V94.93L277,94.93z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099648696676631033650000015652492479616113831_",
    gradientUnits: "userSpaceOnUse",
    x1: 275,
    y1: 57.875,
    x2: 275,
    y2: 45.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#847ABD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7149A1"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000099648696676631033650000015652492479616113831_)",
    d: "M275,57.88c-7.1,0-12.88-2.19-12.88-4.88 c0-1.9,3.01-5.86,7.75-7.82V47c0,1.19,2.25,2.12,5.12,2.12s5.12-0.93,5.12-2.12v-1.82c4.74,1.96,7.75,5.91,7.75,7.82 C287.88,55.69,282.1,57.88,275,57.88z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3F64",
    d: "M280.25,45.37c4.52,1.94,7.5,5.83,7.5,7.63c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75 c0-1.8,2.98-5.69,7.5-7.63V47c0,1.26,2.31,2.25,5.25,2.25s5.25-0.99,5.25-2.25V45.37 M280,45v2c0,1.1-2.24,2-5,2s-5-0.9-5-2 v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5s13-2.24,13-5C288,50.92,284.7,46.87,280,45L280,45z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044857845245686159350000006460715396718214316_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.2665,
    y1: 65.9342,
    x2: 280.6288,
    y2: 65.9342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000044857845245686159350000006460715396718214316_)",
    d: "M273,68.97c0.37,0.01,0.74,0.03,1.12,0.03 c1.13,0,2.22-0.08,3.28-0.21c0.57-1.65,1.7-3.35,3.23-4.91c-0.82,0.07-1.66,0.11-2.51,0.11c-2.83,0-5.5-0.41-7.85-1.13 C271.95,64.87,272.99,67.03,273,68.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164500443307388914370000014329656957391932090_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.3229,
    y1: 59.75,
    x2: 288,
    y2: 59.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000164500443307388914370000014329656957391932090_)",
    d: "M271.21,64.1c1.49,0.25,3.05,0.4,4.67,0.4 c1.57,0,3.07-0.14,4.51-0.37c1.29-1.37,2.88-2.62,4.64-3.63c0.17-1.75,1.24-3.18,2.97-4.14V55c0,2.76-5.82,5-13,5 c-2.47,0-4.78-0.27-6.75-0.73c-1.02-0.13-1.99-0.32-2.93-0.56C267.75,60.17,269.83,62.09,271.21,64.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M313,50.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46s4.21-0.6,4.88-1.46V49 C317.88,50.02,315.64,50.88,313,50.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M317.75,45.97V49c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S316.92,46.74,317.75,45.97 M318,45c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V45L318,45z"
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M313,46.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S315.64,46.88,313,46.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M313,43.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S310.2,43.25,313,43.25 M313,43c-2.76,0-5,0.9-5,2s2.24,2,5,2s5-0.9,5-2S315.76,43,313,43L313,43z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152962939467089175220000013540994280146368391_",
    gradientUnits: "userSpaceOnUse",
    x1: 313,
    y1: 96.875,
    x2: 313,
    y2: 55.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77C0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7206,
    style: {
      stopColor: "#5096A3"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000152962939467089175220000013540994280146368391_)",
    d: "M313,96.88c-0.64,0-1.26-0.02-1.88-0.06V71 c0-3.5-3.3-7.85-8.04-10.58c-0.11-0.99-0.5-1.89-1.15-2.66c2.33,1.42,6.42,2.37,11.06,2.37c6.36,0,11.68-1.78,12.88-4.13v2.28 c-1.75,1-2.77,2.43-2.96,4.14c-4.74,2.73-8.04,7.08-8.04,10.58v23.82C314.26,96.85,313.64,96.88,313,96.88z M300.12,56.28V56 c0.08,0.15,0.17,0.3,0.28,0.45C300.31,56.39,300.22,56.33,300.12,56.28z"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#36646D",
    d: "M325.75,56.46v1.74c-1.72,1.01-2.74,2.43-2.95,4.14c-4.74,2.76-8.05,7.13-8.05,10.66v4.16v0.45v2.63 v5.73v4.18v0.45v2.63v3.45c-0.64,0.03-1.21,0.05-1.75,0.05s-1.11-0.02-1.75-0.05v-0.03v-0.91v-2.63v-0.64v-8.82v-0.91v-2.63 v-0.64V73v-2c0-3.53-3.3-7.9-8.05-10.66c-0.1-0.78-0.36-1.49-0.78-2.14c2.4,1.25,6.21,2.05,10.58,2.05 C319.15,60.25,324.19,58.67,325.75,56.46 M326,55c0,2.76-5.82,5-13,5s-13-2.24-13-5v1.35c1.72,0.96,2.8,2.4,2.97,4.14 c4.6,2.64,8.03,6.97,8.03,10.51v2v6.48v0.64v2.63v0.91v8.82v0.64v2.63v0.91v0.27c0.65,0.04,1.32,0.07,2,0.07s1.35-0.03,2-0.07 v-3.69v-2.63v-0.45v-4.18v-5.73v-2.63v-0.45V73c0-3.53,3.43-7.87,8.03-10.51c0.17-1.75,1.24-3.18,2.97-4.14V55L326,55z"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M313.1,103.87c-0.56-0.8-1.23-1.56-1.98-2.26v-4.55c0.61,0.04,1.24,0.06,1.88,0.06s1.26-0.02,1.88-0.06 v6.55l-0.25,0.24c-0.04,0-0.07,0-0.11,0C314.09,103.86,313.6,103.87,313.1,103.87z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M314.75,97.2v1.78v4.18v0.4c-0.03,0.03-0.07,0.07-0.1,0.1l-0.04,0.04c-0.47,0.03-0.95,0.04-1.44,0.04 c-0.55-0.78-1.19-1.51-1.92-2.19V97.2c0.63,0.03,1.21,0.05,1.75,0.05S314.12,97.23,314.75,97.2 M315,96.93 c-0.65,0.04-1.32,0.07-2,0.07s-1.35-0.03-2-0.07v4.74c0.8,0.73,1.47,1.51,2.04,2.33c0.57,0,1.13-0.02,1.68-0.05 c0.1-0.09,0.18-0.19,0.28-0.28v-0.05v-0.45v-4.18V96.93L315,96.93z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137816148403166877130000008892700816351352767_",
    gradientUnits: "userSpaceOnUse",
    x1: 313,
    y1: 59.875,
    x2: 313,
    y2: 47.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77C0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7206,
    style: {
      stopColor: "#5096A3"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000137816148403166877130000008892700816351352767_)",
    d: "M313,59.88c-7.1,0-12.88-2.19-12.88-4.88 c0-1.9,3.01-5.86,7.75-7.82V49c0,1.19,2.25,2.12,5.12,2.12s5.12-0.93,5.12-2.12v-1.82c4.74,1.96,7.75,5.91,7.75,7.82 C325.88,57.69,320.1,59.88,313,59.88z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#36646D",
    d: "M318.25,47.37c4.52,1.94,7.5,5.83,7.5,7.63c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75 c0-1.8,2.98-5.69,7.5-7.63V49c0,1.26,2.31,2.25,5.25,2.25s5.25-0.99,5.25-2.25V47.37 M318,47v2c0,1.1-2.24,2-5,2s-5-0.9-5-2 v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5s13-2.24,13-5C326,52.92,322.7,48.87,318,47L318,47z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108272400290810848640000000582817522432058284_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.2665,
    y1: 67.9342,
    x2: 318.6288,
    y2: 67.9342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000108272400290810848640000000582817522432058284_)",
    d: "M311,70.97c0.37,0.01,0.74,0.03,1.12,0.03 c1.13,0,2.22-0.08,3.28-0.21c0.57-1.65,1.7-3.35,3.23-4.91c-0.82,0.07-1.66,0.11-2.51,0.11c-2.83,0-5.5-0.41-7.85-1.13 C309.95,66.87,310.99,69.03,311,70.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134212551853304426430000001687747276067780259_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.3229,
    y1: 61.75,
    x2: 326,
    y2: 61.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000134212551853304426430000001687747276067780259_)",
    d: "M309.21,66.1c1.49,0.25,3.05,0.4,4.67,0.4 c1.57,0,3.07-0.14,4.51-0.37c1.29-1.37,2.88-2.62,4.64-3.63c0.17-1.75,1.24-3.18,2.97-4.14V57c0,2.76-5.82,5-13,5 c-2.47,0-4.78-0.27-6.75-0.73c-1.02-0.13-1.99-0.32-2.93-0.56C305.75,62.17,307.83,64.09,309.21,66.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M351,52.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46s4.21-0.6,4.88-1.46V51 C355.88,52.02,353.64,52.88,351,52.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M355.75,47.97V51c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S354.92,48.74,355.75,47.97 M356,47c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V47L356,47z"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M351,48.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S353.64,48.88,351,48.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M351,45.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S348.2,45.25,351,45.25 M351,45c-2.76,0-5,0.9-5,2s2.24,2,5,2s5-0.9,5-2S353.76,45,351,45L351,45z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005978409111829804260000013647046936890150804_",
    gradientUnits: "userSpaceOnUse",
    x1: 351,
    y1: 98.875,
    x2: 351,
    y2: 57.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4E9F0"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000005978409111829804260000013647046936890150804_)",
    d: "M351,98.88c-0.64,0-1.26-0.02-1.88-0.06V73 c0-3.5-3.3-7.85-8.04-10.58c-0.11-0.99-0.5-1.89-1.15-2.66c2.33,1.42,6.42,2.37,11.06,2.37c6.36,0,11.68-1.78,12.88-4.13v36 C363.88,96.69,358.1,98.88,351,98.88z M338.12,58.28V58c0.08,0.15,0.17,0.3,0.28,0.45C338.31,58.39,338.22,58.33,338.12,58.28z "
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5096A3",
    d: "M363.75,58.46V94c0,2.57-5.84,4.75-12.75,4.75c-0.54,0-1.11-0.02-1.75-0.05v-0.03v-0.91v-2.63v-0.64 v-8.82v-0.91v-2.63v-0.64V75v-2c0-3.53-3.3-7.9-8.05-10.66c-0.1-0.78-0.36-1.49-0.78-2.14c2.4,1.25,6.21,2.05,10.58,2.05 C357.15,62.25,362.19,60.67,363.75,58.46 M364,57c0,2.76-5.82,5-13,5s-13-2.24-13-5v1.35c1.72,0.96,2.8,2.4,2.97,4.14 c4.6,2.64,8.03,6.97,8.03,10.51v2v6.48v0.64v2.63v0.91v8.82v0.64v2.63v0.91v0.27c0.65,0.04,1.32,0.07,2,0.07 c7.18,0,13-2.24,13-5V57L364,57z"
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M351.1,105.87c-0.58-0.82-1.24-1.58-1.97-2.26v-4.55c0.61,0.04,1.24,0.06,1.88,0.06 c7.24,0,13.12-2.3,13.12-5.12v-4.2c2.42,1.75,3.75,3.95,3.75,6.2C367.88,101.42,360.35,105.84,351.1,105.87z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M364.25,90.05c2.26,1.7,3.5,3.8,3.5,5.95c0,5.34-7.43,9.7-16.59,9.75c-0.56-0.79-1.2-1.53-1.91-2.19 V99.2c0.63,0.03,1.21,0.05,1.75,0.05c7.43,0,13.25-2.31,13.25-5.25V90.05 M364,89.56V94c0,2.76-5.82,5-13,5 c-0.68,0-1.35-0.03-2-0.07v4.74c0.79,0.73,1.46,1.51,2.03,2.33c9.37-0.01,16.97-4.48,16.97-10 C368,93.55,366.49,91.3,364,89.56L364,89.56z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179629715909786146250000002072912106571603126_",
    gradientUnits: "userSpaceOnUse",
    x1: 351,
    y1: 61.875,
    x2: 351,
    y2: 49.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C4E9F0"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000179629715909786146250000002072912106571603126_)",
    d: "M351,61.88c-7.1,0-12.88-2.19-12.88-4.88 c0-1.9,3.01-5.86,7.75-7.82V51c0,1.19,2.25,2.12,5.12,2.12s5.12-0.93,5.12-2.12v-1.82c4.74,1.96,7.75,5.91,7.75,7.82 C363.88,59.69,358.1,61.88,351,61.88z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#5096A3",
    d: "M356.25,49.37c4.52,1.94,7.5,5.83,7.5,7.63c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75 c0-1.8,2.98-5.69,7.5-7.63V51c0,1.26,2.31,2.25,5.25,2.25s5.25-0.99,5.25-2.25V49.37 M356,49v2c0,1.1-2.24,2-5,2s-5-0.9-5-2 v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5s13-2.24,13-5C364,54.92,360.7,50.87,356,49L356,49z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153663672600559403680000008448268189418851486_",
    gradientUnits: "userSpaceOnUse",
    x1: 349,
    y1: 95.5536,
    x2: 364,
    y2: 95.5536
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000153663672600559403680000008448268189418851486_)",
    d: "M354.12,94c-1.79,0-3.5-0.17-5.12-0.47 v0.95v0.64v2.63v0.91v0.27c0.49,0.03,0.98,0.05,1.49,0.06c5.45-0.07,10.26-1.65,13.28-4.06c0.15-0.3,0.23-0.61,0.23-0.93 v-1.88C361.22,93.3,357.81,94,354.12,94z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156575125858026215560000018167628337017697978_",
    gradientUnits: "userSpaceOnUse",
    x1: 349,
    y1: 82.5586,
    x2: 364,
    y2: 82.5586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000156575125858026215560000018167628337017697978_)",
    d: "M354.12,81c-1.79,0-3.5-0.17-5.12-0.47 v0.95v0.64v2.63v0.91v0.3c0.37,0.01,0.74,0.03,1.12,0.03c5.75,0,10.81-1.68,13.88-4.25v-2.63 C361.22,80.3,357.81,81,354.12,81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178180807556311646330000008134271593000359097_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.2665,
    y1: 69.5586,
    x2: 364,
    y2: 69.5586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000178180807556311646330000008134271593000359097_)",
    d: "M354.12,68c-2.83,0-5.5-0.41-7.85-1.13 c1.68,2,2.72,4.16,2.73,6.1c0.37,0.01,0.74,0.03,1.12,0.03c5.75,0,10.81-1.68,13.88-4.25v-2.63 C361.22,67.3,357.81,68,354.12,68z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173160377536483813190000013179174912131628702_",
    gradientUnits: "userSpaceOnUse",
    x1: 349,
    y1: 88.5819,
    x2: 364,
    y2: 88.5819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000173160377536483813190000013179174912131628702_)",
    d: "M349,89.47v4.87 c0.94,0.1,1.9,0.16,2.88,0.16c4.75,0,9.03-1.15,12.12-2.99v-8.84C361.86,86.44,356.01,89.2,349,89.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057111071522719618380000014313071196363807411_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.3229,
    y1: 63.75,
    x2: 364,
    y2: 63.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000057111071522719618380000014313071196363807411_)",
    d: "M351,64c-2.47,0-4.78-0.27-6.75-0.73 c-1.02-0.13-1.99-0.32-2.93-0.56c2.43,1.46,4.51,3.38,5.89,5.39c1.49,0.25,3.05,0.4,4.67,0.4c4.76,0,9.03-1.16,12.12-3.02V59 C364,61.76,358.18,64,351,64z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180332971904012019280000012513059342431321988_",
    gradientUnits: "userSpaceOnUse",
    x1: 349,
    y1: 75.5819,
    x2: 364,
    y2: 75.5819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000180332971904012019280000012513059342431321988_)",
    d: "M349,76.47v4.87 c0.94,0.1,1.9,0.16,2.88,0.16c4.76,0,9.03-1.16,12.12-3.02v-8.82C361.86,73.44,356.01,76.2,349,76.47z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M180,68.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46s4.21-0.6,4.88-1.46V67 C184.88,68.02,182.64,68.88,180,68.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M184.75,63.97V67c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S183.92,64.74,184.75,63.97 M185,63c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V63L185,63z"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M180,64.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S182.64,64.88,180,64.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M180,61.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S177.2,61.25,180,61.25 M180,61c-2.76,0-5,0.9-5,2s2.24,2,5,2s5-0.9,5-2S182.76,61,180,61L180,61z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095339553025409560970000009503030960571380101_",
    gradientUnits: "userSpaceOnUse",
    x1: 180,
    y1: 114.875,
    x2: 180,
    y2: 73.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEEB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6202,
    style: {
      stopColor: "#FFE282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8C06E"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000095339553025409560970000009503030960571380101_)",
    d: "M180,114.88c-7.1,0-12.88-2.19-12.88-4.88V74 c1.19,2.35,6.51,4.13,12.88,4.13s11.68-1.78,12.88-4.13v36C192.88,112.69,187.1,114.88,180,114.88z"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#807141",
    d: "M192.75,74.46V110c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75V74.46 c1.56,2.21,6.6,3.79,12.75,3.79S191.19,76.67,192.75,74.46 M193,73c0,2.76-5.82,5-13,5s-13-2.24-13-5v37c0,2.76,5.82,5,13,5 s13-2.24,13-5V73L193,73z"
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M180,121.88c-9.3,0-16.88-4.43-16.88-9.88c0-2.25,1.33-4.44,3.75-6.2v4.2c0,2.83,5.89,5.12,13.12,5.12 s13.12-2.3,13.12-5.12v-4.2c2.42,1.75,3.75,3.95,3.75,6.2C196.88,117.45,189.3,121.88,180,121.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M193.25,106.05c2.26,1.7,3.5,3.8,3.5,5.95c0,5.38-7.51,9.75-16.75,9.75s-16.75-4.37-16.75-9.75 c0-2.15,1.24-4.24,3.5-5.95V110c0,2.94,5.82,5.25,13.25,5.25s13.25-2.31,13.25-5.25V106.05 M193,105.56V110 c0,2.76-5.82,5-13,5s-13-2.24-13-5v-4.44c-2.49,1.74-4,3.98-4,6.44c0,5.52,7.61,10,17,10s17-4.48,17-10 C197,109.55,195.49,107.3,193,105.56L193,105.56z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054248596625665434990000017971283140879953587_",
    gradientUnits: "userSpaceOnUse",
    x1: 180,
    y1: 77.875,
    x2: 180,
    y2: 65.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEEB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    style: {
      stopColor: "#FFE89B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6202,
    style: {
      stopColor: "#FFE282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8C06E"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000054248596625665434990000017971283140879953587_)",
    d: "M180,77.88c-7.1,0-12.88-2.19-12.88-4.88 c0-1.9,3.01-5.86,7.75-7.82V67c0,1.19,2.25,2.12,5.12,2.12s5.12-0.93,5.12-2.12v-1.82c4.74,1.96,7.75,5.91,7.75,7.82 C192.88,75.69,187.1,77.88,180,77.88z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#807141",
    d: "M185.25,65.37c4.52,1.94,7.5,5.83,7.5,7.63c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75 c0-1.8,2.98-5.69,7.5-7.63V67c0,1.26,2.31,2.25,5.25,2.25s5.25-0.99,5.25-2.25V65.37 M185,65v2c0,1.1-2.24,2-5,2s-5-0.9-5-2 v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5s13-2.24,13-5C193,70.92,189.7,66.87,185,65L185,65z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050639827204869865170000008711889253551963520_",
    gradientUnits: "userSpaceOnUse",
    x1: 167,
    y1: 109.0769,
    x2: 193,
    y2: 109.0769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000050639827204869865170000008711889253551963520_)",
    d: "M183.12,110c-7.51,0-13.87-2.87-16.12-6.84 V110c0,2.69,5.55,4.89,12.49,4.99c5.45-0.07,10.26-1.65,13.28-4.06c0.15-0.3,0.23-0.61,0.23-0.93v-1.88 C190.22,109.3,186.81,110,183.12,110z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103951788685610939770000003753581962407499443_",
    gradientUnits: "userSpaceOnUse",
    x1: 167,
    y1: 83.0819,
    x2: 193,
    y2: 83.0819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000103951788685610939770000003753581962407499443_)",
    d: "M193,84.75v-2.63 c-2.78,1.18-6.19,1.88-9.88,1.88c-7.51,0-13.87-2.87-16.12-6.84v8.82c3.08,1.85,7.36,3.02,12.12,3.02 C184.86,89,189.93,87.32,193,84.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098902857813110429890000016712752927361060537_",
    gradientUnits: "userSpaceOnUse",
    x1: 167,
    y1: 96.0819,
    x2: 193,
    y2: 96.0819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000098902857813110429890000016712752927361060537_)",
    d: "M167,90.16v8.82 c3.08,1.85,7.36,3.02,12.12,3.02c5.75,0,10.81-1.68,13.88-4.25v-2.63c-2.78,1.18-6.19,1.88-9.88,1.88 C175.61,97,169.25,94.13,167,90.16z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164493454964766119010000015969418489350504891_",
    gradientUnits: "userSpaceOnUse",
    x1: 167,
    y1: 104.5819,
    x2: 193,
    y2: 104.5819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000164493454964766119010000015969418489350504891_)",
    d: "M180.88,110.5c4.75,0,9.03-1.15,12.12-2.99 v-8.84c-2.25,3.97-8.61,6.84-16.12,6.84c-3.69,0-7.1-0.7-9.88-1.88v2.63C170.07,108.82,175.14,110.5,180.88,110.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048471229027951037410000017649385161686475410_",
    gradientUnits: "userSpaceOnUse",
    x1: 167,
    y1: 79.75,
    x2: 193,
    y2: 79.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000048471229027951037410000017649385161686475410_)",
    d: "M173.25,79.27 c-2.3-0.3-4.41-0.87-6.25-1.65v2.63c3.07,2.57,8.14,4.25,13.88,4.25c4.76,0,9.03-1.16,12.12-3.02V75c0,2.76-5.82,5-13,5 C177.53,80,175.22,79.73,173.25,79.27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001633096504751975770000001975279055226786211_",
    gradientUnits: "userSpaceOnUse",
    x1: 167,
    y1: 91.5819,
    x2: 193,
    y2: 91.5819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000001633096504751975770000001975279055226786211_)",
    d: "M180.88,97.5c4.76,0,9.03-1.16,12.12-3.02 v-8.82c-2.25,3.97-8.61,6.84-16.12,6.84c-3.69,0-7.1-0.7-9.88-1.88v2.63C170.07,95.82,175.14,97.5,180.88,97.5z"
  })))))), /*#__PURE__*/React.createElement("g", null, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M218,66.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46s4.21-0.6,4.88-1.46V65 C222.88,66.02,220.64,66.88,218,66.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M222.75,61.97V65c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S221.92,62.74,222.75,61.97 M223,61c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V61L223,61z"
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M218,62.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S220.64,62.88,218,62.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M218,59.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S215.2,59.25,218,59.25 M218,59c-2.76,0-5,0.9-5,2s2.24,2,5,2s5-0.9,5-2S220.76,59,218,59L218,59z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152977949339963840990000002067905345295128476_",
    gradientUnits: "userSpaceOnUse",
    x1: 218,
    y1: 112.875,
    x2: 218,
    y2: 71.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EB9EAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DD5D76"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000152977949339963840990000002067905345295128476_)",
    d: "M218,112.88c-7.1,0-12.88-2.19-12.88-4.88V72 c1.19,2.35,6.51,4.13,12.88,4.13s11.68-1.78,12.88-4.13v36C230.88,110.69,225.1,112.88,218,112.88z"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A63C46",
    d: "M230.75,72.46V108c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75V72.46 c1.56,2.21,6.6,3.79,12.75,3.79S229.19,74.67,230.75,72.46 M231,71c0,2.76-5.82,5-13,5s-13-2.24-13-5v37c0,2.76,5.82,5,13,5 s13-2.24,13-5V71L231,71z"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M218,119.88c-9.3,0-16.88-4.43-16.88-9.88c0-2.25,1.33-4.44,3.75-6.2v4.2c0,2.83,5.89,5.12,13.12,5.12 s13.12-2.3,13.12-5.12v-4.2c2.42,1.75,3.75,3.95,3.75,6.2C234.88,115.45,227.3,119.88,218,119.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M231.25,104.05c2.26,1.7,3.5,3.8,3.5,5.95c0,5.38-7.51,9.75-16.75,9.75s-16.75-4.37-16.75-9.75 c0-2.15,1.24-4.24,3.5-5.95V108c0,2.94,5.82,5.25,13.25,5.25s13.25-2.31,13.25-5.25V104.05 M231,103.56V108 c0,2.76-5.82,5-13,5s-13-2.24-13-5v-4.44c-2.49,1.74-4,3.98-4,6.44c0,5.52,7.61,10,17,10s17-4.48,17-10 C235,107.55,233.49,105.3,231,103.56L231,103.56z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081624977513280293310000013376919133024131260_",
    gradientUnits: "userSpaceOnUse",
    x1: 218,
    y1: 75.875,
    x2: 218,
    y2: 63.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EB9EAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DD5D76"
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000081624977513280293310000013376919133024131260_)",
    d: "M218,75.88c-7.1,0-12.88-2.19-12.88-4.88 c0-1.9,3.01-5.86,7.75-7.82V65c0,1.19,2.25,2.12,5.12,2.12s5.12-0.93,5.12-2.12v-1.82c4.74,1.96,7.75,5.91,7.75,7.82 C230.88,73.69,225.1,75.88,218,75.88z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#A63C46",
    d: "M223.25,63.37c4.52,1.94,7.5,5.83,7.5,7.63c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75 c0-1.8,2.98-5.69,7.5-7.63V65c0,1.26,2.31,2.25,5.25,2.25s5.25-0.99,5.25-2.25V63.37 M223,63v2c0,1.1-2.24,2-5,2s-5-0.9-5-2 v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5s13-2.24,13-5C231,68.92,227.7,64.87,223,63L223,63z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161609665187890325680000012183531632453402764_",
    gradientUnits: "userSpaceOnUse",
    x1: 205,
    y1: 107.0769,
    x2: 231,
    y2: 107.0769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000161609665187890325680000012183531632453402764_)",
    d: "M221.12,108c-7.51,0-13.87-2.87-16.12-6.84 V108c0,2.69,5.55,4.89,12.49,4.99c5.45-0.07,10.26-1.65,13.28-4.06c0.15-0.3,0.23-0.61,0.23-0.93v-1.88 C228.22,107.3,224.81,108,221.12,108z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103225331429169013000000016475227100340256411_",
    gradientUnits: "userSpaceOnUse",
    x1: 205,
    y1: 81.0819,
    x2: 231,
    y2: 81.0819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000103225331429169013000000016475227100340256411_)",
    d: "M231,82.75v-2.63 c-2.78,1.18-6.19,1.88-9.88,1.88c-7.51,0-13.87-2.87-16.12-6.84v8.82c3.08,1.85,7.36,3.02,12.12,3.02 C222.86,87,227.93,85.32,231,82.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141432273541308784000000002218865696332131259_",
    gradientUnits: "userSpaceOnUse",
    x1: 205,
    y1: 94.0819,
    x2: 231,
    y2: 94.0819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000141432273541308784000000002218865696332131259_)",
    d: "M205,88.16v8.82 c3.08,1.85,7.36,3.02,12.12,3.02c5.75,0,10.81-1.68,13.88-4.25v-2.63c-2.78,1.18-6.19,1.88-9.88,1.88 C213.61,95,207.25,92.13,205,88.16z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014606686954335837600000014392664415226523311_",
    gradientUnits: "userSpaceOnUse",
    x1: 205,
    y1: 102.5819,
    x2: 231,
    y2: 102.5819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000014606686954335837600000014392664415226523311_)",
    d: "M218.88,108.5c4.75,0,9.03-1.15,12.12-2.99 v-8.84c-2.25,3.97-8.61,6.84-16.12,6.84c-3.69,0-7.1-0.7-9.88-1.88v2.63C208.07,106.82,213.14,108.5,218.88,108.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174602677748632952870000011920533892543930798_",
    gradientUnits: "userSpaceOnUse",
    x1: 205,
    y1: 77.75,
    x2: 231,
    y2: 77.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000174602677748632952870000011920533892543930798_)",
    d: "M211.25,77.27 c-2.3-0.3-4.41-0.87-6.25-1.65v2.63c3.07,2.57,8.14,4.25,13.88,4.25c4.76,0,9.03-1.16,12.12-3.02V73c0,2.76-5.82,5-13,5 C215.53,78,213.22,77.73,211.25,77.27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073707196288038652410000008892507003070145970_",
    gradientUnits: "userSpaceOnUse",
    x1: 205,
    y1: 89.5819,
    x2: 231,
    y2: 89.5819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000073707196288038652410000008892507003070145970_)",
    d: "M218.88,95.5c4.76,0,9.03-1.16,12.12-3.02 v-8.82c-2.25,3.97-8.61,6.84-16.12,6.84c-3.69,0-7.1-0.7-9.88-1.88v2.63C208.07,93.82,213.14,95.5,218.88,95.5z"
  })))))), /*#__PURE__*/React.createElement("g", null, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M256,64.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46 c2.31,0,4.21-0.6,4.88-1.46V63C260.88,64.02,258.64,64.88,256,64.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M260.75,59.97V63c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S259.92,60.74,260.75,59.97 M261,59c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V59L261,59z"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M256,60.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S258.64,60.88,256,60.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M256,57.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S253.2,57.25,256,57.25 M256,57c-2.76,0-5,0.9-5,2s2.24,2,5,2c2.76,0,5-0.9,5-2S258.76,57,256,57L256,57z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003791673941015046520000012449631743693739410_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 110.5,
    x2: 256,
    y2: 71.1162
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF92C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D74E9C"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000003791673941015046520000012449631743693739410_)",
    d: "M256,110.5c-7.48,0-12.5-2.33-12.5-4.5V71.12 c2,2,6.78,3.38,12.5,3.38c5.72,0,10.5-1.38,12.5-3.38V106C268.5,108.17,263.48,110.5,256,110.5z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#A446B7",
    d: "M268,72.2V106c0,1.67-4.57,4-12,4c-7.43,0-12-2.33-12-4V72.2c2.62,1.83,7.41,2.8,12,2.8 C260.59,75,265.38,74.04,268,72.2 M269,69c0,2.76-5.82,5-13,5s-13-2.24-13-5v37c0,2.76,5.82,5,13,5s13-2.24,13-5V69L269,69z"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M256,117.88c-9.3,0-16.88-4.43-16.88-9.88c0-2.25,1.33-4.44,3.75-6.2v4.2c0,2.83,5.89,5.12,13.12,5.12 s13.12-2.3,13.12-5.12v-4.2c2.42,1.75,3.75,3.95,3.75,6.2C272.88,113.45,265.3,117.88,256,117.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M269.25,102.05c2.26,1.7,3.5,3.8,3.5,5.95c0,5.38-7.51,9.75-16.75,9.75c-9.24,0-16.75-4.37-16.75-9.75 c0-2.15,1.24-4.24,3.5-5.95V106c0,2.94,5.82,5.25,13.25,5.25c7.43,0,13.25-2.31,13.25-5.25V102.05 M269,101.56V106 c0,2.76-5.82,5-13,5s-13-2.24-13-5v-4.44c-2.49,1.74-4,3.98-4,6.44c0,5.52,7.61,10,17,10s17-4.48,17-10 C273,105.55,271.49,103.3,269,101.56L269,101.56z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145059162594485894690000016001842153043555748_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 73.5,
    x2: 256,
    y2: 61.7544
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF92C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D74E9C"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000145059162594485894690000016001842153043555748_)",
    d: "M256,73.5c-7.48,0-12.5-2.33-12.5-4.5 c0-1.69,2.76-5.31,7-7.25V63c0,1.62,2.83,2.5,5.5,2.5c2.67,0,5.5-0.88,5.5-2.5v-1.25c4.24,1.94,7,5.55,7,7.25 C268.5,71.17,263.48,73.5,256,73.5z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#A446B7",
    d: "M262,62.55c3.75,1.96,6,5.14,6,6.45c0,1.67-4.57,4-12,4c-7.43,0-12-2.33-12-4c0-1.31,2.25-4.49,6-6.45 V63c0,2.06,3.11,3,6,3c2.89,0,6-0.94,6-3V62.55 M261,61v2c0,1.1-2.24,2-5,2s-5-0.9-5-2v-2c-4.7,1.87-8,5.92-8,8 c0,2.76,5.82,5,13,5s13-2.24,13-5C269,66.92,265.7,62.87,261,61L261,61z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132089192069121689120000014725886748744258176_",
    gradientUnits: "userSpaceOnUse",
    x1: 243,
    y1: 105.0769,
    x2: 269,
    y2: 105.0769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000132089192069121689120000014725886748744258176_)",
    d: "M259.12,106c-7.51,0-13.87-2.87-16.12-6.84 V106c0,2.69,5.55,4.89,12.49,4.99c5.45-0.07,10.26-1.65,13.28-4.06c0.15-0.3,0.23-0.61,0.23-0.93v-1.88 C266.22,105.3,262.81,106,259.12,106z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085222174759730862700000006674436502129023901_",
    gradientUnits: "userSpaceOnUse",
    x1: 243,
    y1: 79.0819,
    x2: 269,
    y2: 79.0819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000085222174759730862700000006674436502129023901_)",
    d: "M269,80.75v-2.63 c-2.78,1.18-6.19,1.88-9.88,1.88c-7.51,0-13.87-2.87-16.12-6.84v8.82c3.08,1.85,7.36,3.02,12.12,3.02 C260.86,85,265.93,83.32,269,80.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163760695143641530220000013678432961755650455_",
    gradientUnits: "userSpaceOnUse",
    x1: 243,
    y1: 92.0819,
    x2: 269,
    y2: 92.0819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000163760695143641530220000013678432961755650455_)",
    d: "M243,86.16v8.82 c3.08,1.85,7.36,3.02,12.12,3.02c5.75,0,10.81-1.68,13.88-4.25v-2.63c-2.78,1.18-6.19,1.88-9.88,1.88 C251.61,93,245.25,90.13,243,86.16z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101823184195888262450000015346490946624256700_",
    gradientUnits: "userSpaceOnUse",
    x1: 243,
    y1: 100.5819,
    x2: 269,
    y2: 100.5819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000101823184195888262450000015346490946624256700_)",
    d: "M256.88,106.5c4.75,0,9.03-1.15,12.12-2.99 v-8.84c-2.25,3.97-8.61,6.84-16.12,6.84c-3.69,0-7.1-0.7-9.88-1.88v2.63C246.07,104.82,251.14,106.5,256.88,106.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083791364367186054830000010670692076278562473_",
    gradientUnits: "userSpaceOnUse",
    x1: 243,
    y1: 75.75,
    x2: 269,
    y2: 75.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000083791364367186054830000010670692076278562473_)",
    d: "M249.25,75.27 c-2.3-0.3-4.41-0.87-6.25-1.65v2.63c3.07,2.57,8.14,4.25,13.88,4.25c4.76,0,9.03-1.16,12.12-3.02V71c0,2.76-5.82,5-13,5 C253.53,76,251.22,75.73,249.25,75.27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125582008038718704410000004047764456903034795_",
    gradientUnits: "userSpaceOnUse",
    x1: 243,
    y1: 87.5819,
    x2: 269,
    y2: 87.5819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000125582008038718704410000004047764456903034795_)",
    d: "M256.88,93.5c4.76,0,9.03-1.16,12.12-3.02 v-8.82c-2.25,3.97-8.61,6.84-16.12,6.84c-3.69,0-7.1-0.7-9.88-1.88v2.63C246.07,91.82,251.14,93.5,256.88,93.5z"
  })))))), /*#__PURE__*/React.createElement("g", null, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M294,66.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46s4.21-0.6,4.88-1.46V65 C298.88,66.02,296.64,66.88,294,66.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M298.75,61.97V65c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S297.92,62.74,298.75,61.97 M299,61c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V61L299,61z"
  })))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M294,62.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S296.64,62.88,294,62.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M294,59.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S291.2,59.25,294,59.25 M294,59c-2.76,0-5,0.9-5,2s2.24,2,5,2s5-0.9,5-2S296.76,59,294,59L294,59z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011736929993556747230000004960809949878820238_",
    gradientUnits: "userSpaceOnUse",
    x1: 294,
    y1: 112.875,
    x2: 294,
    y2: 71.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405,
    style: {
      stopColor: "#89D3E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#71B9C6"
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000011736929993556747230000004960809949878820238_)",
    d: "M294,112.88c-7.1,0-12.88-2.19-12.88-4.88V72 c1.19,2.35,6.51,4.13,12.88,4.13s11.68-1.78,12.88-4.13v36C306.88,110.69,301.1,112.88,294,112.88z"
  })), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#36646D",
    d: "M306.75,72.46V108c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75V72.46 c1.56,2.21,6.6,3.79,12.75,3.79S305.19,74.67,306.75,72.46 M307,71c0,2.76-5.82,5-13,5s-13-2.24-13-5v37c0,2.76,5.82,5,13,5 s13-2.24,13-5V71L307,71z"
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M294,119.88c-9.3,0-16.88-4.43-16.88-9.88c0-2.25,1.33-4.44,3.75-6.2v4.2c0,2.83,5.89,5.12,13.12,5.12 s13.12-2.3,13.12-5.12v-4.2c2.42,1.75,3.75,3.95,3.75,6.2C310.88,115.45,303.3,119.88,294,119.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M307.25,104.05c2.26,1.7,3.5,3.8,3.5,5.95c0,5.38-7.51,9.75-16.75,9.75s-16.75-4.37-16.75-9.75 c0-2.15,1.24-4.24,3.5-5.95V108c0,2.94,5.82,5.25,13.25,5.25s13.25-2.31,13.25-5.25V104.05 M307,103.56V108 c0,2.76-5.82,5-13,5s-13-2.24-13-5v-4.44c-2.49,1.74-4,3.98-4,6.44c0,5.52,7.61,10,17,10s17-4.48,17-10 C311,107.55,309.49,105.3,307,103.56L307,103.56z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109721722446708136190000013469940760173917624_",
    gradientUnits: "userSpaceOnUse",
    x1: 294,
    y1: 75.875,
    x2: 294,
    y2: 63.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405,
    style: {
      stopColor: "#89D3E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#71B9C6"
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000109721722446708136190000013469940760173917624_)",
    d: "M294,75.88c-7.1,0-12.88-2.19-12.88-4.88 c0-1.9,3.01-5.86,7.75-7.82V65c0,1.19,2.25,2.12,5.12,2.12s5.12-0.93,5.12-2.12v-1.82c4.74,1.96,7.75,5.91,7.75,7.82 C306.88,73.69,301.1,75.88,294,75.88z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#36646D",
    d: "M299.25,63.37c4.52,1.94,7.5,5.83,7.5,7.63c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75 c0-1.8,2.98-5.69,7.5-7.63V65c0,1.26,2.31,2.25,5.25,2.25s5.25-0.99,5.25-2.25V63.37 M299,63v2c0,1.1-2.24,2-5,2s-5-0.9-5-2 v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5s13-2.24,13-5C307,68.92,303.7,64.87,299,63L299,63z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173864025967952539370000012882874789788723870_",
    gradientUnits: "userSpaceOnUse",
    x1: 281,
    y1: 107.0769,
    x2: 307,
    y2: 107.0769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000173864025967952539370000012882874789788723870_)",
    d: "M297.12,108c-7.51,0-13.87-2.87-16.12-6.84 V108c0,2.69,5.55,4.89,12.49,4.99c5.45-0.07,10.26-1.65,13.28-4.06c0.15-0.3,0.23-0.61,0.23-0.93v-1.88 C304.22,107.3,300.81,108,297.12,108z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060026106795788878690000004906894231927930290_",
    gradientUnits: "userSpaceOnUse",
    x1: 281,
    y1: 81.0819,
    x2: 307,
    y2: 81.0819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000060026106795788878690000004906894231927930290_)",
    d: "M307,82.75v-2.63 c-2.78,1.18-6.19,1.88-9.88,1.88c-7.51,0-13.87-2.87-16.12-6.84v8.82c3.08,1.85,7.36,3.02,12.12,3.02 C298.86,87,303.93,85.32,307,82.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109015125185626652800000005365251209546749344_",
    gradientUnits: "userSpaceOnUse",
    x1: 281,
    y1: 94.0819,
    x2: 307,
    y2: 94.0819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000109015125185626652800000005365251209546749344_)",
    d: "M281,88.16v8.82 c3.08,1.85,7.36,3.02,12.12,3.02c5.75,0,10.81-1.68,13.88-4.25v-2.63c-2.78,1.18-6.19,1.88-9.88,1.88 C289.61,95,283.25,92.13,281,88.16z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006685005970850885650000014848979143923845562_",
    gradientUnits: "userSpaceOnUse",
    x1: 281,
    y1: 102.5819,
    x2: 307,
    y2: 102.5819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000006685005970850885650000014848979143923845562_)",
    d: "M294.88,108.5c4.75,0,9.03-1.15,12.12-2.99 v-8.84c-2.25,3.97-8.61,6.84-16.12,6.84c-3.69,0-7.1-0.7-9.88-1.88v2.63C284.07,106.82,289.14,108.5,294.88,108.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016061040067260791840000002567007781899177654_",
    gradientUnits: "userSpaceOnUse",
    x1: 281,
    y1: 77.75,
    x2: 307,
    y2: 77.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000016061040067260791840000002567007781899177654_)",
    d: "M287.25,77.27 c-2.3-0.3-4.41-0.87-6.25-1.65v2.63c3.07,2.57,8.14,4.25,13.88,4.25c4.76,0,9.03-1.16,12.12-3.02V73c0,2.76-5.82,5-13,5 C291.53,78,289.22,77.73,287.25,77.27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078751147043170714560000013601716178654499243_",
    gradientUnits: "userSpaceOnUse",
    x1: 281,
    y1: 89.5819,
    x2: 307,
    y2: 89.5819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000078751147043170714560000013601716178654499243_)",
    d: "M294.88,95.5c4.76,0,9.03-1.16,12.12-3.02 v-8.82c-2.25,3.97-8.61,6.84-16.12,6.84c-3.69,0-7.1-0.7-9.88-1.88v2.63C284.07,93.82,289.14,95.5,294.88,95.5z"
  })))))), /*#__PURE__*/React.createElement("g", null, _g75 || (_g75 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M332,68.88c-2.64,0-4.88-0.86-4.88-1.88v-3.33c0.66,0.85,2.57,1.46,4.88,1.46s4.21-0.6,4.88-1.46V67 C336.88,68.02,334.64,68.88,332,68.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M336.75,63.97V67c0,0.83-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75v-3.03 c0.83,0.76,2.63,1.28,4.75,1.28S335.92,64.74,336.75,63.97 M337,63c0,1.1-2.24,2-5,2s-5-0.9-5-2v4c0,1.1,2.24,2,5,2s5-0.9,5-2 V63L337,63z"
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M332,64.88c-2.64,0-4.88-0.86-4.88-1.88s2.23-1.88,4.88-1.88s4.88,0.86,4.88,1.88 S334.64,64.88,332,64.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M332,61.25c2.8,0,4.75,0.92,4.75,1.75s-1.95,1.75-4.75,1.75s-4.75-0.92-4.75-1.75 S329.2,61.25,332,61.25 M332,61c-2.76,0-5,0.9-5,2s2.24,2,5,2s5-0.9,5-2S334.76,61,332,61L332,61z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102526785990490680720000009539212383221343908_",
    gradientUnits: "userSpaceOnUse",
    x1: 332,
    y1: 114.875,
    x2: 332,
    y2: 73.9985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9EB8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5176,
    style: {
      stopColor: "#A8E673"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EAD56"
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000102526785990490680720000009539212383221343908_)",
    d: "M332,114.88c-7.1,0-12.88-2.19-12.88-4.88V74 c1.19,2.35,6.51,4.13,12.88,4.13s11.68-1.78,12.88-4.13v36C344.88,112.69,339.1,114.88,332,114.88z"
  })), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7EAD56",
    d: "M344.75,74.46V110c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75V74.46 c1.56,2.21,6.6,3.79,12.75,3.79S343.19,76.67,344.75,74.46 M345,73c0,2.76-5.82,5-13,5s-13-2.24-13-5v37c0,2.76,5.82,5,13,5 s13-2.24,13-5V73L345,73z"
  })))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M332,121.88c-9.3,0-16.88-4.43-16.88-9.88c0-2.25,1.33-4.44,3.75-6.2v4.2c0,2.83,5.89,5.12,13.12,5.12 s13.12-2.3,13.12-5.12v-4.2c2.42,1.75,3.75,3.95,3.75,6.2C348.88,117.45,341.3,121.88,332,121.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M345.25,106.05c2.26,1.7,3.5,3.8,3.5,5.95c0,5.38-7.51,9.75-16.75,9.75s-16.75-4.37-16.75-9.75 c0-2.15,1.24-4.24,3.5-5.95V110c0,2.94,5.82,5.25,13.25,5.25s13.25-2.31,13.25-5.25V106.05 M345,105.56V110 c0,2.76-5.82,5-13,5s-13-2.24-13-5v-4.44c-2.49,1.74-4,3.98-4,6.44c0,5.52,7.61,10,17,10s17-4.48,17-10 C349,109.55,347.49,107.3,345,105.56L345,105.56z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152266455161124212730000012077317759339981712_",
    gradientUnits: "userSpaceOnUse",
    x1: 332,
    y1: 77.875,
    x2: 332,
    y2: 65.1821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9EB8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5176,
    style: {
      stopColor: "#A8E673"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7EAD56"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000152266455161124212730000012077317759339981712_)",
    d: "M332,77.88c-7.1,0-12.88-2.19-12.88-4.88 c0-1.9,3.01-5.86,7.75-7.82V67c0,1.19,2.25,2.12,5.12,2.12s5.12-0.93,5.12-2.12v-1.82c4.74,1.96,7.75,5.91,7.75,7.82 C344.88,75.69,339.1,77.88,332,77.88z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#7EAD56",
    d: "M337.25,65.37c4.52,1.94,7.5,5.83,7.5,7.63c0,2.57-5.84,4.75-12.75,4.75s-12.75-2.18-12.75-4.75 c0-1.8,2.98-5.69,7.5-7.63V67c0,1.26,2.31,2.25,5.25,2.25s5.25-0.99,5.25-2.25V65.37 M337,65v2c0,1.1-2.24,2-5,2s-5-0.9-5-2 v-2c-4.7,1.87-8,5.92-8,8c0,2.76,5.82,5,13,5s13-2.24,13-5C345,70.92,341.7,66.87,337,65L337,65z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033357898830829268540000000118782935176445354_",
    gradientUnits: "userSpaceOnUse",
    x1: 319,
    y1: 109.0769,
    x2: 345,
    y2: 109.0769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000033357898830829268540000000118782935176445354_)",
    d: "M335.12,110c-7.51,0-13.87-2.87-16.12-6.84 V110c0,2.69,5.55,4.89,12.49,4.99c5.45-0.07,10.26-1.65,13.28-4.06c0.15-0.3,0.23-0.61,0.23-0.93v-1.88 C342.22,109.3,338.81,110,335.12,110z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165202002965222658600000009266801432032370347_",
    gradientUnits: "userSpaceOnUse",
    x1: 319,
    y1: 83.0819,
    x2: 345,
    y2: 83.0819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000165202002965222658600000009266801432032370347_)",
    d: "M345,84.75v-2.63 c-2.78,1.18-6.19,1.88-9.88,1.88c-7.51,0-13.87-2.87-16.12-6.84v8.82c3.08,1.85,7.36,3.02,12.12,3.02 C336.86,89,341.93,87.32,345,84.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016073319769535841370000005087764252893007018_",
    gradientUnits: "userSpaceOnUse",
    x1: 319,
    y1: 96.0819,
    x2: 345,
    y2: 96.0819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6174,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7543,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000016073319769535841370000005087764252893007018_)",
    d: "M319,90.16v8.82 c3.08,1.85,7.36,3.02,12.12,3.02c5.75,0,10.81-1.68,13.88-4.25v-2.63c-2.78,1.18-6.19,1.88-9.88,1.88 C327.61,97,321.25,94.13,319,90.16z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065038632137461027360000012389731699014255534_",
    gradientUnits: "userSpaceOnUse",
    x1: 319,
    y1: 104.5819,
    x2: 345,
    y2: 104.5819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000065038632137461027360000012389731699014255534_)",
    d: "M332.88,110.5c4.75,0,9.03-1.15,12.12-2.99 v-8.84c-2.25,3.97-8.61,6.84-16.12,6.84c-3.69,0-7.1-0.7-9.88-1.88v2.63C322.07,108.82,327.14,110.5,332.88,110.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158003677554243248120000016590650492613381308_",
    gradientUnits: "userSpaceOnUse",
    x1: 319,
    y1: 79.75,
    x2: 345,
    y2: 79.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000158003677554243248120000016590650492613381308_)",
    d: "M325.25,79.27 c-2.3-0.3-4.41-0.87-6.25-1.65v2.63c3.07,2.57,8.14,4.25,13.88,4.25c4.76,0,9.03-1.16,12.12-3.02V75c0,2.76-5.82,5-13,5 C329.53,80,327.22,79.73,325.25,79.27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129202536748459341820000002141425620393676160_",
    gradientUnits: "userSpaceOnUse",
    x1: 319,
    y1: 91.5819,
    x2: 345,
    y2: 91.5819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1586,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000129202536748459341820000002141425620393676160_)",
    d: "M332.88,97.5c4.76,0,9.03-1.16,12.12-3.02 v-8.82c-2.25,3.97-8.61,6.84-16.12,6.84c-3.69,0-7.1-0.7-9.88-1.88v2.63C322.07,95.82,327.14,97.5,332.88,97.5z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127038187197607914400000001449172950090262149_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 130.875,
    x2: 256,
    y2: 102.043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58595B"
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000127038187197607914400000001449172950090262149_)",
    d: "M324.5,130.88c-3.99,0-7.96-0.28-11.81-0.83 c-21.92-1.48-39.93-2.17-56.69-2.17c-16.76,0-34.77,0.69-56.68,2.17c-3.86,0.55-7.83,0.83-11.82,0.83 c-26,0-46.38-10.71-46.38-24.38c0-1.49,0.25-2.98,0.74-4.46c3.14,4.52,9.7,7.58,17.22,8.01c-0.14,0.71-0.21,1.35-0.21,1.94 c0,7.92,9.28,14.12,21.12,14.12c8.89,0,16.6-3.52,19.7-8.98c3.76,4.37,10.58,6.98,18.3,6.98c8.89,0,16.6-3.52,19.7-8.98 c3.76,4.37,10.58,6.98,18.3,6.98s14.53-2.61,18.3-6.98c3.11,5.46,10.81,8.98,19.7,8.98c7.71,0,14.53-2.61,18.3-6.98 c3.11,5.46,10.81,8.98,19.7,8.98c11.85,0,21.12-6.2,21.12-14.12c0-0.59-0.07-1.23-0.21-1.94c7.53-0.43,14.09-3.49,17.22-8.01 c0.49,1.47,0.74,2.97,0.74,4.46C370.88,120.17,350.5,130.88,324.5,130.88z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M141.9,102.32c3.19,4.41,9.64,7.39,17.03,7.86c-0.13,0.66-0.19,1.26-0.19,1.83 c0,7.99,9.33,14.25,21.25,14.25c8.85,0,16.54-3.48,19.72-8.89c3.81,4.32,10.6,6.89,18.28,6.89c8.85,0,16.54-3.48,19.72-8.89 c3.81,4.32,10.6,6.89,18.28,6.89c7.67,0,14.47-2.57,18.28-6.89c3.18,5.41,10.87,8.89,19.72,8.89c7.67,0,14.47-2.57,18.28-6.89 c3.18,5.41,10.87,8.89,19.72,8.89c11.92,0,21.25-6.26,21.25-14.25c0-0.56-0.06-1.16-0.19-1.83c7.39-0.46,13.84-3.44,17.03-7.85 c0.43,1.38,0.65,2.79,0.65,4.18c0,13.6-20.32,24.25-46.25,24.25c-3.99,0-7.95-0.28-11.81-0.83c-21.91-1.48-39.92-2.17-56.69-2.17 s-34.78,0.69-56.71,2.17c-3.84,0.55-7.81,0.83-11.79,0.83c-25.93,0-46.25-10.65-46.25-24.25 C141.25,105.11,141.47,103.7,141.9,102.32 M141.83,101.77c-0.53,1.52-0.83,3.1-0.83,4.73c0,14.08,20.82,24.5,46.5,24.5 c4.09,0,8.05-0.29,11.83-0.84C217.66,128.93,236.6,128,256,128s38.34,0.93,56.67,2.16c3.78,0.54,7.74,0.84,11.83,0.84 c25.68,0,46.5-10.42,46.5-24.5c0-1.63-0.29-3.21-0.83-4.73c-3.02,4.55-9.53,7.76-17.41,8.18c0.14,0.68,0.24,1.36,0.24,2.06 c0,7.85-9.22,14-21,14c-9.16,0-16.75-3.73-19.68-9.07c-3.57,4.25-10.35,7.07-18.32,7.07c-9.16,0-16.75-3.73-19.68-9.07 c-3.57,4.25-10.35,7.07-18.32,7.07c-7.97,0-14.75-2.82-18.32-7.07c-2.93,5.34-10.53,9.07-19.68,9.07 c-7.97,0-14.75-2.82-18.32-7.07c-2.93,5.34-10.53,9.07-19.68,9.07c-11.78,0-21-6.15-21-14c0-0.7,0.1-1.38,0.24-2.06 C151.36,109.52,144.85,106.32,141.83,101.77L141.83,101.77z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027589928935724074380000002590560248259204521_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 142.875,
    x2: 256,
    y2: 113.124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58595B"
    }
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000027589928935724074380000002590560248259204521_)",
    d: "M324.5,142.88c-3.99,0-7.96-0.28-11.81-0.83 c-21.92-1.48-39.93-2.17-56.69-2.17s-34.77,0.69-56.68,2.17c-3.86,0.55-7.83,0.83-11.82,0.83c-26,0-46.38-10.71-46.38-24.38v-5.38 c2.41,12.53,21.91,22,46.38,22c4,0,7.99-0.28,11.85-0.84c21.9-1.48,39.9-2.16,56.65-2.16s34.76,0.69,56.66,2.16 c3.85,0.55,7.84,0.84,11.84,0.84c24.46,0,43.97-9.47,46.38-22v5.38C370.88,132.17,350.5,142.88,324.5,142.88z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M370.75,114.25v4.25c0,13.6-20.32,24.25-46.25,24.25c-3.98,0-7.95-0.28-11.81-0.83 c-21.91-1.48-39.92-2.17-56.69-2.17s-34.78,0.69-56.71,2.17c-3.84,0.55-7.81,0.83-11.79,0.83c-25.93,0-46.25-10.65-46.25-24.25 v-4.25c1.45,5.38,6.03,10.25,13.25,14c8.7,4.51,20.42,7,33,7c4.01,0,8-0.28,11.85-0.84c21.9-1.48,39.9-2.16,56.65-2.16 s34.75,0.69,56.63,2.16c3.86,0.56,7.86,0.84,11.87,0.84c12.58,0,24.3-2.48,33-7C364.72,124.51,369.3,119.63,370.75,114.25  M371,110.5c0,14.08-20.82,24.5-46.5,24.5c-4.09,0-8.05-0.29-11.83-0.84C294.34,132.93,275.4,132,256,132s-38.34,0.93-56.67,2.16 c-3.78,0.54-7.74,0.84-11.83,0.84c-25.68,0-46.5-10.42-46.5-24.5v8c0,14.08,20.82,24.5,46.5,24.5c4.09,0,8.05-0.29,11.83-0.84 C217.66,140.93,236.6,140,256,140s38.34,0.93,56.67,2.16c3.78,0.54,7.74,0.84,11.83,0.84c25.68,0,46.5-10.42,46.5-24.5V110.5 L371,110.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033341476204914664740000005968354425226368178_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.4634,
    y1: 269.8047,
    x2: 415.4634,
    y2: 266.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000033341476204914664740000005968354425226368178_)",
    d: "M410.99,269.8c1.34-0.7,2.6-1.53,3.74-2.48 c0.93-0.77,1.96-1.2,2.91-1.2h2.29C417.35,268.24,414.2,269.54,410.99,269.8z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M419.58,266.25c-2.34,1.84-5.11,3.01-7.97,3.37c1.14-0.64,2.21-1.37,3.2-2.2 c0.91-0.75,1.91-1.17,2.83-1.17H419.58 M420.29,266h-2.65c-0.97,0-2.04,0.44-2.99,1.23c-1.32,1.1-2.76,2.01-4.26,2.74 c3.61-0.16,7-1.57,9.71-3.82C420.16,266.1,420.23,266.05,420.29,266L420.29,266z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061442617843196755240000005257687366266968220_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.4667,
    y1: 263.875,
    x2: 464.4667,
    y2: 134.522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000061442617843196755240000005257687366266968220_)",
    d: "M454.49,263.88c3.19-2.18,5.29-5.7,5.64-9.5 l10.51-114c0.19-2.03-0.14-4.05-0.95-5.86c3.1,1.05,5.03,4.08,4.72,7.47l-10.51,114c-0.4,4.35-4.26,7.89-8.61,7.89H454.49z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M469.92,134.74c2.89,1.11,4.66,4.01,4.37,7.24l-10.51,114c-0.4,4.29-4.2,7.77-8.49,7.77h-0.4 c3.04-2.21,5.03-5.66,5.37-9.36l10.51-114C470.94,138.44,470.65,136.49,469.92,134.74 M469.45,134.32 c0.88,1.84,1.26,3.9,1.06,6.05l-10.51,114c-0.37,4.05-2.67,7.56-5.93,9.63h1.21c4.42,0,8.33-3.58,8.74-8l10.51-114 C474.87,138.35,472.7,135.28,469.45,134.32L469.45,134.32z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036968813072143109700000011114212540189480854_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.7373,
    y1: 238.875,
    x2: 411.7373,
    y2: 145.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58595B"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_00000036968813072143109700000011114212540189480854_)",
    points: "381.54,238.88 390.18,145.12  441.93,145.12 433.29,238.88  "
  })), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M441.8,145.25l-8.62,93.5h-51.5l8.62-93.5H441.8 M442.07,145h-52l-8.67,94h52L442.07,145L442.07,145z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005985007545211724630000001042436405067003789_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.9295,
    y1: 258.875,
    x2: 402.9295,
    y2: 251.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E47D91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3954,
    style: {
      stopColor: "#DD5D76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    style: {
      stopColor: "#D5586F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7821,
    style: {
      stopColor: "#C04B5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A63C46"
    }
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000005985007545211724630000001042436405067003789_)",
    d: "M402.56,258.88c-1.03,0-1.96-0.4-2.62-1.12 c-0.67-0.73-0.98-1.7-0.88-2.74c0.2-2.14,2.1-3.89,4.25-3.89c1.03,0,1.96,0.4,2.62,1.12c0.67,0.73,0.98,1.7,0.88,2.74 C406.61,257.13,404.7,258.88,402.56,258.88z"
  })), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A63C46",
    d: "M403.3,251.25c0.99,0,1.89,0.38,2.53,1.08c0.64,0.7,0.94,1.64,0.85,2.64c-0.19,2.08-2.04,3.77-4.12,3.77 c-0.99,0-1.89-0.38-2.53-1.08c-0.64-0.7-0.94-1.64-0.85-2.64C399.37,252.94,401.22,251.25,403.3,251.25 M403.3,251 c-2.21,0-4.17,1.79-4.37,4c-0.2,2.21,1.42,4,3.63,4c2.21,0,4.17-1.79,4.37-4C407.13,252.79,405.51,251,403.3,251L403.3,251z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005988134433872910130000015693712013720666793_",
    gradientUnits: "userSpaceOnUse",
    x1: 417.2765,
    y1: 267.875,
    x2: 417.2765,
    y2: 132.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000005988134433872910130000015693712013720666793_)",
    d: "M401.73,267.88c-3.67,0-7.06-1.35-9.57-3.81 c-1.44-1.41-3.3-2.19-5.24-2.19h-11.64c-2.09,0-3.99-0.81-5.34-2.29c-1.36-1.49-1.99-3.47-1.8-5.57l10.51-114 c0.4-4.35,4.26-7.89,8.61-7.89h72c2.09,0,3.99,0.81,5.34,2.29c1.36,1.49,2,3.47,1.8,5.57l-10.51,114 c-0.4,4.35-4.26,7.89-8.61,7.89h-29.64c-1.94,0-3.93,0.77-5.62,2.18C409.05,266.52,405.4,267.88,401.73,267.88z M403.67,246.88 c-4.47,0-8.45,3.64-8.86,8.11c-0.2,2.17,0.46,4.22,1.87,5.76c1.4,1.53,3.36,2.38,5.52,2.38c4.47,0,8.45-3.64,8.86-8.11 c0.2-2.18-0.46-4.22-1.87-5.76C407.79,247.72,405.83,246.88,403.67,246.88z M389.44,140.88c-1.72,0-3.24,1.4-3.4,3.11l-8.85,96 c-0.08,0.84,0.18,1.63,0.72,2.22c0.54,0.59,1.29,0.91,2.13,0.91h54c1.72,0,3.24-1.4,3.4-3.11l8.85-96 c0.08-0.84-0.18-1.63-0.72-2.22c-0.54-0.59-1.29-0.92-2.13-0.92H389.44z M448.88,222.88c-3.37,0-6.37,2.74-6.68,6.11 c-0.15,1.64,0.35,3.19,1.41,4.35c1.05,1.15,2.53,1.79,4.16,1.79c3.37,0,6.37-2.74,6.68-6.11c0.15-1.64-0.35-3.19-1.41-4.35 C451.99,223.51,450.51,222.88,448.88,222.88z M451.09,198.88c-1.17,0-2.2,0.95-2.31,2.11c-0.05,0.57,0.12,1.11,0.49,1.51 c0.37,0.4,0.88,0.62,1.45,0.62c1.17,0,2.2-0.95,2.31-2.11c0.05-0.57-0.12-1.11-0.49-1.51 C452.18,199.1,451.66,198.88,451.09,198.88z M455.46,194.88c-1.17,0-2.2,0.95-2.31,2.11c-0.05,0.57,0.12,1.11,0.49,1.51 c0.37,0.4,0.88,0.62,1.45,0.62c1.17,0,2.2-0.95,2.31-2.11c0.05-0.57-0.12-1.11-0.49-1.51 C456.54,195.1,456.03,194.88,455.46,194.88z M447.46,194.88c-1.17,0-2.2,0.95-2.31,2.11c-0.05,0.57,0.12,1.11,0.49,1.51 c0.37,0.4,0.88,0.62,1.45,0.62c1.17,0,2.2-0.95,2.31-2.11c0.05-0.57-0.12-1.11-0.49-1.51 C448.54,195.1,448.03,194.88,447.46,194.88z M451.83,190.88c-1.17,0-2.2,0.95-2.31,2.11c-0.05,0.57,0.12,1.11,0.49,1.51 c0.37,0.4,0.88,0.62,1.45,0.62c1.17,0,2.2-0.95,2.31-2.11c0.05-0.57-0.12-1.11-0.49-1.51 C452.91,191.1,452.4,190.88,451.83,190.88z"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M459.27,132.25c2.06,0,3.92,0.8,5.25,2.25c1.33,1.46,1.96,3.41,1.77,5.48l-10.51,114 c-0.4,4.29-4.2,7.77-8.49,7.77h-29.64c-1.97,0-3.99,0.78-5.7,2.21c-2.94,2.44-6.56,3.79-10.2,3.79c-3.63,0-7-1.34-9.48-3.78 c-1.46-1.43-3.35-2.22-5.32-2.22h-11.64c-2.06,0-3.92-0.8-5.25-2.25c-1.33-1.46-1.96-3.41-1.77-5.48l10.51-114 c0.4-4.29,4.2-7.77,8.49-7.77H459.27 M380.04,243.25h54c1.78,0,3.36-1.45,3.53-3.23l8.85-96c0.08-0.87-0.19-1.7-0.75-2.32 c-0.56-0.62-1.35-0.96-2.22-0.96h-54c-1.78,0-3.36,1.45-3.53,3.23l-8.85,96c-0.08,0.87,0.19,1.7,0.75,2.32 C378.38,242.91,379.17,243.25,380.04,243.25 M451.46,195.25c1.23,0,2.32-1,2.43-2.23c0.06-0.61-0.13-1.18-0.52-1.61 c-0.39-0.43-0.94-0.66-1.54-0.66c-1.23,0-2.32,1-2.43,2.23c-0.06,0.61,0.13,1.18,0.52,1.61 C450.31,195.01,450.86,195.25,451.46,195.25 M455.09,199.25c1.23,0,2.32-1,2.43-2.23c0.06-0.61-0.13-1.18-0.52-1.61 c-0.39-0.43-0.94-0.66-1.54-0.66c-1.23,0-2.32,1-2.43,2.23c-0.06,0.61,0.13,1.18,0.52,1.61 C453.94,199.01,454.49,199.25,455.09,199.25 M447.09,199.25c1.23,0,2.32-1,2.43-2.23c0.06-0.61-0.13-1.18-0.52-1.61 c-0.39-0.43-0.94-0.66-1.54-0.66c-1.23,0-2.32,1-2.43,2.23c-0.06,0.61,0.13,1.18,0.52,1.61 C445.94,199.01,446.49,199.25,447.09,199.25 M450.72,203.25c1.23,0,2.32-1,2.43-2.23c0.06-0.61-0.13-1.18-0.52-1.61 c-0.39-0.43-0.94-0.66-1.54-0.66c-1.23,0-2.32,1-2.43,2.23c-0.06,0.61,0.13,1.18,0.52,1.61 C449.57,203.01,450.12,203.25,450.72,203.25 M447.77,235.25c3.43,0,6.49-2.79,6.8-6.23c0.15-1.68-0.36-3.26-1.44-4.44 c-1.08-1.18-2.59-1.83-4.26-1.83c-3.43,0-6.49,2.79-6.8,6.23c-0.15,1.68,0.36,3.26,1.44,4.44 C444.59,234.6,446.1,235.25,447.77,235.25 M402.19,263.25c4.54,0,8.57-3.69,8.99-8.23c0.2-2.21-0.47-4.29-1.9-5.86 c-1.42-1.56-3.41-2.42-5.61-2.42c-4.54,0-8.57,3.69-8.99,8.23c-0.2,2.21,0.47,4.29,1.9,5.86 C398,262.39,399.99,263.25,402.19,263.25 M459.27,132h-72c-4.42,0-8.33,3.58-8.74,8l-10.51,114c-0.41,4.42,2.84,8,7.26,8h11.64 c1.99,0,3.79,0.82,5.15,2.15c2.43,2.39,5.8,3.85,9.65,3.85c3.85,0,7.49-1.46,10.36-3.85c1.6-1.33,3.55-2.15,5.54-2.15h29.64 c4.42,0,8.33-3.58,8.74-8l10.51-114C466.94,135.58,463.69,132,459.27,132L459.27,132z M380.04,243c-1.66,0-2.88-1.34-2.72-3 l8.85-96c0.15-1.66,1.62-3,3.28-3h54c1.66,0,2.88,1.34,2.72,3l-8.85,96c-0.15,1.66-1.62,3-3.28,3H380.04L380.04,243z M451.46,195 c-1.1,0-1.92-0.9-1.82-2c0.1-1.1,1.08-2,2.18-2s1.92,0.9,1.82,2C453.54,194.1,452.57,195,451.46,195L451.46,195z M455.09,199 c-1.1,0-1.92-0.9-1.82-2c0.1-1.1,1.08-2,2.18-2s1.92,0.9,1.82,2C457.17,198.1,456.2,199,455.09,199L455.09,199z M447.09,199 c-1.1,0-1.92-0.9-1.82-2c0.1-1.1,1.08-2,2.18-2s1.92,0.9,1.82,2C449.17,198.1,448.2,199,447.09,199L447.09,199z M450.72,203 c-1.1,0-1.92-0.9-1.82-2c0.1-1.1,1.08-2,2.18-2c1.1,0,1.92,0.9,1.82,2C452.81,202.1,451.83,203,450.72,203L450.72,203z  M447.77,235c-3.31,0-5.75-2.69-5.45-6c0.31-3.31,3.24-6,6.55-6s5.75,2.69,5.45,6C454.02,232.31,451.09,235,447.77,235 L447.77,235z M402.19,263c-4.41,0-7.67-3.59-7.26-8s4.33-8,8.74-8c4.41,0,7.67,3.59,7.26,8S406.6,263,402.19,263L402.19,263z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145753731908696824610000011591589086527793803_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 324,
    x2: 256,
    y2: 316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_00000145753731908696824610000011591589086527793803_)",
    stroke: "#999999",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    cx: 256,
    cy: 320,
    r: 4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124120137554200857220000004455497342091300761_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 376,
    x2: 256,
    y2: 308
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000124120137554200857220000004455497342091300761_)",
    stroke: "#999999",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: " M290.81,308h-18.43c0.71,1.2,1.12,2.59,1.12,4.08v11.67c0,8.41-6.84,15.25-15.25,15.25h-4.5c-8.41,0-15.25-6.84-15.25-15.25 v-11.67c0-1.49,0.41-2.88,1.12-4.08h-18.43c-2.31,0-4.19,1.87-4.19,4.19v24.47c0,1.27,0.6,2.43,1.56,3.26 c6.21,5.32,10.87,17.44,12.11,32.22c0.18,2.18,1.98,3.87,4.17,3.87h42.32c2.19,0,3.99-1.69,4.17-3.87 c1.24-14.78,5.9-26.9,12.11-32.22c0.96-0.82,1.56-1.99,1.56-3.26v-24.47C295,309.87,293.13,308,290.81,308z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMachine);
export default __webpack_public_path__ + "static/media/icon_machine.5fe83a3146e643d9c6b9c05eaf4fe711.svg";
export { ForwardRef as ReactComponent };